
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("iIet0", function(module, exports) {

$parcel$export(module.exports, "CardWithMediaClient", () => $2183b4e08d94d92e$export$91b1a6414631318a);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $iArlU = parcelRequire("iArlU");

var $1NgTd = parcelRequire("1NgTd");

var $ezsjX = parcelRequire("ezsjX");
const $2183b4e08d94d92e$export$91b1a6414631318a = (props)=>{
    const { dimensions: dimensions, onClick: onClick } = props;
    const Card = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useMemo(()=>{
        return (0, $iArlU.withMediaClient)((0, $ezsjX.Card));
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1NgTd.default), {
        dimensions: dimensions,
        onClick: onClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(Card, {
            ...props
        })
    });
};

});
parcelRegister("iArlU", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $104af301cec809a6$export$9f7977d4a2561bee);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");
const $104af301cec809a6$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        });

});

parcelRegister("1NgTd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3570d1bd275f02f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lMILl = parcelRequire("lMILl");

var $f72aH = parcelRequire("f72aH");

var $cb25w = parcelRequire("cb25w");

var $fJdkV = parcelRequire("fJdkV");
class $e3570d1bd275f02f$var$WrappedMediaCardAnalyticsErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props), this.fireOperationalEvent = (error, info)=>{
            const { data: data = {}, createAnalyticsEvent: createAnalyticsEvent } = this.props;
            const payload = {
                eventType: 'operational',
                action: 'failed',
                actionSubject: 'mediaCardRender',
                attributes: {
                    browserInfo: window?.navigator?.userAgent ? window.navigator.userAgent : 'unknown',
                    error: error,
                    info: info,
                    failReason: 'unexpected-error',
                    ...data
                }
            };
            (0, $fJdkV.fireMediaCardEvent)(payload, createAnalyticsEvent);
        }, this.handleOnClick = (event)=>{
            try {
                this.props.onClick?.({
                    event: event
                });
            } catch (e) {}
        };
        this.state = {
            hasError: false
        };
    }
    static{
        this.displayName = 'MediaCardAnalyticsErrorBoundary';
    }
    componentDidCatch(error, info) {
        try {
            this.fireOperationalEvent(error, info);
        } catch (e) {}
        this.setState({
            hasError: true
        });
    }
    render() {
        const { hasError: hasError } = this.state;
        const { dimensions: dimensions, children: children } = this.props;
        if (hasError) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $f72aH.UnhandledErrorCard), {
            dimensions: dimensions,
            onClick: this.handleOnClick
        });
        return children;
    }
}
const $e3570d1bd275f02f$var$packageName = "platform-pkg";
const $e3570d1bd275f02f$var$packageVersion = "0.0.0-use.local";
// @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
const $e3570d1bd275f02f$var$MediaCardAnalyticsErrorBoundary = (0, $lMILl.withMediaAnalyticsContext)({
    packageVersion: $e3570d1bd275f02f$var$packageVersion,
    packageName: $e3570d1bd275f02f$var$packageName,
    componentName: 'mediaCard',
    component: 'mediaCard'
})((0, $cb25w.default)()($e3570d1bd275f02f$var$WrappedMediaCardAnalyticsErrorBoundary));
var $e3570d1bd275f02f$export$2e2bcd8739ae039 = $e3570d1bd275f02f$var$MediaCardAnalyticsErrorBoundary;

});
parcelRegister("lMILl", function(module, exports) {

$parcel$export(module.exports, "withMediaAnalyticsContext", () => $2f883e77faff2ecd$export$ba0fb5f6ba6ce56c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

const $2f883e77faff2ecd$export$ba0fb5f6ba6ce56c = (contextPublicAttributes)=>(WrappedComponent)=>{
        // forwardRef() allows passing React refs to the wrapped component WithMediaAnalyticsContext
        const WithMediaAnalyticsContext = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
            const { featureFlags: featureFlags } = props;
            const contextData = (0, $5uXOq.useMemo)(()=>{
                const contextPrivateAttributes = {
                    featureFlags: featureFlags
                };
                return {
                    ...contextPublicAttributes,
                    [(0, $b276966247f2f12d$export$70df29c238ba7306)]: {
                        ...contextPrivateAttributes
                    }
                };
            }, [
                featureFlags
            ]);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
                data: contextData,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                    ...props,
                    ref: ref
                })
            });
        });
        WithMediaAnalyticsContext.displayName = `WithMediaAnalyticsContext(${// @ts-ignore displayName doesn't exist on type
        WrappedComponent.displayName || WrappedComponent.name})`;
        return WithMediaAnalyticsContext;
    };

});
// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx


parcelRegister("f72aH", function(module, exports) {

$parcel$export(module.exports, "UnhandledErrorCard", () => $193fe3f90fa74d87$export$b5dd0a6175f5992c);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $1XQjA = parcelRequire("1XQjA");

var $2LLWL = parcelRequire("2LLWL");
const $193fe3f90fa74d87$export$b5dd0a6175f5992c = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1XQjA.UnhandledErrorCard), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2LLWL.UnhandledErrorCard), {
        ...props
    });

});
parcelRegister("1XQjA", function(module, exports) {

$parcel$export(module.exports, "UnhandledErrorCard", () => $a0f05271fbd9cb86$export$b5dd0a6175f5992c);
/* unhandledErrorCard-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gb7Oz = parcelRequire("gb7Oz");


var $kwmmf = parcelRequire("kwmmf");

var $lGDbO = parcelRequire("lGDbO");
const $a0f05271fbd9cb86$var$isPercentage = (value)=>/^\d+(\.\d+)?%$/.test(value);
const $a0f05271fbd9cb86$var$shouldShowText = ({ width: width, height: height })=>{
    if ($a0f05271fbd9cb86$var$isPercentage(width) || $a0f05271fbd9cb86$var$isPercentage(height)) return false;
    return parseInt(width, 10) >= 240 && parseInt(height, 10) >= 90;
};
const $a0f05271fbd9cb86$var$normalizeDimension = (value, defaultValue)=>{
    const sValue = value.toString();
    return $a0f05271fbd9cb86$var$isPercentage(sValue) ? sValue : isNaN(parseInt(sValue, 10)) ? defaultValue + 'px' : parseInt(sValue, 10) + 'px';
};
const $a0f05271fbd9cb86$var$getConvertedDimension = (dimensions)=>{
    const { width: width = (0, $kwmmf.defaultImageCardDimensions).width, height: height = (0, $kwmmf.defaultImageCardDimensions).height } = dimensions;
    return {
        width: $a0f05271fbd9cb86$var$normalizeDimension(width, (0, $kwmmf.defaultImageCardDimensions).width),
        height: $a0f05271fbd9cb86$var$normalizeDimension(height, (0, $kwmmf.defaultImageCardDimensions).height)
    };
};
const $a0f05271fbd9cb86$var$wrapperStyle = null;
class $a0f05271fbd9cb86$export$b5dd0a6175f5992c extends (0, $5uXOq.Component) {
    render() {
        const { dimensions: dimensions = (0, $kwmmf.defaultImageCardDimensions), onClick: onClick } = this.props;
        const convertedDimensions = $a0f05271fbd9cb86$var$getConvertedDimension(dimensions);
        const hideText = !$a0f05271fbd9cb86$var$shouldShowText($a0f05271fbd9cb86$var$getConvertedDimension(dimensions));
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            style: convertedDimensions,
            onClick: onClick,
            className: (0, $bwpsq.default)([
                "_2rko1l7b _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1s4m _syaz1aqp _c71l1osq _p12f1osq _2lx21bp4 _1i7v2smr _31ku1h6o"
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gb7Oz))), {
                    label: "Error",
                    color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`,
                    LEGACY_size: "medium",
                    spacing: "spacious"
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lGDbO.ContentLoadingErrorMessage), {
                    isHidden: hideText
                })
            ]
        });
    }
}

});
parcelRegister("gb7Oz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77723dece3c67bedf7bcbbec84e5d004>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bc73bc3d72b7857d$var$_react = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bc73bc3d72b7857d$var$_warning = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("34Rrn")));

var $bc73bc3d72b7857d$var$_warning2 = $bc73bc3d72b7857d$var$_interopRequireDefault((parcelRequire("hD8l9")));
function $bc73bc3d72b7857d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bc73bc3d72b7857d$var$WarningIcon = (props)=>/*#__PURE__*/ $bc73bc3d72b7857d$var$_react.default.createElement($bc73bc3d72b7857d$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $bc73bc3d72b7857d$var$_warning2.default
    }, props));
$bc73bc3d72b7857d$var$WarningIcon.Name = 'WarningIconMigration';
var $bc73bc3d72b7857d$var$_default = module.exports.default = $bc73bc3d72b7857d$var$WarningIcon;

});
parcelRegister("hD8l9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd5c8c5b40614fc0$var$_react = $cd5c8c5b40614fc0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $cd5c8c5b40614fc0$var$_warning = $cd5c8c5b40614fc0$var$_interopRequireDefault((parcelRequire("34Rrn")));
function $cd5c8c5b40614fc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $cd5c8c5b40614fc0$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $cd5c8c5b40614fc0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $cd5c8c5b40614fc0$var$_warning.default
    }));
$cd5c8c5b40614fc0$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $cd5c8c5b40614fc0$var$_default = module.exports.default = $cd5c8c5b40614fc0$var$EditorWarningIcon;

});


var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("kwmmf", function(module, exports) {

$parcel$export(module.exports, "defaultImageCardDimensions", () => $f7806f30f9314468$export$d87a47989c00f322);
$parcel$export(module.exports, "getDefaultCardDimensions", () => $f7806f30f9314468$export$ed7b8a4728e9c63);
const $f7806f30f9314468$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $f7806f30f9314468$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $f7806f30f9314468$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $f7806f30f9314468$export$ed7b8a4728e9c63 = (appearance)=>{
    if (appearance === 'image') return $f7806f30f9314468$export$d87a47989c00f322;
    if (appearance === 'square') return $f7806f30f9314468$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $f7806f30f9314468$export$aeb48196afcd236a;
    return $f7806f30f9314468$export$d87a47989c00f322;
};

});

parcelRegister("lGDbO", function(module, exports) {

$parcel$export(module.exports, "ContentLoadingErrorMessage", () => $19684e4aca5739ab$export$86b6c8e2cf41b115);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
const $19684e4aca5739ab$export$86b6c8e2cf41b115 = ({ isHidden: isHidden })=>// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, $2OMIu.jsx)("p", {
        style: {
            display: isHidden ? 'none' : 'block'
        },
        children: "We couldn't load this content"
    });

});


parcelRegister("2LLWL", function(module, exports) {

$parcel$export(module.exports, "UnhandledErrorCard", () => $5ad5e575abe79479$export$b5dd0a6175f5992c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $gb7Oz = parcelRequire("gb7Oz");


var $9Kxjq = parcelRequire("9Kxjq");

var $kwmmf = parcelRequire("kwmmf");

var $lGDbO = parcelRequire("lGDbO");
const $5ad5e575abe79479$var$isPercentage = (value)=>/^\d+(\.\d+)?%$/.test(value);
const $5ad5e575abe79479$var$shouldShowText = ({ width: width, height: height })=>{
    if ($5ad5e575abe79479$var$isPercentage(width) || $5ad5e575abe79479$var$isPercentage(height)) return false;
    return parseInt(width, 10) >= 240 && parseInt(height, 10) >= 90;
};
const $5ad5e575abe79479$var$normalizeDimension = (value, defaultValue)=>{
    const sValue = value.toString();
    return $5ad5e575abe79479$var$isPercentage(sValue) ? sValue : isNaN(parseInt(sValue, 10)) ? defaultValue + 'px' : parseInt(sValue, 10) + 'px';
};
const $5ad5e575abe79479$var$getConvertedDimension = (dimensions)=>{
    const { width: width = (0, $kwmmf.defaultImageCardDimensions).width, height: height = (0, $kwmmf.defaultImageCardDimensions).height } = dimensions;
    return {
        width: $5ad5e575abe79479$var$normalizeDimension(width, (0, $kwmmf.defaultImageCardDimensions).width),
        height: $5ad5e575abe79479$var$normalizeDimension(height, (0, $kwmmf.defaultImageCardDimensions).height)
    };
};
const $5ad5e575abe79479$var$wrapperStyles = (dimensions = (0, $kwmmf.defaultImageCardDimensions))=>{
    try {
        return /*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $9Kxjq.center), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        (0, $9Kxjq.borderRadius), {
            background: `var(--ds-background-neutral, ${(0, $829f609a65d26a98$export$9fdfb749e33cdf97)})`,
            color: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
            maxHeight: '100%',
            maxWidth: '100%'
        }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        $5ad5e575abe79479$var$getConvertedDimension(dimensions), "display:flex;flex-direction:column;p{font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);text-align:center;}");
    } catch (e) {
        return null;
    }
};
class $5ad5e575abe79479$export$b5dd0a6175f5992c extends (0, $5uXOq.Component) {
    render() {
        const { dimensions: dimensions, onClick: onClick } = this.props;
        const isErrorHidden = !$5ad5e575abe79479$var$shouldShowText($5ad5e575abe79479$var$getConvertedDimension(dimensions ?? (0, $kwmmf.defaultImageCardDimensions)));
        return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlaskit/design-system/consistent-css-prop-usage, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $5ad5e575abe79479$var$wrapperStyles(dimensions),
            onClick: onClick
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gb7Oz))), {
            label: "Error",
            color: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`,
            LEGACY_size: "medium",
            spacing: "spacious"
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $lGDbO.ContentLoadingErrorMessage), {
            isHidden: isErrorHidden
        })));
    }
}

});


parcelRegister("fJdkV", function(module, exports) {

$parcel$export(module.exports, "getRenderSucceededEventPayload", () => $5ff489e336fa361f$export$4006df18b24ad838);
$parcel$export(module.exports, "getDownloadSucceededEventPayload", () => $5ff489e336fa361f$export$30f484b360b0efe8);
$parcel$export(module.exports, "getRenderErrorRequestMetadata", () => $5ff489e336fa361f$export$1a2ec9b4a3a99d5e);
$parcel$export(module.exports, "extractErrorInfo", () => $5ff489e336fa361f$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "getRenderErrorEventPayload", () => $5ff489e336fa361f$export$ea8620de23983ca1);
$parcel$export(module.exports, "getDownloadFailedEventPayload", () => $5ff489e336fa361f$export$bd721ce2bd18db4c);
$parcel$export(module.exports, "getErrorEventPayload", () => $5ff489e336fa361f$export$d3944464e6ecd3d4);
$parcel$export(module.exports, "getRenderFailedFileStatusPayload", () => $5ff489e336fa361f$export$116834b91a04bd49);
$parcel$export(module.exports, "fireMediaCardEvent", () => $5ff489e336fa361f$export$60729f3fb03dcecc);
$parcel$export(module.exports, "createAndFireMediaCardEvent", () => $5ff489e336fa361f$export$4d33ada3618f7626);

var $gFZHi = parcelRequire("gFZHi");

var $3I9M1 = parcelRequire("3I9M1");

var $gB4mS = parcelRequire("gB4mS");
const $5ff489e336fa361f$export$31786e85bf49987b = (metadata, fileStatus)=>({
        fileMediatype: metadata.mediaType,
        fileMimetype: metadata.mimeType,
        fileId: metadata.id,
        fileSize: metadata.size,
        fileStatus: fileStatus
    });
const $5ff489e336fa361f$export$4006df18b24ad838 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'success',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $5ff489e336fa361f$export$30f484b360b0efe8 = (fileAttributes, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'success',
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
const $5ff489e336fa361f$export$81661af638dd90bc = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'cache-hit',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $5ff489e336fa361f$export$62c7b749808f1b8f = (cardPreviewAttributes)=>({
        eventType: 'operational',
        action: 'Remote-success',
        actionSubject: 'mediaCardCache',
        attributes: {
            cardPreviewAttributes: cardPreviewAttributes
        }
    });
const $5ff489e336fa361f$export$c9d988402f74bba = (fileAttributes, performanceAttributes)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'external-uri'
        }
    });
const $5ff489e336fa361f$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $5ff489e336fa361f$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $5ff489e336fa361f$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError) && secondaryError.innerError?.message) return secondaryError.innerError?.message;
    if (secondaryError instanceof Error) return secondaryError.message;
    return error.message;
};
const $5ff489e336fa361f$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $5ff489e336fa361f$export$1a2ec9b4a3a99d5e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata;
};
const $5ff489e336fa361f$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $5ff489e336fa361f$export$4af9d71992e89714(error),
        error: $5ff489e336fa361f$export$88c61dcad53762da(error),
        errorDetail: $5ff489e336fa361f$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $5ff489e336fa361f$export$29aa614726672b2e(error)
    };
};
const $5ff489e336fa361f$export$ea8620de23983ca1 = (fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            ...$5ff489e336fa361f$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $5ff489e336fa361f$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext
        }
    });
const $5ff489e336fa361f$export$bd721ce2bd18db4c = (fileAttributes, error, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardDownload',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$5ff489e336fa361f$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $5ff489e336fa361f$export$1a2ec9b4a3a99d5e(error),
            traceContext: traceContext
        }
    });
const $5ff489e336fa361f$export$d3944464e6ecd3d4 = (cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'nonCriticalFail',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileAttributes: fileAttributes,
            status: 'fail',
            ...$5ff489e336fa361f$export$74aaf4784c2edb2c(error, metadataTraceContext),
            request: $5ff489e336fa361f$export$1a2ec9b4a3a99d5e(error),
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            cardStatus: cardStatus
        }
    });
const $5ff489e336fa361f$export$116834b91a04bd49 = (fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext)=>({
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCardRender',
        attributes: {
            fileMimetype: fileAttributes.fileMimetype,
            fileAttributes: fileAttributes,
            performanceAttributes: performanceAttributes,
            status: 'fail',
            failReason: 'failed-processing',
            ssrReliability: ssrReliability,
            traceContext: traceContext,
            metadataTraceContext: metadataTraceContext
        }
    });
function $5ff489e336fa361f$export$60729f3fb03dcecc(payload, createAnalyticsEvent) {
    if (createAnalyticsEvent) {
        const event = createAnalyticsEvent((0, $3I9M1.sanitiseAnalyticsPayload)(payload));
        event.fire((0, $6409754536c5152d$export$ec1779cb96554e1));
    }
}
const $5ff489e336fa361f$export$4d33ada3618f7626 = (payload)=>{
    return (0, $gB4mS.default)((0, $6409754536c5152d$export$ec1779cb96554e1))((0, $3I9M1.sanitiseAnalyticsPayload)(payload));
};

});
const $6409754536c5152d$export$ec1779cb96554e1 = 'media';

parcelRegister("3I9M1", function(module, exports) {

$parcel$export(module.exports, "sanitiseAnalyticsPayload", () => $23ddbf5f8f0f2d51$export$e24d38cbdf73bc1a);

var $6CZ6k = parcelRequire("6CZ6k");

var $86xFr = parcelRequire("86xFr");
const $23ddbf5f8f0f2d51$var$sanitiseFileId = (draft)=>{
    const { fileId: fileId } = draft.attributes.fileAttributes;
    draft.attributes.fileAttributes.fileId = fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(fileId) ? fileId : 'INVALID_FILE_ID';
};
const $23ddbf5f8f0f2d51$var$hasFileAttributesWithFileId = (payload)=>'attributes' in payload && !!payload.attributes && typeof payload.attributes === 'object' && 'fileAttributes' in payload.attributes && !!payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes === 'object' && 'fileId' in payload.attributes.fileAttributes && typeof payload.attributes.fileAttributes.fileId === 'string';
const $23ddbf5f8f0f2d51$export$e24d38cbdf73bc1a = (payload)=>$23ddbf5f8f0f2d51$var$hasFileAttributesWithFileId(payload) ? (0, $86xFr.produce)(payload, $23ddbf5f8f0f2d51$var$sanitiseFileId) : payload;

});



parcelRegister("ezsjX", function(module, exports) {

$parcel$export(module.exports, "Card", () => $90b800a3bb81641d$export$60332b2344f7fe41);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7qjGu = parcelRequire("7qjGu");

var $lMILl = parcelRequire("lMILl");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $7o6JR = parcelRequire("7o6JR");

var $cqXs3 = parcelRequire("cqXs3");

var $2ucn9 = parcelRequire("2ucn9");

var $2NMNM = parcelRequire("2NMNM");

var $3aXpE = parcelRequire("3aXpE");
const $90b800a3bb81641d$var$packageName = "platform-pkg";
const $90b800a3bb81641d$var$packageVersion = "0.0.0-use.local";
const $90b800a3bb81641d$export$7a6ccaf429ad93a8 = ({ identifier: identifier, ...otherProps })=>{
    const innerContent = (0, $7qjGu.isFileIdentifier)(identifier) ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3aXpE.default), {
        name: "media-card-file-card",
        children: /*#__PURE__*/ (0, $5uXOq.createElement)((0, $cqXs3.FileCard), {
            ...otherProps,
            identifier: identifier,
            key: identifier.id
        })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3aXpE.default), {
        name: "media-card-external-image",
        children: /*#__PURE__*/ (0, $5uXOq.createElement)((0, $7o6JR.ExternalImageCard), {
            ...otherProps,
            identifier: identifier,
            key: identifier.dataURI
        })
    });
    return otherProps.intl ? innerContent : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: innerContent
    });
};
const $90b800a3bb81641d$export$ec84c9f4597a734b = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $2ucn9.startResourceObserver)();
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        (0, $2ucn9.setAnalyticsContext)(createAnalyticsEvent);
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($90b800a3bb81641d$export$7a6ccaf429ad93a8, {
        ...props
    });
};
const $90b800a3bb81641d$export$60332b2344f7fe41 = (0, $lMILl.withMediaAnalyticsContext)({
    packageVersion: $90b800a3bb81641d$var$packageVersion,
    packageName: $90b800a3bb81641d$var$packageName,
    componentName: 'mediaCard',
    component: 'mediaCard'
})((0, $8RXs9.default)($90b800a3bb81641d$export$ec84c9f4597a734b, {
    enforceContext: false
}));

});
parcelRegister("7qjGu", function(module, exports) {

$parcel$export(module.exports, "isFileIdentifier", () => $a9dd7b2499b5385d$export$7695387cd66cf5b5);
$parcel$export(module.exports, "isExternalImageIdentifier", () => $a9dd7b2499b5385d$export$2782f2fbff82f0c9);

var $6SBvm = parcelRequire("6SBvm");
const $a9dd7b2499b5385d$export$7695387cd66cf5b5 = (identifier)=>{
    return identifier.mediaItemType === 'file';
};
const $a9dd7b2499b5385d$export$2782f2fbff82f0c9 = (identifier)=>{
    return identifier.mediaItemType === 'external-image';
};
const $a9dd7b2499b5385d$export$5883721593c4e4b1 = (a, b)=>{
    if ($a9dd7b2499b5385d$export$7695387cd66cf5b5(a) && $a9dd7b2499b5385d$export$7695387cd66cf5b5(b)) return a.id !== b.id || a.collectionName !== b.collectionName || a.occurrenceKey !== b.occurrenceKey;
    else return !(0, (/*@__PURE__*/$parcel$interopDefault($6SBvm)))(a, b);
};

});
parcelRegister("6SBvm", function(module, exports) {

var $dZMWQ = parcelRequire("dZMWQ");

var $eyPxb = parcelRequire("eyPxb");

var $joK88 = parcelRequire("joK88");

var $2jaDc = parcelRequire("2jaDc");

var $kjdG6 = parcelRequire("kjdG6");

var $6Fkfb = parcelRequire("6Fkfb");
var $5024e0e3cc4aeda1$var$getTime = Date.prototype.getTime;
function $5024e0e3cc4aeda1$var$deepEqual(actual, expected, options) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $joK88(actual, expected) : actual === expected) return true;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') return opts.strict ? $joK88(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return $5024e0e3cc4aeda1$var$objEquiv(actual, expected, opts);
}
function $5024e0e3cc4aeda1$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $5024e0e3cc4aeda1$var$isBuffer(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $5024e0e3cc4aeda1$var$objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if (typeof a !== typeof b) return false;
    if ($5024e0e3cc4aeda1$var$isUndefinedOrNull(a) || $5024e0e3cc4aeda1$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if ($eyPxb(a) !== $eyPxb(b)) return false;
    var aIsRegex = $2jaDc(a);
    var bIsRegex = $2jaDc(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && $kjdG6(a) === $kjdG6(b);
    if ($6Fkfb(a) && $6Fkfb(b)) return $5024e0e3cc4aeda1$var$getTime.call(a) === $5024e0e3cc4aeda1$var$getTime.call(b);
    var aIsBuffer = $5024e0e3cc4aeda1$var$isBuffer(a);
    var bIsBuffer = $5024e0e3cc4aeda1$var$isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    try {
        var ka = $dZMWQ(a);
        var kb = $dZMWQ(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$5024e0e3cc4aeda1$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
module.exports = $5024e0e3cc4aeda1$var$deepEqual;

});
parcelRegister("dZMWQ", function(module, exports) {
'use strict';
var $a306f0f1bb5f232a$var$slice = Array.prototype.slice;

var $1Houy = parcelRequire("1Houy");
var $a306f0f1bb5f232a$var$origKeys = Object.keys;

var $a306f0f1bb5f232a$var$keysShim = $a306f0f1bb5f232a$var$origKeys ? function keys(o) {
    return $a306f0f1bb5f232a$var$origKeys(o);
} : (parcelRequire("eQVXL"));
var $a306f0f1bb5f232a$var$originalKeys = Object.keys;
$a306f0f1bb5f232a$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($1Houy(object)) return $a306f0f1bb5f232a$var$originalKeys($a306f0f1bb5f232a$var$slice.call(object));
            return $a306f0f1bb5f232a$var$originalKeys(object);
        };
    } else Object.keys = $a306f0f1bb5f232a$var$keysShim;
    return Object.keys || $a306f0f1bb5f232a$var$keysShim;
};
module.exports = $a306f0f1bb5f232a$var$keysShim;

});
parcelRegister("1Houy", function(module, exports) {
'use strict';
var $13ccce2fa6936c75$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $13ccce2fa6936c75$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $13ccce2fa6936c75$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("eQVXL", function(module, exports) {
'use strict';
var $ad02e23a59d3730f$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $ad02e23a59d3730f$var$has = Object.prototype.hasOwnProperty;
    var $ad02e23a59d3730f$var$toStr = Object.prototype.toString;
    var $ad02e23a59d3730f$var$isArgs = (parcelRequire("1Houy")); // eslint-disable-line global-require
    var $ad02e23a59d3730f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $ad02e23a59d3730f$var$hasDontEnumBug = !$ad02e23a59d3730f$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $ad02e23a59d3730f$var$hasProtoEnumBug = $ad02e23a59d3730f$var$isEnumerable.call(function() {}, 'prototype');
    var $ad02e23a59d3730f$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $ad02e23a59d3730f$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $ad02e23a59d3730f$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $ad02e23a59d3730f$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$ad02e23a59d3730f$var$excludedKeys['$' + k] && $ad02e23a59d3730f$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $ad02e23a59d3730f$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$ad02e23a59d3730f$var$hasAutomationEqualityBug) return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
        try {
            return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $ad02e23a59d3730f$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $ad02e23a59d3730f$var$toStr.call(object) === '[object Function]';
        var isArguments = $ad02e23a59d3730f$var$isArgs(object);
        var isString = isObject && $ad02e23a59d3730f$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $ad02e23a59d3730f$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$ad02e23a59d3730f$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $ad02e23a59d3730f$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($ad02e23a59d3730f$var$hasDontEnumBug) {
            var skipConstructor = $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $ad02e23a59d3730f$var$dontEnums.length; ++k)if (!(skipConstructor && $ad02e23a59d3730f$var$dontEnums[k] === 'constructor') && $ad02e23a59d3730f$var$has.call(object, $ad02e23a59d3730f$var$dontEnums[k])) theKeys.push($ad02e23a59d3730f$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $ad02e23a59d3730f$var$keysShim;

});


parcelRegister("eyPxb", function(module, exports) {
'use strict';

var $a99c3747cd09063d$var$hasToStringTag = (parcelRequire("fmBzB"))();

var $53KqO = parcelRequire("53KqO");
var $a99c3747cd09063d$var$$toString = $53KqO('Object.prototype.toString');
var $a99c3747cd09063d$var$isStandardArguments = function isArguments(value) {
    if ($a99c3747cd09063d$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $a99c3747cd09063d$var$$toString(value) === '[object Arguments]';
};
var $a99c3747cd09063d$var$isLegacyArguments = function isArguments(value) {
    if ($a99c3747cd09063d$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $a99c3747cd09063d$var$$toString(value) !== '[object Array]' && $a99c3747cd09063d$var$$toString(value.callee) === '[object Function]';
};
var $a99c3747cd09063d$var$supportsStandardArguments = function() {
    return $a99c3747cd09063d$var$isStandardArguments(arguments);
}();
$a99c3747cd09063d$var$isStandardArguments.isLegacyArguments = $a99c3747cd09063d$var$isLegacyArguments; // for tests
module.exports = $a99c3747cd09063d$var$supportsStandardArguments ? $a99c3747cd09063d$var$isStandardArguments : $a99c3747cd09063d$var$isLegacyArguments;

});
parcelRegister("fmBzB", function(module, exports) {
'use strict';

var $9T9x9 = parcelRequire("9T9x9");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $9T9x9() && !!Symbol.toStringTag;
};

});

parcelRegister("53KqO", function(module, exports) {
'use strict';

var $iPtqy = parcelRequire("iPtqy");

var $h05ZS = parcelRequire("h05ZS");
var $3af13fe1c3fdd190$var$$indexOf = $h05ZS($iPtqy('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $iPtqy(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $3af13fe1c3fdd190$var$$indexOf(name, '.prototype.') > -1) return $h05ZS(intrinsic);
    return intrinsic;
};

});
parcelRegister("h05ZS", function(module, exports) {
'use strict';

var $6ElEw = parcelRequire("6ElEw");

var $7Th0d = parcelRequire("7Th0d");

var $h08zB = parcelRequire("h08zB");

var $ghZDY = parcelRequire("ghZDY");
module.exports = function callBind(originalFunction) {
    var func = $h08zB(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $6ElEw(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($7Th0d) $7Th0d(module.exports, 'apply', {
    value: $ghZDY
});
else module.exports.apply = $ghZDY;

});
parcelRegister("6ElEw", function(module, exports) {
'use strict';

var $iPtqy = parcelRequire("iPtqy");

var $le88V = parcelRequire("le88V");

var $4d77463b7ea9d419$var$hasDescriptors = (parcelRequire("9lmlE"))();

var $lBvcQ = parcelRequire("lBvcQ");

var $kQfBa = parcelRequire("kQfBa");
var $4d77463b7ea9d419$var$$floor = $iPtqy('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $kQfBa('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $4d77463b7ea9d419$var$$floor(length) !== length) throw new $kQfBa('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $lBvcQ) {
        var desc = $lBvcQ(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($4d77463b7ea9d419$var$hasDescriptors) $le88V(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $le88V(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("le88V", function(module, exports) {
'use strict';

var $7Th0d = parcelRequire("7Th0d");

var $6ZTEL = parcelRequire("6ZTEL");

var $kQfBa = parcelRequire("kQfBa");

var $lBvcQ = parcelRequire("lBvcQ");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $kQfBa('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $kQfBa('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $kQfBa('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $kQfBa('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $kQfBa('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $kQfBa('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$lBvcQ && $lBvcQ(obj, property);
    if ($7Th0d) $7Th0d(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $6ZTEL('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("9lmlE", function(module, exports) {
'use strict';

var $7Th0d = parcelRequire("7Th0d");
var $6cd7691e5358e89c$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$7Th0d;
};
$6cd7691e5358e89c$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$7Th0d) return null;
    try {
        return $7Th0d([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $6cd7691e5358e89c$var$hasPropertyDescriptors;

});


parcelRegister("ghZDY", function(module, exports) {
'use strict';

var $g2Z6Y = parcelRequire("g2Z6Y");

var $iJCdB = parcelRequire("iJCdB");

var $4XlJF = parcelRequire("4XlJF");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $4XlJF($g2Z6Y, $iJCdB, arguments);
};

});




parcelRegister("joK88", function(module, exports) {
'use strict';

var $d94D2 = parcelRequire("d94D2");

var $h05ZS = parcelRequire("h05ZS");

var $iwNFM = parcelRequire("iwNFM");

var $eJazH = parcelRequire("eJazH");

var $90RaO = parcelRequire("90RaO");
var $e1f40ab7009ea590$var$polyfill = $h05ZS($eJazH(), Object);
$d94D2($e1f40ab7009ea590$var$polyfill, {
    getPolyfill: $eJazH,
    implementation: $iwNFM,
    shim: $90RaO
});
module.exports = $e1f40ab7009ea590$var$polyfill;

});
parcelRegister("d94D2", function(module, exports) {
'use strict';

var $dZMWQ = parcelRequire("dZMWQ");
var $991fb4ca00f3da54$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $991fb4ca00f3da54$var$toStr = Object.prototype.toString;
var $991fb4ca00f3da54$var$concat = Array.prototype.concat;

var $le88V = parcelRequire("le88V");
var $991fb4ca00f3da54$var$isFunction = function(fn) {
    return typeof fn === 'function' && $991fb4ca00f3da54$var$toStr.call(fn) === '[object Function]';
};

var $991fb4ca00f3da54$var$supportsDescriptors = (parcelRequire("9lmlE"))();
var $991fb4ca00f3da54$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$991fb4ca00f3da54$var$isFunction(predicate) || !predicate()) return;
    }
    if ($991fb4ca00f3da54$var$supportsDescriptors) $le88V(object, name, value, true);
    else $le88V(object, name, value);
};
var $991fb4ca00f3da54$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $dZMWQ(map);
    if ($991fb4ca00f3da54$var$hasSymbols) props = $991fb4ca00f3da54$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$991fb4ca00f3da54$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$991fb4ca00f3da54$var$defineProperties.supportsDescriptors = !!$991fb4ca00f3da54$var$supportsDescriptors;
module.exports = $991fb4ca00f3da54$var$defineProperties;

});

parcelRegister("iwNFM", function(module, exports) {
'use strict';
var $d7d1bf25ec690182$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($d7d1bf25ec690182$var$numberIsNaN(a) && $d7d1bf25ec690182$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("eJazH", function(module, exports) {
'use strict';

var $iwNFM = parcelRequire("iwNFM");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $iwNFM;
};

});

parcelRegister("90RaO", function(module, exports) {
'use strict';

var $eJazH = parcelRequire("eJazH");

var $d94D2 = parcelRequire("d94D2");
module.exports = function shimObjectIs() {
    var polyfill = $eJazH();
    $d94D2(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("2jaDc", function(module, exports) {
'use strict';

var $3T2jo = parcelRequire("3T2jo");

var $1ae59a456e400bfc$var$hasToStringTag = (parcelRequire("fmBzB"))();

var $kO8H7 = parcelRequire("kO8H7");

var $lBvcQ = parcelRequire("lBvcQ");
/** @type {import('.')} */ var $1ae59a456e400bfc$var$fn;
if ($1ae59a456e400bfc$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $1ae59a456e400bfc$var$$exec = $3T2jo('RegExp.prototype.exec');
    /** @type {object} */ var $1ae59a456e400bfc$var$isRegexMarker = {};
    var $1ae59a456e400bfc$var$throwRegexMarker = function() {
        throw $1ae59a456e400bfc$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $1ae59a456e400bfc$var$badStringifier = {
        toString: $1ae59a456e400bfc$var$throwRegexMarker,
        valueOf: $1ae59a456e400bfc$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $1ae59a456e400bfc$var$badStringifier[Symbol.toPrimitive] = $1ae59a456e400bfc$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $1ae59a456e400bfc$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $lBvcQ(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $kO8H7(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $1ae59a456e400bfc$var$$exec(value, /** @type {unknown} */ $1ae59a456e400bfc$var$badStringifier);
        } catch (e) {
            return e === $1ae59a456e400bfc$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $1ae59a456e400bfc$var$$toString = $3T2jo('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $1ae59a456e400bfc$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $1ae59a456e400bfc$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $1ae59a456e400bfc$var$$toString(value) === $1ae59a456e400bfc$var$regexClass;
    };
}
module.exports = $1ae59a456e400bfc$var$fn;

});

parcelRegister("kjdG6", function(module, exports) {
'use strict';

var $d94D2 = parcelRequire("d94D2");

var $h05ZS = parcelRequire("h05ZS");

var $ckZYs = parcelRequire("ckZYs");

var $1kOo9 = parcelRequire("1kOo9");

var $jvGc4 = parcelRequire("jvGc4");
var $ec90312fceb278a3$var$flagsBound = $h05ZS($1kOo9());
$d94D2($ec90312fceb278a3$var$flagsBound, {
    getPolyfill: $1kOo9,
    implementation: $ckZYs,
    shim: $jvGc4
});
module.exports = $ec90312fceb278a3$var$flagsBound;

});
parcelRegister("ckZYs", function(module, exports) {
'use strict';

var $6vStt = parcelRequire("6vStt");

var $kQfBa = parcelRequire("kQfBa");
var $8fb76d112b6eea5e$var$$Object = Object;
module.exports = $6vStt(function flags() {
    if (this == null || this !== $8fb76d112b6eea5e$var$$Object(this)) throw new $kQfBa('RegExp.prototype.flags getter called on non-object');
    var result = '';
    if (this.hasIndices) result += 'd';
    if (this.global) result += 'g';
    if (this.ignoreCase) result += 'i';
    if (this.multiline) result += 'm';
    if (this.dotAll) result += 's';
    if (this.unicode) result += 'u';
    if (this.unicodeSets) result += 'v';
    if (this.sticky) result += 'y';
    return result;
}, 'get flags', true);

});
parcelRegister("6vStt", function(module, exports) {
'use strict';

var $le88V = parcelRequire("le88V");

var $4bdfe4c785c362d4$var$hasDescriptors = (parcelRequire("9lmlE"))();

var $4bdfe4c785c362d4$var$functionsHaveConfigurableNames = (parcelRequire("9x3DX")).functionsHaveConfigurableNames();

var $kQfBa = parcelRequire("kQfBa");
/** @type {import('.')} */ module.exports = function setFunctionName(fn, name) {
    if (typeof fn !== 'function') throw new $kQfBa('`fn` is not a function');
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || $4bdfe4c785c362d4$var$functionsHaveConfigurableNames) {
        if ($4bdfe4c785c362d4$var$hasDescriptors) $le88V(/** @type {Parameters<define>[0]} */ fn, 'name', name, true, true);
        else $le88V(/** @type {Parameters<define>[0]} */ fn, 'name', name);
    }
    return fn;
};

});
parcelRegister("9x3DX", function(module, exports) {
'use strict';
var $6f0a05a05756bb65$var$functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === 'string';
};
var $6f0a05a05756bb65$var$gOPD = Object.getOwnPropertyDescriptor;
if ($6f0a05a05756bb65$var$gOPD) try {
    $6f0a05a05756bb65$var$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $6f0a05a05756bb65$var$gOPD = null;
}
$6f0a05a05756bb65$var$functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!$6f0a05a05756bb65$var$functionsHaveNames() || !$6f0a05a05756bb65$var$gOPD) return false;
    var desc = $6f0a05a05756bb65$var$gOPD(function() {}, 'name');
    return !!desc && !!desc.configurable;
};
var $6f0a05a05756bb65$var$$bind = Function.prototype.bind;
$6f0a05a05756bb65$var$functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return $6f0a05a05756bb65$var$functionsHaveNames() && typeof $6f0a05a05756bb65$var$$bind === 'function' && (function f() {}).bind().name !== '';
};
module.exports = $6f0a05a05756bb65$var$functionsHaveNames;

});



parcelRegister("1kOo9", function(module, exports) {
'use strict';

var $ckZYs = parcelRequire("ckZYs");

var $d94D2 = parcelRequire("d94D2");
var $0f8ebecd0b3aa0aa$require$supportsDescriptors = $d94D2.supportsDescriptors;
var $0f8ebecd0b3aa0aa$var$$gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
    if ($0f8ebecd0b3aa0aa$require$supportsDescriptors && /a/mig.flags === 'gim') {
        var descriptor = $0f8ebecd0b3aa0aa$var$$gOPD(RegExp.prototype, 'flags');
        if (descriptor && typeof descriptor.get === 'function' && 'dotAll' in RegExp.prototype && 'hasIndices' in RegExp.prototype) {
            /* eslint getter-return: 0 */ var calls = '';
            var o = {};
            Object.defineProperty(o, 'hasIndices', {
                get: function() {
                    calls += 'd';
                }
            });
            Object.defineProperty(o, 'sticky', {
                get: function() {
                    calls += 'y';
                }
            });
            descriptor.get.call(o);
            if (calls === 'dy') return descriptor.get;
        }
    }
    return $ckZYs;
};

});

parcelRegister("jvGc4", function(module, exports) {
'use strict';

var $d94D2 = parcelRequire("d94D2");
var $e341a45c8a08c1ee$require$supportsDescriptors = $d94D2.supportsDescriptors;

var $1kOo9 = parcelRequire("1kOo9");

var $lBvcQ = parcelRequire("lBvcQ");
var $e341a45c8a08c1ee$var$defineProperty = Object.defineProperty;

var $6GVaQ = parcelRequire("6GVaQ");

var $863dK = parcelRequire("863dK");
var $e341a45c8a08c1ee$var$regex = /a/;
module.exports = function shimFlags() {
    if (!$e341a45c8a08c1ee$require$supportsDescriptors || !$863dK) throw new $6GVaQ('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    var polyfill = $1kOo9();
    var proto = $863dK($e341a45c8a08c1ee$var$regex);
    var descriptor = $lBvcQ(proto, 'flags');
    if (!descriptor || descriptor.get !== polyfill) $e341a45c8a08c1ee$var$defineProperty(proto, 'flags', {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};

});


parcelRegister("6Fkfb", function(module, exports) {
'use strict';

var $3T2jo = parcelRequire("3T2jo");
var $4da6466ec2c71190$var$getDay = $3T2jo('Date.prototype.getDay');
/** @type {import('.')} */ var $4da6466ec2c71190$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $4da6466ec2c71190$var$getDay(value);
        return true;
    } catch (e) {
        return false;
    }
};
/** @type {(value: unknown) => string} */ var $4da6466ec2c71190$var$toStr = $3T2jo('Object.prototype.toString');
var $4da6466ec2c71190$var$dateClass = '[object Date]';

var $4da6466ec2c71190$var$hasToStringTag = (parcelRequire("fmBzB"))();
/** @type {import('.')} */ module.exports = function isDateObject(value) {
    if (typeof value !== 'object' || value === null) return false;
    return $4da6466ec2c71190$var$hasToStringTag ? $4da6466ec2c71190$var$tryDateObject(value) : $4da6466ec2c71190$var$toStr(value) === $4da6466ec2c71190$var$dateClass;
};

});



parcelRegister("7o6JR", function(module, exports) {

$parcel$export(module.exports, "ExternalImageCard", () => $343fa04fd22b7788$export$b7c988f139757a90);

var $2OMIu = parcelRequire("2OMIu");

var $2NMNM = parcelRequire("2NMNM");

var $bfb59 = parcelRequire("bfb59");

var $27T0s = parcelRequire("27T0s");

var $6ZIFT = parcelRequire("6ZIFT");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $avBrk = parcelRequire("avBrk");

var $c3l1i = parcelRequire("c3l1i");

var $hOlel = parcelRequire("hOlel");

var $kNDBv = parcelRequire("kNDBv");

var $dnnKy = parcelRequire("dnnKy");

var $kwmmf = parcelRequire("kwmmf");

var $klfbI = parcelRequire("klfbI");

var $dyIlI = parcelRequire("dyIlI");

var $ajqQB = parcelRequire("ajqQB");

var $9yjd0 = parcelRequire("9yjd0");
const $343fa04fd22b7788$export$b7c988f139757a90 = ({ mediaClient: mediaClient, appearance: appearance = 'auto', resizeMode: resizeMode = 'crop', disableOverlay: disableOverlay = false, featureFlags: // Media Feature Flag defaults are defined in @atlaskit/media-common
featureFlags = {}, identifier: identifier, dimensions: dimensions, contextId: contextId, alt: alt, actions: actions, shouldOpenMediaViewer: shouldOpenMediaViewer, selectable: selectable, selected: selected, testId: testId, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, shouldHideTooltip: shouldHideTooltip, mediaViewerItems: mediaViewerItems, onClick: onClick, onMouseEnter: onMouseEnter })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cardDimensions = dimensions || (0, $kwmmf.getDefaultCardDimensions)(appearance);
    const internalOccurrenceKey = (0, $5uXOq.useMemo)(()=>(0, $c3l1i.generateUniqueId)(), []);
    const timeElapsedTillCommenced = (0, $5uXOq.useMemo)(()=>(0, $9yjd0.performanceNow)(), []);
    // Generate unique traceId for file
    const traceContext = (0, $5uXOq.useMemo)(()=>({
            traceId: (0, $27T0s.getRandomHex)(8)
        }), []);
    const fileStateFlagsRef = (0, $5uXOq.useRef)({
        wasStatusUploading: false,
        wasStatusProcessing: false
    });
    const startUfoExperienceRef = (0, $dnnKy.useCurrentValueRef)(()=>{
        if (shouldSendPerformanceEventRef.current) (0, $kNDBv.startUfoExperience)(internalOccurrenceKey);
    });
    const [status, setStatus] = (0, $5uXOq.useState)('loading-preview');
    const cardPreview = (0, $5uXOq.useMemo)(()=>({
            dataURI: identifier.dataURI,
            orientation: 1,
            source: 'external'
        }), [
        identifier.dataURI
    ]);
    const metadata = {
        id: identifier.mediaItemType,
        name: identifier.name || identifier.dataURI,
        mediaType: 'image'
    };
    const fileAttributes = {
        fileMediatype: 'image',
        fileId: metadata.id
    };
    // for analytics
    const ssrReliability = {
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    };
    const [previewDidRender, setPreviewDidRender] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)();
    const [mediaViewerSelectedItem, setMediaViewerSelectedItem] = (0, $5uXOq.useState)(null);
    const shouldSendPerformanceEventRef = (0, $5uXOq.useRef)((0, $kNDBv.shouldPerformanceBeSampled)());
    //----------------------------------------------------------------//
    //---------------------- Analytics  ------------------------------//
    //----------------------------------------------------------------//
    const fireOperationalEventRef = (0, $dnnKy.useCurrentValueRef)(()=>{
        const timeElapsedTillEvent = (0, $9yjd0.performanceNow)();
        const durationSinceCommenced = timeElapsedTillEvent - timeElapsedTillCommenced;
        const performanceAttributes = {
            overall: {
                durationSincePageStart: timeElapsedTillEvent,
                durationSinceCommenced: durationSinceCommenced
            }
        };
        createAnalyticsEvent && (0, $dyIlI.fireOperationalEvent)(createAnalyticsEvent, status, fileAttributes, performanceAttributes, ssrReliability, error, traceContext, undefined);
        shouldSendPerformanceEventRef.current && (0, $kNDBv.completeUfoExperience)(internalOccurrenceKey, status, fileAttributes, fileStateFlagsRef.current, ssrReliability, error);
    });
    const fireAbortedEventRef = (0, $dnnKy.useCurrentValueRef)(()=>{
        // UFO won't abort if it's already in a final state (succeeded, failed, aborted, etc)
        if (shouldSendPerformanceEventRef.current) (0, $kNDBv.abortUfoExperience)(internalOccurrenceKey, {
            fileAttributes: fileAttributes,
            fileStateFlags: fileStateFlagsRef?.current,
            ssrReliability: ssrReliability
        });
    });
    //----------------------------------------------------------------//
    //------------------------ useEffects ----------------------------//
    //----------------------------------------------------------------//
    (0, $5uXOq.useEffect)(()=>{
        startUfoExperienceRef.current();
    }, [
        startUfoExperienceRef
    ]);
    const prevStatus = (0, $klfbI.usePrevious)(status);
    (0, $5uXOq.useEffect)(()=>{
        if (prevStatus !== undefined && status !== prevStatus) fireOperationalEventRef.current();
    }, [
        fireOperationalEventRef,
        prevStatus,
        status
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (previewDidRender && status === 'loading-preview') setStatus('complete');
    }, [
        previewDidRender,
        status
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            fireAbortedEventRef.current();
        };
    }, [
        fireAbortedEventRef
    ]);
    //----------------------------------------------------------------//
    //---------------------- Render Functions ------------------------//
    //----------------------------------------------------------------//
    const renderMediaViewer = ()=>{
        if (!mediaViewerSelectedItem) return;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ZIFT.default), {
            collectionName: '',
            items: mediaViewerItems || [],
            mediaClientConfig: mediaClient.config,
            selectedItem: mediaViewerSelectedItem,
            onClose: ()=>{
                setMediaViewerSelectedItem(null);
            },
            contextId: contextId,
            featureFlags: featureFlags
        }), document.body);
    };
    //----------------------------------------------------------------//
    //-------------------------- RENDER ------------------------------//
    //----------------------------------------------------------------//
    const mediaCardCursor = (0, $hOlel.getMediaCardCursor)(false, !!shouldOpenMediaViewer, status === 'error', !!cardPreview, metadata.mediaType);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ajqQB.CardView), {
                identifier: identifier,
                status: status,
                error: error,
                mediaItemType: identifier.mediaItemType,
                metadata: metadata,
                cardPreview: cardPreview,
                alt: alt,
                resizeMode: resizeMode,
                dimensions: cardDimensions,
                actions: actions,
                selectable: selectable,
                selected: selected,
                onClick: (event, analyticsEvent)=>{
                    if (onClick) {
                        const cardEvent = {
                            event: event,
                            mediaItemDetails: metadata
                        };
                        onClick(cardEvent, analyticsEvent);
                    }
                    if (shouldOpenMediaViewer) setMediaViewerSelectedItem({
                        mediaItemType: 'external-image',
                        dataURI: identifier.dataURI,
                        name: identifier.name
                    });
                },
                onMouseEnter: (event)=>{
                    onMouseEnter?.({
                        event: event,
                        mediaItemDetails: metadata
                    });
                },
                disableOverlay: disableOverlay,
                onDisplayImage: ()=>{
                    const payloadPart = {
                        fileId: identifier.dataURI,
                        isUserCollection: false
                    };
                    (0, $bfb59.globalMediaEventEmitter).emit('media-viewed', {
                        viewingLevel: 'minimal',
                        ...payloadPart
                    });
                },
                testId: testId,
                titleBoxBgColor: titleBoxBgColor,
                titleBoxIcon: titleBoxIcon,
                onImageError: (newCardPreview)=>{
                    // If the dataURI has been replaced, we can dismiss this error
                    if (newCardPreview?.dataURI !== cardPreview?.dataURI) return;
                    const error = new (0, $avBrk.ImageLoadError)(newCardPreview?.source);
                    setStatus('error');
                    setError(error);
                },
                onImageLoad: (newCardPreview)=>{
                    // If the dataURI has been replaced, we can dismiss this callback
                    if (newCardPreview?.dataURI !== cardPreview?.dataURI) return;
                    setPreviewDidRender(true);
                },
                mediaCardCursor: mediaCardCursor,
                shouldHideTooltip: shouldHideTooltip
            }),
            mediaViewerSelectedItem ? renderMediaViewer() : null
        ]
    });
};

});
parcelRegister("6ZIFT", function(module, exports) {

$parcel$export(module.exports, "default", () => $f347b7554cf6135c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $kYjx1 = parcelRequire("kYjx1");

var $jrVQR = parcelRequire("jrVQR");

const $f347b7554cf6135c$var$MediaViewer = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("7EhWJ")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $f347b7554cf6135c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kYjx1.default), {}),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jrVQR.MediaViewerPortal), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)($f347b7554cf6135c$var$MediaViewer, {
                ...props
            })
        })
    });
}

});
parcelRegister("kYjx1", function(module, exports) {

$parcel$export(module.exports, "headerAndSidebarBackgroundColor", () => $fde2124eed995e23$export$442b7be89436c101);
$parcel$export(module.exports, "default", () => $fde2124eed995e23$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2XI9f = parcelRequire("2XI9f");

var $hxoiH = parcelRequire("hxoiH");
const $fde2124eed995e23$export$442b7be89436c101 = '#101214';
const $fde2124eed995e23$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2XI9f.default), {
        blankedColor: $fde2124eed995e23$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $fde2124eed995e23$export$2e2bcd8739ae039 = $fde2124eed995e23$var$ModalSpinner;

});
parcelRegister("2XI9f", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f5f68a4750c9801$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eSLIv = parcelRequire("eSLIv");

var $fPycj = parcelRequire("fPycj");

var $VSDnB = parcelRequire("VSDnB");
const $1f5f68a4750c9801$var$ModalSpinner = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fPycj.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eSLIv.default), {
        ...props
    });
var $1f5f68a4750c9801$export$2e2bcd8739ae039 = $1f5f68a4750c9801$var$ModalSpinner;

});
parcelRegister("eSLIv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b357977404ea7fb7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $k5uoT = parcelRequire("k5uoT");

var $eZJjh = parcelRequire("eZJjh");

var $bWGt6 = parcelRequire("bWGt6");
function $b357977404ea7fb7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b357977404ea7fb7$var$overlayZindex = (0, $k5uoT.layers).modal() + 10;
const $b357977404ea7fb7$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1if7vbe1"
})({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: $b357977404ea7fb7$var$overlayZindex
});
$b357977404ea7fb7$export$5b927fc1ef8c468b.displayName = 'Blanket';
const $b357977404ea7fb7$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $bWGt6.default)("div", {
    target: "e1if7vbe0"
})({
    name: "1aslf6p",
    styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$b357977404ea7fb7$export$52b4dfd89a6b3a1b.displayName = 'SpinnerWrapper';
const $b357977404ea7fb7$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $b357977404ea7fb7$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)($b357977404ea7fb7$export$5b927fc1ef8c468b, {
        style: {
            backgroundColor: blankedColor || $b357977404ea7fb7$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($b357977404ea7fb7$export$52b4dfd89a6b3a1b, {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                size: "large",
                appearance: invertSpinnerColor || $b357977404ea7fb7$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});

parcelRegister("fPycj", function(module, exports) {

$parcel$export(module.exports, "default", () => $be399455922a702c$export$2e2bcd8739ae039);
/* modalSpinner-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
const $be399455922a702c$var$blanketStyles = null;
const $be399455922a702c$var$spinnerStyles = null;
const $be399455922a702c$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $be399455922a702c$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            backgroundColor: blankedColor || $be399455922a702c$var$defaultProps.blankedColor
        },
        "data-testid": 'media-modal-spinner-blanket',
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _1pby1qpw"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            className: (0, $bwpsq.default)([
                "_kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe"
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                size: "large",
                appearance: invertSpinnerColor || $be399455922a702c$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit',
                testId: 'media-modal-spinner'
            })
        })
    });

});



parcelRegister("jrVQR", function(module, exports) {

$parcel$export(module.exports, "MediaViewerPortal", () => $141e006dbfdbf28e$export$51aee4c01b17acde);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $k8nZq = parcelRequire("k8nZq");
const $141e006dbfdbf28e$export$51aee4c01b17acde = ({ children: children })=>// This zIndex matches with zIndex used by DS Modal and Jira Issue View Modal.
    // This value makes layers stack work correctly:
    //  -> Issue View -> Media Viewer -> DS Modal
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
        zIndex: 510,
        children: children
    });

});

parcelRegister("7EhWJ", function(module, exports) {

let $591a309388f9d1cb$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $591a309388f9d1cb$var$load("76n7a"),
    $591a309388f9d1cb$var$load("l253H"),
    $591a309388f9d1cb$var$load("ffQaD"),
    $591a309388f9d1cb$var$load("kvRbA"),
    $591a309388f9d1cb$var$load("3I8uP")
]).then(()=>parcelRequire('9mook'));

});


parcelRegister("avBrk", function(module, exports) {

$parcel$export(module.exports, "MediaCardError", () => $27b075a388b2cfb6$export$ec8d022824f41295);
$parcel$export(module.exports, "ImageLoadError", () => $27b075a388b2cfb6$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isUploadError", () => $27b075a388b2cfb6$export$11f9f5835c5b9a04);
class $27b075a388b2cfb6$export$ec8d022824f41295 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $27b075a388b2cfb6$export$2c035820a31723e extends $27b075a388b2cfb6$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $27b075a388b2cfb6$export$10ab445310d30114 extends $27b075a388b2cfb6$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $27b075a388b2cfb6$export$18e89b7e50818288 extends $27b075a388b2cfb6$export$ec8d022824f41295 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $27b075a388b2cfb6$export$921ab4548acefaa4 = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $27b075a388b2cfb6$export$d0a45ab59b4606b extends $27b075a388b2cfb6$export$ec8d022824f41295 {
    constructor(source){
        super($27b075a388b2cfb6$export$921ab4548acefaa4(source));
    }
}
function $27b075a388b2cfb6$export$36b43e3dd9a92(err) {
    return err instanceof $27b075a388b2cfb6$export$ec8d022824f41295;
}
const $27b075a388b2cfb6$export$b380593ba3516c6f = (err)=>err instanceof $27b075a388b2cfb6$export$2c035820a31723e;
const $27b075a388b2cfb6$export$e1d87830b3784f94 = (err)=>err instanceof $27b075a388b2cfb6$export$10ab445310d30114;
const $27b075a388b2cfb6$export$443aeb298d35d79d = (err)=>$27b075a388b2cfb6$export$36b43e3dd9a92(err) && err.primaryReason === 'local-preview-unsupported';
function $27b075a388b2cfb6$export$f00bb5a138da22e1(err) {
    return err instanceof $27b075a388b2cfb6$export$d0a45ab59b4606b;
}
const $27b075a388b2cfb6$export$4536ca0b68b4caf9 = (primaryReason, error, updatePrimaryReason)=>{
    if ($27b075a388b2cfb6$export$36b43e3dd9a92(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $27b075a388b2cfb6$export$ec8d022824f41295(primaryReason, error.secondaryError);
        return error;
    }
    return new $27b075a388b2cfb6$export$ec8d022824f41295(primaryReason, error);
};
const $27b075a388b2cfb6$export$11f9f5835c5b9a04 = (error)=>error && error.primaryReason === 'upload';

});

parcelRegister("c3l1i", function(module, exports) {

$parcel$export(module.exports, "generateUniqueId", () => $1acba60fcfd97d1e$export$48da330df5248c4c);
const $1acba60fcfd97d1e$export$48da330df5248c4c = ()=>{
    return (performance.now().toString(36) + Math.random().toString(36)).replace(/\./g, '');
};

});

parcelRegister("hOlel", function(module, exports) {

$parcel$export(module.exports, "getMediaCardCursor", () => $b9ab97809b6a398b$export$c364ca3a4cf16be0);

var $apIKb = parcelRequire("apIKb");
const $b9ab97809b6a398b$export$c364ca3a4cf16be0 = (useInlinePlayer, useMediaViewer, isErrorStatus, hasCardPreview, mediaType)=>{
    // If error status or no action is requested = NoAction
    if (isErrorStatus || !useInlinePlayer && !useMediaViewer) return;
    if (!mediaType && (useInlinePlayer || useInlinePlayer && useMediaViewer)) return (0, $apIKb.MediaCardCursor).NotReady;
    else if (mediaType === 'video' && hasCardPreview && useInlinePlayer) return (0, $apIKb.MediaCardCursor).Action;
    if (useMediaViewer) return (0, $apIKb.MediaCardCursor).Action;
    return;
};

});
parcelRegister("apIKb", function(module, exports) {

$parcel$export(module.exports, "isSSRPreview", () => $2d24925b0ce474a4$export$dea79d05143ccf4);
$parcel$export(module.exports, "MediaCardCursor", () => $2d24925b0ce474a4$export$2abd8762d023dc4c);
/**
 * Entry Point: @atlaskit/media-card/types
 * tsconfig.entry-points.json
 */ const $2d24925b0ce474a4$export$dea79d05143ccf4 = (preview)=>$2d24925b0ce474a4$export$36aae1afbc0a9661(preview) || $2d24925b0ce474a4$export$48a298744248dfdd(preview) || $2d24925b0ce474a4$export$f366c2c8a792cce6(preview);
const $2d24925b0ce474a4$export$48a298744248dfdd = (preview)=>{
    const ssrClientSources = [
        'ssr-server',
        'cache-ssr-server'
    ];
    return ssrClientSources.includes(preview.source);
};
const $2d24925b0ce474a4$export$36aae1afbc0a9661 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'cache-ssr-client'
    ];
    return ssrClientSources.includes(preview.source);
};
const $2d24925b0ce474a4$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
var $2d24925b0ce474a4$export$2abd8762d023dc4c = /*#__PURE__*/ function(MediaCardCursor) {
    MediaCardCursor["Action"] = "pointer";
    MediaCardCursor["NotReady"] = "wait";
    return MediaCardCursor;
}({});

});


parcelRegister("kNDBv", function(module, exports) {

$parcel$export(module.exports, "shouldPerformanceBeSampled", () => $7f85e76fa4c0d2b1$export$b21c64f4f93d10f4);
$parcel$export(module.exports, "startUfoExperience", () => $7f85e76fa4c0d2b1$export$5e9287b6a10f8075);
$parcel$export(module.exports, "completeUfoExperience", () => $7f85e76fa4c0d2b1$export$9d46b54f7b0bb11a);
$parcel$export(module.exports, "abortUfoExperience", () => $7f85e76fa4c0d2b1$export$b1021040eb94cdca);

var $cBycP = parcelRequire("cBycP");
var $7Zbvr = parcelRequire("7Zbvr");

var $4TDix = parcelRequire("4TDix");

var $6CZ6k = parcelRequire("6CZ6k");

var $fJdkV = parcelRequire("fJdkV");

var $avBrk = parcelRequire("avBrk");

var $1FyHg = parcelRequire("1FyHg");
const $7f85e76fa4c0d2b1$var$packageName = "platform-pkg";
const $7f85e76fa4c0d2b1$var$packageVersion = "0.0.0-use.local";
const $7f85e76fa4c0d2b1$var$SAMPLE_RATE = 0.05;
let $7f85e76fa4c0d2b1$var$concurrentExperience;
const $7f85e76fa4c0d2b1$var$getExperience = (id)=>{
    if (!$7f85e76fa4c0d2b1$var$concurrentExperience) {
        const inlineExperience = {
            platform: {
                component: 'media-card'
            },
            type: (0, $7Zbvr.ExperienceTypes).Experience,
            performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
            featureFlags: (0, $4TDix.getFeatureFlagKeysAllProducts)()
        };
        $7f85e76fa4c0d2b1$var$concurrentExperience = new (0, $cBycP.ConcurrentExperience)('media-card-render', inlineExperience);
    }
    return $7f85e76fa4c0d2b1$var$concurrentExperience.getInstance(id);
};
const $7f85e76fa4c0d2b1$export$b21c64f4f93d10f4 = ()=>// We generate about 100M events UFOv1 events, we want to reduce this to about 5M as we can get the same info from there
    // Math.random() generates a random floating-point number between 0 (inclusive) and 1 (exclusive).
    // The condition Math.random() < SAMPLE_RATE (0.05) will be true approximately 5% of the time.
    Math.random() < $7f85e76fa4c0d2b1$var$SAMPLE_RATE;
const $7f85e76fa4c0d2b1$export$5e9287b6a10f8075 = (id)=>{
    $7f85e76fa4c0d2b1$var$getExperience(id).start();
};
const $7f85e76fa4c0d2b1$var$sanitiseFileAttributes = (fileAttributes)=>{
    /*
  	Allow external image mediaItemType as fileId
  	See ExternalImageIdentifier interface on platform/packages/media/media-client/src/identifier.ts
   */ let sanitisedFileId = 'INVALID_FILE_ID';
    if (fileAttributes.fileId === 'external-image' || (0, (/*@__PURE__*/$parcel$interopDefault($6CZ6k)))(fileAttributes.fileId)) sanitisedFileId = fileAttributes.fileId;
    return {
        ...fileAttributes,
        fileId: sanitisedFileId
    };
};
const $7f85e76fa4c0d2b1$export$9d46b54f7b0bb11a = (id, status, fileAttributes, fileStateFlags, ssrReliability, error = new (0, $avBrk.MediaCardError)('missing-error-data'))=>{
    switch(status){
        case 'complete':
            $7f85e76fa4c0d2b1$var$succeedUfoExperience(id, {
                fileAttributes: fileAttributes,
                ssrReliability: ssrReliability,
                fileStateFlags: fileStateFlags
            });
            break;
        case 'failed-processing':
            $7f85e76fa4c0d2b1$var$failUfoExperience(id, {
                fileAttributes: fileAttributes,
                failReason: 'failed-processing',
                ssrReliability: ssrReliability,
                fileStateFlags: fileStateFlags
            });
            break;
        case 'error':
            $7f85e76fa4c0d2b1$var$failUfoExperience(id, {
                fileAttributes: fileAttributes,
                ...(0, $fJdkV.extractErrorInfo)(error),
                request: (0, $fJdkV.getRenderErrorRequestMetadata)(error),
                ssrReliability: ssrReliability,
                fileStateFlags: fileStateFlags
            });
            break;
    }
};
const $7f85e76fa4c0d2b1$var$getBasePayloadAttributes = ()=>({
        packageName: $7f85e76fa4c0d2b1$var$packageName,
        packageVersion: $7f85e76fa4c0d2b1$var$packageVersion,
        mediaEnvironment: (0, $1FyHg.getMediaEnvironment)(),
        mediaRegion: (0, $1FyHg.getMediaRegion)()
    });
const $7f85e76fa4c0d2b1$var$succeedUfoExperience = (id, properties)=>{
    if (properties?.fileAttributes) properties.fileAttributes = $7f85e76fa4c0d2b1$var$sanitiseFileAttributes(properties.fileAttributes);
    $7f85e76fa4c0d2b1$var$getExperience(id).success({
        metadata: {
            ...properties,
            ...$7f85e76fa4c0d2b1$var$getBasePayloadAttributes()
        }
    });
};
const $7f85e76fa4c0d2b1$var$failUfoExperience = (id, properties)=>{
    if (properties?.fileAttributes) properties.fileAttributes = $7f85e76fa4c0d2b1$var$sanitiseFileAttributes(properties.fileAttributes);
    $7f85e76fa4c0d2b1$var$getExperience(id).failure({
        metadata: {
            ...properties,
            ...$7f85e76fa4c0d2b1$var$getBasePayloadAttributes()
        }
    });
};
const $7f85e76fa4c0d2b1$export$b1021040eb94cdca = (id, properties)=>{
    // UFO won't abort if it's already in a final state (succeeded, failed, aborted, etc)
    if (properties?.fileAttributes) properties.fileAttributes = $7f85e76fa4c0d2b1$var$sanitiseFileAttributes(properties.fileAttributes);
    $7f85e76fa4c0d2b1$var$getExperience(id).abort({
        metadata: {
            ...properties,
            ...$7f85e76fa4c0d2b1$var$getBasePayloadAttributes()
        }
    });
};

});
parcelRegister("cBycP", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac);

var $dCAsn = parcelRequire("dCAsn");

var $boHLC = parcelRequire("boHLC");
class $d4c0ab33dd6972cc$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $boHLC.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $dCAsn.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});

parcelRegister("4TDix", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagKeysAllProducts", () => $da8fe37d22416a40$export$c8bcd5e6111ea1f3);
$parcel$export(module.exports, "getMediaFeatureFlag", () => $da8fe37d22416a40$export$383e8f51978266d);

var $2zWou = parcelRequire("2zWou");

var $66Zz4 = parcelRequire("66Zz4");

var $aU0XH = parcelRequire("aU0XH");
const $da8fe37d22416a40$export$b79c645ae6a0e5c7 = (flags)=>{
    const pairs = Object.entries(flags);
    return pairs.filter(([_key, value])=>!!value).map(([key])=>key);
};
const $da8fe37d22416a40$export$c8bcd5e6111ea1f3 = ()=>{
    const productKeys = (0, $66Zz4.getProductKeys)();
    let ldFeatureFlags = [];
    (0, $2zWou.supportedProducts).forEach((product)=>{
        ldFeatureFlags = [
            ...ldFeatureFlags,
            ...Object.values(productKeys[product])
        ];
    });
    return ldFeatureFlags.filter((flag)=>flag !== '');
};
const $da8fe37d22416a40$export$836625761e76d373 = {
    mediaInline: false
};
function $da8fe37d22416a40$export$383e8f51978266d(flagName, featureFlags) {
    return (0, $aU0XH.getGenericFeatureFlag)(flagName, $da8fe37d22416a40$export$836625761e76d373, featureFlags);
}

});
parcelRegister("2zWou", function(module, exports) {

$parcel$export(module.exports, "supportedProducts", () => $52beebacaaaff308$export$2db74afa1ef496f1);
// Media feature flags - type and defaults defined here in one source of truth
const $52beebacaaaff308$export$2db74afa1ef496f1 = [
    'confluence',
    'jira'
];

});

parcelRegister("66Zz4", function(module, exports) {

$parcel$export(module.exports, "getProductKeys", () => $7ad87e8114af2f32$export$189fe120be7e73fc);
const $7ad87e8114af2f32$var$productKeys = {
    confluence: {
        mediaInline: ''
    },
    jira: {
        // Manged by Linking Platform. No Rollout plan found for Jira
        mediaInline: ''
    }
};
const $7ad87e8114af2f32$export$189fe120be7e73fc = ()=>$7ad87e8114af2f32$var$productKeys;

});

parcelRegister("aU0XH", function(module, exports) {

$parcel$export(module.exports, "getGenericFeatureFlag", () => $04a8c3e5f240e16a$export$f2687d0de19e4973);

var $25hNX = parcelRequire("25hNX");
function $04a8c3e5f240e16a$export$f2687d0de19e4973(flagName, defaults, featureFlags) {
    const devOverride = (0, $25hNX.getLocalMediaFeatureFlag)(flagName);
    if (devOverride !== null) try {
        return JSON.parse(devOverride);
    } catch (e) {}
    if (featureFlags) return flagName in featureFlags ? featureFlags[flagName] : defaults[flagName];
    return defaults[flagName];
}

});
parcelRegister("25hNX", function(module, exports) {

$parcel$export(module.exports, "getLocalMediaFeatureFlag", () => $231bde62bcb02f83$export$d125817a2695dbc9);
// window.localStorage is easier to mock in tests if wrapped in this module
const $231bde62bcb02f83$export$d125817a2695dbc9 = (key)=>{
    try {
        return typeof window !== 'undefined' && window.localStorage ? window.localStorage.getItem(key) : null;
    } catch (e) {
    // do nothing, return null by default
    }
    return null;
};

});




parcelRegister("dnnKy", function(module, exports) {

$parcel$export(module.exports, "useCurrentValueRef", () => $bd0ba0a8e8d8ed32$export$b3e10e1f0fbb71db);

var $5uXOq = parcelRequire("5uXOq");
function $bd0ba0a8e8d8ed32$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}

});

parcelRegister("klfbI", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $0f0d6d884caeac1f$export$5cae361ad82dce8b);

var $5uXOq = parcelRequire("5uXOq");
function $0f0d6d884caeac1f$export$5cae361ad82dce8b(value) {
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("dyIlI", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $e2d050927e76d04f$export$a1fb57756f0de62b);
$parcel$export(module.exports, "fireNonCriticalErrorEvent", () => $e2d050927e76d04f$export$6505e60579e04cbd);
$parcel$export(module.exports, "fireDownloadSucceededEvent", () => $e2d050927e76d04f$export$8f39639231268ced);
$parcel$export(module.exports, "fireDownloadFailedEvent", () => $e2d050927e76d04f$export$f0368e92a624442a);

var $fJdkV = parcelRequire("fJdkV");

var $avBrk = parcelRequire("avBrk");
const $e2d050927e76d04f$export$a1fb57756f0de62b = (createAnalyticsEvent, status, fileAttributes, performanceAttributes, ssrReliability, error = new (0, $avBrk.MediaCardError)('missing-error-data'), traceContext, metadataTraceContext)=>{
    const fireEvent = (payload)=>(0, $fJdkV.fireMediaCardEvent)(payload, createAnalyticsEvent);
    switch(status){
        case 'complete':
            fireEvent((0, $fJdkV.getRenderSucceededEventPayload)(fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext));
            break;
        case 'failed-processing':
            fireEvent((0, $fJdkV.getRenderFailedFileStatusPayload)(fileAttributes, performanceAttributes, ssrReliability, traceContext, metadataTraceContext));
            break;
        case 'error':
            fireEvent((0, $fJdkV.getRenderErrorEventPayload)(fileAttributes, performanceAttributes, error, ssrReliability, traceContext, metadataTraceContext));
            break;
    }
};
const $e2d050927e76d04f$export$6505e60579e04cbd = (createAnalyticsEvent, cardStatus, fileAttributes, ssrReliability, error = new (0, $avBrk.MediaCardError)('missing-error-data'), traceContext, metadataTraceContext)=>{
    const errorPayload = (0, $fJdkV.getErrorEventPayload)(cardStatus, fileAttributes, error, ssrReliability, traceContext, metadataTraceContext);
    (0, $fJdkV.fireMediaCardEvent)(errorPayload, createAnalyticsEvent);
};
const $e2d050927e76d04f$export$8f39639231268ced = (createAnalyticsEvent, fileAttributes, traceContext, metadataTraceContext)=>{
    const payload = (0, $fJdkV.getDownloadSucceededEventPayload)(fileAttributes, traceContext, metadataTraceContext);
    (0, $fJdkV.fireMediaCardEvent)(payload, createAnalyticsEvent);
};
const $e2d050927e76d04f$export$f0368e92a624442a = (createAnalyticsEvent, fileAttributes, error = new (0, $avBrk.MediaCardError)('missing-error-data'), traceContext, metadataTraceContext)=>{
    const payload = (0, $fJdkV.getDownloadFailedEventPayload)(fileAttributes, error, traceContext, metadataTraceContext);
    (0, $fJdkV.fireMediaCardEvent)(payload, createAnalyticsEvent);
};

});

parcelRegister("ajqQB", function(module, exports) {

$parcel$export(module.exports, "CardView", () => $0346bc2670bafaa1$export$7e52c821f7b6f422);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7qjGu = parcelRequire("7qjGu");

var $cb25w = parcelRequire("cb25w");

var $2I6Ss = parcelRequire("2I6Ss");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $3Du7S = parcelRequire("3Du7S");

var $fUEF9 = parcelRequire("fUEF9");

var $fJdkV = parcelRequire("fJdkV");

var $2SXir = parcelRequire("2SXir");

var $8uJVP = parcelRequire("8uJVP");

var $b0ccC = parcelRequire("b0ccC");

var $dejfZ = parcelRequire("dejfZ");

var $cXkSM = parcelRequire("cXkSM");

var $gRd69 = parcelRequire("gRd69");

var $kQ7MY = parcelRequire("kQ7MY");

var $9VKme = parcelRequire("9VKme");

var $2aY4r = parcelRequire("2aY4r");

var $acX2Z = parcelRequire("acX2Z");

var $avBrk = parcelRequire("avBrk");

var $4vtR5 = parcelRequire("4vtR5");
var $cu1jt = parcelRequire("cu1jt");


var $eRJkE = parcelRequire("eRJkE");

var $cR8Mn = parcelRequire("cR8Mn");

var $dnnKy = parcelRequire("dnnKy");

var $5zeO2 = parcelRequire("5zeO2");

var $VSDnB = parcelRequire("VSDnB");
const $0346bc2670bafaa1$export$fe522702db3259fa = ({ identifier: identifier, innerRef: innerRef = null, onImageLoad: onImageLoad, onImageError: onImageError, dimensions: dimensions, onClick: onClick, onMouseEnter: onMouseEnter, testId: testId, metadata: metadata, status: status, selected: selected, selectable: selectable, cardPreview: cardPreview, mediaCardCursor: mediaCardCursor, shouldHideTooltip: shouldHideTooltip, progress: progress, alt: alt, resizeMode: resizeMode, onDisplayImage: onDisplayImage, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay, actions: actions, disableOverlay: disableOverlay, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, error: error, disableAnimation: disableAnimation, openMediaViewerButtonRef: openMediaViewerButtonRef = null, shouldOpenMediaViewer: shouldOpenMediaViewer, overriddenCreationDate: overriddenCreationDate, onSvgError: onSvgError, onSvgLoad: onSvgLoad })=>{
    const [didSvgRender, setDidSvgRender] = (0, $5uXOq.useState)(false);
    const [didImageRender, setDidImageRender] = (0, $5uXOq.useState)(false);
    const divRef = (0, $5uXOq.useRef)(null);
    const prevCardPreviewRef = (0, $5uXOq.useRef)();
    const breakpoint = (0, $eRJkE.useBreakpoint)(dimensions?.width, divRef);
    (0, $5uXOq.useEffect)(()=>{
        // We should only switch didImageRender to false when cardPreview goes undefined, not when it is changed. as this method could be triggered after onImageLoad callback, falling on a race condition
        if (prevCardPreviewRef.current && !cardPreview) setDidImageRender(false);
        prevCardPreviewRef.current = cardPreview;
    }, [
        cardPreview
    ]);
    const handleOnImageLoad = (prevCardPreview)=>{
        if (prevCardPreview.dataURI !== cardPreview?.dataURI) return;
        /*
      We render the icon & icon message always, even if there is cardPreview available.
      If the image fails to load/render, the icon will remain, i.e. the user won't see a change until the root card decides to chage status to error.
      If the image renders successfully, we switch this variable to hide the icon & icon message behind the thumbnail in case the image has transparency.
      It is less likely that root component replaces a suceeded cardPreview for a failed one than the opposite case. Therefore we prefer to hide the icon instead show when the image fails, for a smoother transition
    */ setDidImageRender(true);
        onImageLoad?.(cardPreview);
    };
    const handleOnImageError = (prevCardPreview)=>{
        if (prevCardPreview.dataURI !== cardPreview?.dataURI) return;
        setDidImageRender(false);
        onImageError?.(cardPreview);
    };
    const shouldRenderPlayButton = ()=>{
        const { mediaType: mediaType } = metadata || {};
        if (mediaType !== 'video' || !cardPreview) return false;
        return true;
    };
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        divRef,
        innerRef
    ]);
    const getRenderConfigByStatus = ()=>{
        const { name: name, mediaType: mediaType, mimeType: mimeType } = metadata || {};
        const isZeroSize = metadata && metadata.size === 0;
        const defaultConfig = {
            renderTypeIcon: !didImageRender && !didSvgRender,
            renderImageRenderer: !didSvgRender,
            renderSvgView: mimeType === 'image/svg+xml',
            renderPlayButton: !!cardPreview && mediaType === 'video',
            renderBlanket: !disableOverlay,
            renderTitleBox: !disableOverlay,
            renderTickBox: !disableOverlay && !!selectable
        };
        const loadingConfig = {
            ...defaultConfig,
            renderPlayButton: false,
            renderTypeIcon: false,
            renderSpinner: !didImageRender && !didSvgRender
        };
        switch(status){
            case 'uploading':
                return {
                    ...defaultConfig,
                    renderBlanket: !disableOverlay || mediaType !== 'video',
                    isFixedBlanket: true,
                    renderProgressBar: true
                };
            case 'processing':
                return {
                    ...defaultConfig,
                    iconMessage: !didImageRender && !isZeroSize ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $acX2Z.CreatingPreview), {
                        disableAnimation: disableAnimation
                    }) : undefined
                };
            case 'complete':
                return defaultConfig;
            case 'error':
            case 'failed-processing':
                if (status === 'failed-processing' && mimeType === 'image/svg+xml') return loadingConfig;
                const baseErrorConfig = {
                    ...defaultConfig,
                    renderTypeIcon: true,
                    renderImageRenderer: false,
                    renderSvgView: false,
                    renderTitleBox: false,
                    renderPlayButton: false
                };
                let iconMessage;
                let customTitleMessage;
                if ((0, $avBrk.isUploadError)(error)) {
                    iconMessage = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $acX2Z.FailedToUpload), {});
                    customTitleMessage = (0, $fUEF9.messages).failed_to_upload;
                } else if (!metadata) iconMessage = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $acX2Z.FailedToLoad), {});
                else iconMessage = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $acX2Z.PreviewUnavailable), {});
                if (!disableOverlay) {
                    const renderFailedTitleBox = !name || !!customTitleMessage;
                    return {
                        ...baseErrorConfig,
                        renderTitleBox: !!name && !customTitleMessage,
                        renderFailedTitleBox: renderFailedTitleBox,
                        iconMessage: !renderFailedTitleBox ? iconMessage : undefined,
                        customTitleMessage: customTitleMessage
                    };
                }
                return {
                    ...baseErrorConfig,
                    iconMessage: iconMessage
                };
            case 'loading-preview':
            case 'loading':
            default:
                return loadingConfig;
        }
    };
    const { renderTypeIcon: renderTypeIcon, iconMessage: iconMessage, renderImageRenderer: renderImageRenderer, renderSvgView: renderSvgView, renderSpinner: renderSpinner, renderPlayButton: renderPlayButton, renderBlanket: renderBlanket, renderProgressBar: renderProgressBar, renderTitleBox: renderTitleBox, renderFailedTitleBox: renderFailedTitleBox, renderTickBox: renderTickBox, isFixedBlanket: isFixedBlanket, customTitleMessage: customTitleMessage } = getRenderConfigByStatus();
    const shouldDisplayBackground = !cardPreview || !disableOverlay || status === 'error' || status === 'failed-processing';
    const isPlayButtonClickable = shouldRenderPlayButton() && !!disableOverlay;
    const isTickBoxSelectable = !disableOverlay && !!selectable && !selected;
    // Disable tooltip for Media Single
    const shouldDisplayTooltip = !disableOverlay && !shouldHideTooltip;
    const { mediaType: mediaType, mimeType: mimeType, name: name, createdAt: createdAt } = metadata || {};
    const isTitleBoxVisible = renderTitleBox && name;
    const hasVisibleTitleBox = !!(isTitleBoxVisible || renderFailedTitleBox);
    const metadataRef = (0, $dnnKy.useCurrentValueRef)(metadata);
    const actionsWithDetails = (0, $5uXOq.useMemo)(()=>{
        if (!actions) return [];
        return actions.map((action)=>({
                ...action,
                handler: ()=>{
                    if (!metadataRef.current) action.handler();
                    else action.handler({
                        type: 'file',
                        details: metadataRef.current
                    });
                }
            }));
    }, [
        actions,
        metadataRef
    ]);
    const onSvgLoadBase = ()=>{
        setDidSvgRender(true);
        onSvgLoad?.();
    };
    const contents = /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4vtR5.ImageContainer), {
                centerElements: didSvgRender && !(0, $VSDnB.fg)('platform_media_card_image_render'),
                testId: (0, $025bde419ff72534$export$7a6526d4be3b7eb3),
                mediaName: name,
                status: status,
                progress: progress,
                selected: selected,
                source: cardPreview?.source,
                children: [
                    renderTypeIcon && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2aY4r.IconWrapper), {
                        breakpoint: breakpoint,
                        hasTitleBox: hasVisibleTitleBox,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2I6Ss.MimeTypeIcon), {
                                testId: "media-card-file-type-icon",
                                mediaType: mediaType,
                                mimeType: mimeType,
                                name: name
                            }),
                            iconMessage
                        ]
                    }),
                    renderSpinner && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2aY4r.IconWrapper), {
                        breakpoint: breakpoint,
                        hasTitleBox: hasVisibleTitleBox,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                            testId: "media-card-loading",
                            interactionName: "media-card-loading"
                        })
                    }),
                    renderSvgView && identifier && (0, $7qjGu.isFileIdentifier)(identifier) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5zeO2.SvgView), {
                        identifier: identifier,
                        resizeMode: resizeMode || 'crop',
                        onError: onSvgError,
                        onLoad: onSvgLoadBase,
                        wrapperRef: divRef
                    }),
                    renderImageRenderer && identifier && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2SXir.ImageRenderer), {
                        cardPreview: cardPreview,
                        mediaType: metadata?.mediaType || 'unknown',
                        alt: alt ?? name,
                        resizeMode: resizeMode,
                        onDisplayImage: onDisplayImage,
                        onImageLoad: handleOnImageLoad,
                        onImageError: handleOnImageError,
                        nativeLazyLoad: nativeLazyLoad,
                        forceSyncDisplay: forceSyncDisplay,
                        identifier: identifier,
                        wrapperRef: divRef
                    }),
                    renderPlayButton && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2aY4r.IconWrapper), {
                        breakpoint: breakpoint,
                        hasTitleBox: hasVisibleTitleBox,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cXkSM.PlayButton), {})
                    }),
                    renderBlanket && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kQ7MY.Blanket), {
                        isFixed: isFixedBlanket
                    }),
                    renderTitleBox && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8uJVP.TitleBox), {
                        name: name,
                        createdAt: overriddenCreationDate ?? createdAt,
                        breakpoint: breakpoint,
                        titleBoxIcon: titleBoxIcon,
                        titleBoxBgColor: titleBoxBgColor,
                        hidden: !isTitleBoxVisible
                    }),
                    renderFailedTitleBox && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $b0ccC.FailedTitleBox), {
                        breakpoint: breakpoint,
                        customMessage: customTitleMessage
                    }),
                    renderProgressBar && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dejfZ.ProgressBar), {
                        progress: progress,
                        breakpoint: breakpoint,
                        positionBottom: !hasVisibleTitleBox
                    }),
                    renderTickBox && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gRd69.TickBox), {
                        selected: selected
                    })
                ]
            }),
            disableOverlay || !actions || actions.length === 0 ? null : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9VKme.ActionsBar), {
                filename: name,
                actions: actionsWithDetails
            })
        ]
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        children: [
            shouldOpenMediaViewer && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cR8Mn.default), {
                fileName: name ?? '',
                innerRef: openMediaViewerButtonRef,
                onClick: onClick
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cu1jt.Wrapper), {
                testId: testId || 'media-card-view',
                dimensions: dimensions,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                innerRef: mergedRef,
                breakpoint: breakpoint,
                mediaCardCursor: mediaCardCursor,
                disableOverlay: !!disableOverlay,
                selected: !!selected,
                displayBackground: shouldDisplayBackground,
                isPlayButtonClickable: isPlayButtonClickable,
                isTickBoxSelectable: isTickBoxSelectable,
                shouldDisplayTooltip: shouldDisplayTooltip,
                children: shouldDisplayTooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                    content: name,
                    position: "bottom",
                    tag: "div",
                    children: contents
                }) : contents
            })
        ]
    });
};
const $0346bc2670bafaa1$export$7e52c821f7b6f422 = (0, $cb25w.default)({
    onClick: (0, $fJdkV.createAndFireMediaCardEvent)({
        eventType: 'ui',
        action: 'clicked',
        actionSubject: 'mediaCard',
        attributes: {}
    })
})($0346bc2670bafaa1$export$fe522702db3259fa);

});
parcelRegister("2I6Ss", function(module, exports) {

$parcel$export(module.exports, "MimeTypeIcon", () => $ce8d1decd795d05b$export$875d423332b93b5f);
/* mime-type-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1xbJn = parcelRequire("1xbJn");

var $lkyzf = parcelRequire("lkyzf");
var $8DdVX = parcelRequire("8DdVX");

var $VSDnB = parcelRequire("VSDnB");
const $ce8d1decd795d05b$var$iconWrapperStyleMap = {
    small: "",
    large: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $ce8d1decd795d05b$var$iconWrapperStyles = null;
const $ce8d1decd795d05b$export$875d423332b93b5f = ({ mediaType: mediaType = 'unknown', mimeType: mimeType = 'unknown', name: name = 'unknown', testId: testId, size: size = 'large' })=>{
    // retrieve mimetype icon and label
    const iconInfo = (0, $1xbJn.getMimeIcon)(mimeType, name);
    // a corresponding mimetype icon and label was found.
    if (iconInfo) {
        const Icon = iconInfo.icon;
        return (0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "data-testid": testId,
            "data-type": iconInfo.label,
            className: (0, $bwpsq.default)([
                "_1e0c116y",
                $ce8d1decd795d05b$var$iconWrapperStyleMap[size ?? 'small']
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                label: iconInfo.label
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lkyzf.IconWrapper), {
            "data-testid": testId,
            "data-type": iconInfo.label,
            size: size,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                label: iconInfo.label
            })
        });
    }
    // no corresponding mimetype icon/label was found.
    // Hence, return a mediatype (image/doc/audio/video/unknown) icon
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8DdVX.MediaTypeIcon), {
        testId: testId,
        type: mediaType,
        size: size
    });
};

});
parcelRegister("1xbJn", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $3c9a3ebb8ee397f0$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $3c9a3ebb8ee397f0$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $3c9a3ebb8ee397f0$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $3c9a3ebb8ee397f0$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $3c9a3ebb8ee397f0$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $3c9a3ebb8ee397f0$export$61a1de0822e2820);

var $2tm8x = parcelRequire("2tm8x");

var $RiK2l = parcelRequire("RiK2l");

var $cHwqN = parcelRequire("cHwqN");

var $2sfBf = parcelRequire("2sfBf");

var $iABw2 = parcelRequire("iABw2");

var $7hpMa = parcelRequire("7hpMa");

var $dGYEZ = parcelRequire("dGYEZ");

var $iBOon = parcelRequire("iBOon");

var $jdlqN = parcelRequire("jdlqN");

var $c70Lr = parcelRequire("c70Lr");

var $2osAJ = parcelRequire("2osAJ");

var $7zjHG = parcelRequire("7zjHG");

var $8SPcB = parcelRequire("8SPcB");

var $es8mD = parcelRequire("es8mD");

var $gYsK7 = parcelRequire("gYsK7");

var $8RqHP = parcelRequire("8RqHP");
function $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $3c9a3ebb8ee397f0$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $3c9a3ebb8ee397f0$export$849633012686f7ee(file)
    };
}
async function $3c9a3ebb8ee397f0$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $3c9a3ebb8ee397f0$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $3c9a3ebb8ee397f0$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $3c9a3ebb8ee397f0$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $3c9a3ebb8ee397f0$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tm8x)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2osAJ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c70Lr)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBOon)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2sfBf)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($es8mD)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHwqN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($RiK2l)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8SPcB)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7zjHG)))
    }
];
function $3c9a3ebb8ee397f0$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $3c9a3ebb8ee397f0$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $8RqHP.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gYsK7)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iABw2)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7hpMa)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dGYEZ)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("2tm8x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ccf7616b127308b$var$_react = $1ccf7616b127308b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1ccf7616b127308b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ccf7616b127308b$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $1ccf7616b127308b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1ccf7616b127308b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $1ccf7616b127308b$var$_default = module.exports.default = $1ccf7616b127308b$var$PdfDocument24Icon;

});

parcelRegister("RiK2l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0a037d07967bfa4f$var$_react = $0a037d07967bfa4f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $0a037d07967bfa4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0a037d07967bfa4f$var$Gif24Icon = (props)=>/*#__PURE__*/ $0a037d07967bfa4f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$0a037d07967bfa4f$var$Gif24Icon.displayName = 'Gif24Icon';
var $0a037d07967bfa4f$var$_default = module.exports.default = $0a037d07967bfa4f$var$Gif24Icon;

});

parcelRegister("cHwqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $93f2a85309224bbe$var$_react = $93f2a85309224bbe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $93f2a85309224bbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93f2a85309224bbe$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $93f2a85309224bbe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$93f2a85309224bbe$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $93f2a85309224bbe$var$_default = module.exports.default = $93f2a85309224bbe$var$PowerpointPresentation24Icon;

});

parcelRegister("2sfBf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c9a4c12d2fc4227$var$_react = $1c9a4c12d2fc4227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1c9a4c12d2fc4227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1c9a4c12d2fc4227$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $1c9a4c12d2fc4227$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c9a4c12d2fc4227$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $1c9a4c12d2fc4227$var$_default = module.exports.default = $1c9a4c12d2fc4227$var$WordDocument24Icon;

});

parcelRegister("iABw2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d888b0a1557aa645$var$_react = $d888b0a1557aa645$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d888b0a1557aa645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d888b0a1557aa645$var$Sketch24Icon = (props)=>/*#__PURE__*/ $d888b0a1557aa645$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d888b0a1557aa645$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $d888b0a1557aa645$var$_default = module.exports.default = $d888b0a1557aa645$var$Sketch24Icon;

});

parcelRegister("7hpMa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $54ce1d7bd56eb231$var$_react = $54ce1d7bd56eb231$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $54ce1d7bd56eb231$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $54ce1d7bd56eb231$var$Figma24Icon = (props)=>/*#__PURE__*/ $54ce1d7bd56eb231$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$54ce1d7bd56eb231$var$Figma24Icon.displayName = 'Figma24Icon';
var $54ce1d7bd56eb231$var$_default = module.exports.default = $54ce1d7bd56eb231$var$Figma24Icon;

});

parcelRegister("dGYEZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9f7e406d5bea49df$var$_react = $9f7e406d5bea49df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9f7e406d5bea49df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f7e406d5bea49df$var$Executable24Icon = (props)=>/*#__PURE__*/ $9f7e406d5bea49df$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9f7e406d5bea49df$var$Executable24Icon.displayName = 'Executable24Icon';
var $9f7e406d5bea49df$var$_default = module.exports.default = $9f7e406d5bea49df$var$Executable24Icon;

});

parcelRegister("iBOon", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d8c2c58dddf5fcc0$var$_react = $d8c2c58dddf5fcc0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d8c2c58dddf5fcc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d8c2c58dddf5fcc0$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d8c2c58dddf5fcc0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d8c2c58dddf5fcc0$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d8c2c58dddf5fcc0$var$_default = module.exports.default = $d8c2c58dddf5fcc0$var$GoogleDoc24Icon;

});

parcelRegister("jdlqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $dfcfdb061c664b77$var$_react = $dfcfdb061c664b77$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $dfcfdb061c664b77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfcfdb061c664b77$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $dfcfdb061c664b77$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$dfcfdb061c664b77$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $dfcfdb061c664b77$var$_default = module.exports.default = $dfcfdb061c664b77$var$GoogleForm24Icon;

});

parcelRegister("c70Lr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8d16bb363c31083e$var$_react = $8d16bb363c31083e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $8d16bb363c31083e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d16bb363c31083e$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $8d16bb363c31083e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8d16bb363c31083e$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $8d16bb363c31083e$var$_default = module.exports.default = $8d16bb363c31083e$var$GoogleSheet24Icon;

});

parcelRegister("2osAJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1be4005185ae78d9$var$_react = $1be4005185ae78d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1be4005185ae78d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1be4005185ae78d9$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $1be4005185ae78d9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1be4005185ae78d9$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $1be4005185ae78d9$var$_default = module.exports.default = $1be4005185ae78d9$var$GoogleSlide24Icon;

});

parcelRegister("7zjHG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $582b1603b710ea90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $582b1603b710ea90$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;

});

parcelRegister("8SPcB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $677b15938c7d624c$var$_react = $677b15938c7d624c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $677b15938c7d624c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $677b15938c7d624c$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $677b15938c7d624c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$677b15938c7d624c$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $677b15938c7d624c$var$_default = module.exports.default = $677b15938c7d624c$var$Spreadsheet24Icon;

});

parcelRegister("es8mD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a85a2b23143ceb75$var$_react = $a85a2b23143ceb75$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a85a2b23143ceb75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a85a2b23143ceb75$var$Presentation24Icon = (props)=>/*#__PURE__*/ $a85a2b23143ceb75$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a85a2b23143ceb75$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $a85a2b23143ceb75$var$_default = module.exports.default = $a85a2b23143ceb75$var$Presentation24Icon;

});

parcelRegister("gYsK7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c5b88baa981b1084$var$_react = $c5b88baa981b1084$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c5b88baa981b1084$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c5b88baa981b1084$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $c5b88baa981b1084$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c5b88baa981b1084$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $c5b88baa981b1084$var$_default = module.exports.default = $c5b88baa981b1084$var$SourceCode24Icon;

});

parcelRegister("8RqHP", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $60b93921782d6d1e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $60b93921782d6d1e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $60b93921782d6d1e$export$ba4368c844580f9e);
function $60b93921782d6d1e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $60b93921782d6d1e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $60b93921782d6d1e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $60b93921782d6d1e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $60b93921782d6d1e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("lkyzf", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $dfa41c806d2063c1$export$be58b4326e23250f);
$parcel$export(module.exports, "MediaTypeIcon", () => $dfa41c806d2063c1$export$3787195047fd197b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dg1MW = parcelRequire("dg1MW");

var $lBSka = parcelRequire("lBSka");

var $b7OK3 = parcelRequire("b7OK3");

var $lwV66 = parcelRequire("lwV66");

var $9CRO6 = parcelRequire("9CRO6");

var $jGmM2 = parcelRequire("jGmM2");

var $daL8e = parcelRequire("daL8e");

var $dOkKo = parcelRequire("dOkKo");

var $lDRqn = parcelRequire("lDRqn");

var $duwKf = parcelRequire("duwKf");

var $8njZH = parcelRequire("8njZH");

var $7BHMh = parcelRequire("7BHMh");

var $bWGt6 = parcelRequire("bWGt6");
const $dfa41c806d2063c1$export$be58b4326e23250f = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "exhtxam0"
})("display:inline-flex;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ size: size })=>size === 'large' ? `padding: 4px;` : '');
$dfa41c806d2063c1$export$be58b4326e23250f.displayName = 'IconWrapper';
const $dfa41c806d2063c1$var$largeIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($dg1MW))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($lBSka))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($b7OK3))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($lwV66))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($9CRO6))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($jGmM2)))
};
const $dfa41c806d2063c1$var$smallIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($daL8e))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($dOkKo))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($lDRqn))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($duwKf))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($8njZH))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($7BHMh)))
};
const $dfa41c806d2063c1$var$defaultType = 'unknown';
class $dfa41c806d2063c1$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            type: $dfa41c806d2063c1$var$defaultType,
            testId: 'file-type-icon',
            size: 'large'
        };
    }
    render() {
        const { type: type, size: size, testId: testId } = this.props;
        const typeWithDefault = type || $dfa41c806d2063c1$var$defaultType;
        const icons = size === 'large' ? $dfa41c806d2063c1$var$largeIcons : $dfa41c806d2063c1$var$smallIcons;
        const Icon = icons[typeWithDefault] || icons[$dfa41c806d2063c1$var$defaultType];
        return /*#__PURE__*/ (0, $2OMIu.jsx)($dfa41c806d2063c1$export$be58b4326e23250f, {
            "data-testid": testId,
            "data-type": type,
            size: size,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                label: "media-type"
            })
        });
    }
}

});
parcelRegister("dg1MW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9a6e2824e29d024a$var$_react = $9a6e2824e29d024a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9a6e2824e29d024a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9a6e2824e29d024a$var$Image24Icon = (props)=>/*#__PURE__*/ $9a6e2824e29d024a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m7 17-1.293-1.293a1 1 0 0 0-1.414 0L4 19h16v-3.6l-3.295-3.624a1 1 0 0 0-1.447-.034zm-3.333-6.667a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9a6e2824e29d024a$var$Image24Icon.displayName = 'Image24Icon';
var $9a6e2824e29d024a$var$_default = module.exports.default = $9a6e2824e29d024a$var$Image24Icon;

});

parcelRegister("lBSka", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fbb7315e8019fa9d$var$_react = $fbb7315e8019fa9d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $fbb7315e8019fa9d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fbb7315e8019fa9d$var$Audio24Icon = (props)=>/*#__PURE__*/ $fbb7315e8019fa9d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m16 6.673V5.619c0-.38-.322-.656-.72-.615l-8.56.886c-.41.043-.72.383-.72.764v6.462A2.8 2.8 0 0 0 8.2 13h-.4A2.8 2.8 0 0 0 5 15.8v.4A2.8 2.8 0 0 0 7.8 19h.4a2.8 2.8 0 0 0 2.8-2.8V8.863l6-.62v3.873a2.8 2.8 0 0 0-.8-.116h-.4a2.8 2.8 0 0 0-2.8 2.8v.4a2.8 2.8 0 0 0 2.8 2.8h.4a2.8 2.8 0 0 0 2.8-2.8z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$fbb7315e8019fa9d$var$Audio24Icon.displayName = 'Audio24Icon';
var $fbb7315e8019fa9d$var$_default = module.exports.default = $fbb7315e8019fa9d$var$Audio24Icon;

});

parcelRegister("b7OK3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8197b56faa95d635$var$_react = $8197b56faa95d635$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $8197b56faa95d635$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8197b56faa95d635$var$Video24Icon = (props)=>/*#__PURE__*/ $8197b56faa95d635$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 7.995v8.01c0 .54.446.995.995.995h8.01c.54 0 .995-.446.995-.995v-8.01c0-.54-.446-.995-.995-.995h-8.01C4.455 7 4 7.446 4 7.995m15.16 7.943c.38.185.84-.066.84-.457V8.52c0-.39-.46-.642-.84-.457L16 9.592v4.817z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8197b56faa95d635$var$Video24Icon.displayName = 'Video24Icon';
var $8197b56faa95d635$var$_default = module.exports.default = $8197b56faa95d635$var$Video24Icon;

});

parcelRegister("lwV66", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $040b7f7dd846f7fd$var$_react = $040b7f7dd846f7fd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $040b7f7dd846f7fd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $040b7f7dd846f7fd$var$Document24Icon = (props)=>/*#__PURE__*/ $040b7f7dd846f7fd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1 18c0 .556.446 1 .995 1h8.01c.54 0 .995-.448.995-1 0-.556-.446-1-.995-1h-8.01c-.54 0-.995.448-.995 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1m0-4c0 .556.448 1 1 1h14c.555 0 1-.448 1-1 0-.556-.448-1-1-1H5c-.555 0-1 .448-1 1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$040b7f7dd846f7fd$var$Document24Icon.displayName = 'Document24Icon';
var $040b7f7dd846f7fd$var$_default = module.exports.default = $040b7f7dd846f7fd$var$Document24Icon;

});

parcelRegister("9CRO6", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $702166a50812bddf$var$_react = $702166a50812bddf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $702166a50812bddf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $702166a50812bddf$var$Archive24Icon = (props)=>/*#__PURE__*/ $702166a50812bddf$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m6 3v3h3V3zm3 3v3h3V6zM9 9v3h3V9zm3 3v3h3v-3zm-3 3v3h3v-3zm3 3v3h3v-3z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$702166a50812bddf$var$Archive24Icon.displayName = 'Archive24Icon';
var $702166a50812bddf$var$_default = module.exports.default = $702166a50812bddf$var$Archive24Icon;

});

parcelRegister("jGmM2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $e5439afabf017b97$var$_react = $e5439afabf017b97$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $e5439afabf017b97$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e5439afabf017b97$var$Generic24Icon = (props)=>/*#__PURE__*/ $e5439afabf017b97$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M12 4H8a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6.995h-2V18H8V6h4v2a2 2 0 0 0 2 2h3.5a.5.5 0 0 0 .5-.5V8.213a.5.5 0 0 0-.145-.352L14.61 4.59A2 2 0 0 0 13.19 4zM3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3"/></svg>`
    }, props, {
        size: 'medium'
    }));
$e5439afabf017b97$var$Generic24Icon.displayName = 'Generic24Icon';
var $e5439afabf017b97$var$_default = module.exports.default = $e5439afabf017b97$var$Generic24Icon;

});

parcelRegister("daL8e", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9970c4e7d3f96cd3$var$_react = $9970c4e7d3f96cd3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9970c4e7d3f96cd3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9970c4e7d3f96cd3$var$Image16Icon = (props)=>/*#__PURE__*/ $9970c4e7d3f96cd3$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4.75 11.75-.543-.543a1 1 0 0 0-1.414 0L3 13h10v-2.25l-1.795-1.974a1 1 0 0 0-1.447-.034zM4.667 6.333a1.667 1.667 0 1 0 0-3.333 1.667 1.667 0 0 0 0 3.333"/></svg>`
    }, props, {
        size: 'small'
    }));
$9970c4e7d3f96cd3$var$Image16Icon.displayName = 'Image16Icon';
var $9970c4e7d3f96cd3$var$_default = module.exports.default = $9970c4e7d3f96cd3$var$Image16Icon;

});

parcelRegister("dOkKo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a0e009d71aa209df$var$_react = $a0e009d71aa209df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a0e009d71aa209df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a0e009d71aa209df$var$Audio16Icon = (props)=>/*#__PURE__*/ $a0e009d71aa209df$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11 4.195v-.753c0-.271-.23-.468-.514-.44l-6.115.634a.565.565 0 0 0-.514.545v4.616a2 2 0 0 0-.571-.083H5a2 2 0 0 0-2 2V11a2 2 0 0 0 2 2h.286a2 2 0 0 0 2-2V5.76l4.285-.444v2.767A2 2 0 0 0 11 8h-.286a2 2 0 0 0-2 2v.286a2 2 0 0 0 2 2H11a2 2 0 0 0 2-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$a0e009d71aa209df$var$Audio16Icon.displayName = 'Audio16Icon';
var $a0e009d71aa209df$var$_default = module.exports.default = $a0e009d71aa209df$var$Audio16Icon;

});

parcelRegister("lDRqn", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $fc16ae7d17f8a28d$var$_react = $fc16ae7d17f8a28d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $fc16ae7d17f8a28d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fc16ae7d17f8a28d$var$Video16Icon = (props)=>/*#__PURE__*/ $fc16ae7d17f8a28d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m11.37 10.954c.285.138.63-.05.63-.343V5.39c0-.293-.345-.481-.63-.343L11 6.194v3.613zM2 5.99v4.018c0 .54.449.991 1.003.991h4.994A.99.99 0 0 0 9 10.01V5.99C9 5.452 8.551 5 7.997 5H3.003A.99.99 0 0 0 2 5.99"/></svg>`
    }, props, {
        size: 'small'
    }));
$fc16ae7d17f8a28d$var$Video16Icon.displayName = 'Video16Icon';
var $fc16ae7d17f8a28d$var$_default = module.exports.default = $fc16ae7d17f8a28d$var$Video16Icon;

});

parcelRegister("duwKf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9d277a30a5a98acd$var$_react = $9d277a30a5a98acd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9d277a30a5a98acd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9d277a30a5a98acd$var$Document16Icon = (props)=>/*#__PURE__*/ $9d277a30a5a98acd$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#2684ff" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m2 3a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$9d277a30a5a98acd$var$Document16Icon.displayName = 'Document16Icon';
var $9d277a30a5a98acd$var$_default = module.exports.default = $9d277a30a5a98acd$var$Document16Icon;

});

parcelRegister("8njZH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $618ffb1f66ed7d88$var$_react = $618ffb1f66ed7d88$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $618ffb1f66ed7d88$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $618ffb1f66ed7d88$var$Archive16Icon = (props)=>/*#__PURE__*/ $618ffb1f66ed7d88$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M2 0h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m4 3v2h2V3zm2 2v2h2V5zM6 7v2h2V7zm2 2v2h2V9zm-2.307 2v2h2v-2z"/></svg>`
    }, props, {
        size: 'small'
    }));
$618ffb1f66ed7d88$var$Archive16Icon.displayName = 'Archive16Icon';
var $618ffb1f66ed7d88$var$_default = module.exports.default = $618ffb1f66ed7d88$var$Archive16Icon;

});

parcelRegister("7BHMh", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $589df26f9969902f$var$_react = $589df26f9969902f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $589df26f9969902f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $589df26f9969902f$var$Generic16Icon = (props)=>/*#__PURE__*/ $589df26f9969902f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="16" height="16" viewBox="0 0 16 16" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M8 3H5.333C4.597 3 4 3.617 4 4.378v7.244C4 12.382 4.597 13 5.333 13h5.334c.736 0 1.333-.617 1.333-1.378V8h-1.333v3.622H5.333V4.378H8v1.414c0 .736.597 1.333 1.333 1.333h2.334c.184 0 .333-.15.333-.333v-.903a.33.33 0 0 0-.093-.231l-2.164-2.25A1.33 1.33 0 0 0 8.782 3zM0 1.994C0 .893.895 0 1.994 0h12.012C15.107 0 16 .895 16 1.994v12.012A1.995 1.995 0 0 1 14.006 16H1.994A1.995 1.995 0 0 1 0 14.006z"/></svg>`
    }, props, {
        size: 'small'
    }));
$589df26f9969902f$var$Generic16Icon.displayName = 'Generic16Icon';
var $589df26f9969902f$var$_default = module.exports.default = $589df26f9969902f$var$Generic16Icon;

});


parcelRegister("8DdVX", function(module, exports) {

$parcel$export(module.exports, "MediaTypeIcon", () => $4456f4306a7f6a6d$export$3787195047fd197b);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lkyzf = parcelRequire("lkyzf");

var $7K8cP = parcelRequire("7K8cP");

var $VSDnB = parcelRequire("VSDnB");
class $4456f4306a7f6a6d$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return (0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K8cP.MediaTypeIcon), {
            ...this.props
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lkyzf.MediaTypeIcon), {
            ...this.props
        });
    }
}

});
parcelRegister("7K8cP", function(module, exports) {

$parcel$export(module.exports, "MediaTypeIcon", () => $99ef24392acc9462$export$3787195047fd197b);
/* media-type-icon-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dg1MW = parcelRequire("dg1MW");

var $lBSka = parcelRequire("lBSka");

var $b7OK3 = parcelRequire("b7OK3");

var $lwV66 = parcelRequire("lwV66");

var $9CRO6 = parcelRequire("9CRO6");

var $jGmM2 = parcelRequire("jGmM2");

var $daL8e = parcelRequire("daL8e");

var $dOkKo = parcelRequire("dOkKo");

var $lDRqn = parcelRequire("lDRqn");

var $duwKf = parcelRequire("duwKf");

var $8njZH = parcelRequire("8njZH");

var $7BHMh = parcelRequire("7BHMh");
const $99ef24392acc9462$var$iconStyleMap = {
    small: "",
    large: "_ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
const $99ef24392acc9462$var$iconStyles = null;
const $99ef24392acc9462$var$largeIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($dg1MW))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($lBSka))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($b7OK3))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($lwV66))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($9CRO6))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($jGmM2)))
};
const $99ef24392acc9462$var$smallIcons = {
    image: (0, (/*@__PURE__*/$parcel$interopDefault($daL8e))),
    audio: (0, (/*@__PURE__*/$parcel$interopDefault($dOkKo))),
    video: (0, (/*@__PURE__*/$parcel$interopDefault($lDRqn))),
    doc: (0, (/*@__PURE__*/$parcel$interopDefault($duwKf))),
    archive: (0, (/*@__PURE__*/$parcel$interopDefault($8njZH))),
    unknown: (0, (/*@__PURE__*/$parcel$interopDefault($7BHMh)))
};
const $99ef24392acc9462$var$defaultType = 'unknown';
class $99ef24392acc9462$export$3787195047fd197b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            type: $99ef24392acc9462$var$defaultType,
            testId: 'file-type-icon',
            size: 'large'
        };
    }
    render() {
        const { type: type, size: size, testId: testId } = this.props;
        const typeWithDefault = type || $99ef24392acc9462$var$defaultType;
        const icons = size === 'large' ? $99ef24392acc9462$var$largeIcons : $99ef24392acc9462$var$smallIcons;
        const Icon = icons[typeWithDefault] || icons[$99ef24392acc9462$var$defaultType];
        return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            "data-testid": testId,
            "data-type": type,
            className: (0, $bwpsq.default)([
                "_1e0c116y",
                $99ef24392acc9462$var$iconStyleMap[size ?? 'small']
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                label: "media-type"
            })
        });
    }
}

});



parcelRegister("fUEF9", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2623a852a410dd0e$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2623a852a410dd0e$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    click_to_join: {
        id: 'fabric.media.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.media.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    request_access: {
        id: 'fabric.media.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_description: {
        id: 'fabric.media.request_access_description',
        defaultMessage: 'Request access to {context} view this preview.',
        description: 'Allows the user to request access to a product'
    },
    request_access_pending: {
        id: 'fabric.media.request_access_pending',
        defaultMessage: 'Access pending',
        description: 'Allows the user to try an action again with their current account'
    },
    request_access_pending_description: {
        id: 'fabric.media.request_access_pending_description',
        defaultMessage: 'Your access request is pending.',
        description: 'Informs the user that their request to view this content is pending'
    },
    forbidden_description: {
        id: 'fabric.media.forbidden_description',
        defaultMessage: "You don\u2019t have access to this preview. Contact the site admin if you need access.",
        description: 'Informs the user that they cannot view this content.'
    },
    request_denied_description: {
        id: 'fabric.media.request_denied_description',
        defaultMessage: 'Your access request was denied. Contact the site admin if you still need access.',
        description: 'Informs the user that their request to view this content was denied'
    },
    retry: {
        id: 'fabric.media.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    failed_to_load: {
        id: 'fabric.media.failed_to_load',
        defaultMessage: 'Failed to load',
        description: 'We show this message when we have an error loading a file'
    },
    failed_to_upload: {
        id: 'fabric.media.failed_to_upload',
        defaultMessage: 'Failed to upload',
        description: 'We show this message when we have an error uploading a file'
    },
    recent_uploads: {
        id: 'fabric.media.recent_uploads',
        defaultMessage: 'Recent uploads',
        description: 'Title of a section where we show the user recent uploaded files'
    },
    upload_file: {
        id: 'fabric.media.upload_file',
        defaultMessage: 'Upload a file',
        description: 'Call to action that initiates the upload of a file'
    },
    drag_and_drop_your_files: {
        id: 'fabric.media.drag_and_drop_your_files',
        defaultMessage: 'Drag and drop your files anywhere or',
        description: 'Used to describe the area where the user can drag and drop files to upload'
    },
    drag_and_drop_your_files_and_folders: {
        id: 'fabric.media.drag_and_drop_your_files_and_folders',
        defaultMessage: 'Drag and drop your files and folders anywhere or',
        description: 'Used to describe the area where the user can drag and drop files AND folders to upload'
    },
    drop_your_files: {
        id: 'fabric.media.drop_your_files',
        defaultMessage: 'Drop your files to upload',
        description: 'Indicates that the files will be uploaded when the user drops them in the drag and drop area'
    },
    upload: {
        id: 'fabric.media.upload',
        defaultMessage: 'Upload',
        description: 'upload'
    },
    cancel: {
        id: 'fabric.media.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    search_all_gifs: {
        id: 'fabric.media.search_all_gifs',
        defaultMessage: 'Search all the GIFs!',
        description: 'Used as input placeholder to let the user know that they can search for GIF image files'
    },
    cant_retrieve_gifs: {
        id: 'fabric.media.cant_retrieve_gifs',
        defaultMessage: 'Ouch! We could not retrieve any GIFs',
        description: 'Error message when we can not find any GIF images for that text'
    },
    cant_retrieve_files: {
        id: 'fabric.media.cant_retrieve_files',
        defaultMessage: 'Ouch! We could not retrieve any files',
        description: 'Error message when we can not find any files in dropbox/google drive'
    },
    check_your_network: {
        id: 'fabric.media.check_your_network',
        defaultMessage: 'Check your network connection',
        description: 'Error message when network does not work'
    },
    try_again: {
        id: 'fabric.media.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.media.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    no_gifs_found: {
        id: 'fabric.media.no_gifs_found',
        defaultMessage: "Hello? Was it me you're looking for?",
        description: 'Not expected error that happens when searching for GIF images'
    },
    no_gifs_found_suggestion: {
        id: 'fabric.media.no_gifs_found_suggestion',
        defaultMessage: 'We couldn\'t find anything for "{query}"',
        description: 'There are no results for GIFs matching that query'
    },
    load_more_gifs: {
        id: 'fabric.media.load_more_gifs',
        defaultMessage: 'Load more GIFs',
        description: 'Used to load next page of GIF images'
    },
    add_account: {
        id: 'fabric.media.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    unlink_account: {
        id: 'fabric.media.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    upload_file_from: {
        id: 'fabric.media.upload_file_from',
        defaultMessage: 'Upload a file from {name}',
        description: 'Allows to upload a file from different sources'
    },
    connect_to: {
        id: 'fabric.media.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.media.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.media.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.media.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.media.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.media.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    invalid_permissions: {
        id: 'fabric.media.invalid_permissions',
        defaultMessage: 'Restricted link',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.media.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    select_an_avatar: {
        id: 'fabric.media.select_an_avatar',
        defaultMessage: 'Select a default avatar',
        description: 'Shown when the user selects an avatar from a list of avatars'
    },
    upload_an_avatar: {
        id: 'fabric.media.upload_an_avatar',
        defaultMessage: 'Upload an avatar',
        description: 'Indicates that the user can upload a new avatar'
    },
    select_an_avatar_from_all_defaults: {
        id: 'fabric.media.select_an_avatar_from_all_defaults',
        defaultMessage: 'Select from all default options',
        description: 'Announced when user is required to select an avatar from the complete list of default options'
    },
    show_more_avatars_btn_label: {
        id: 'fabric.media.show_more_avatars_btn_label',
        defaultMessage: 'Show more',
        description: 'Button label to show more default avatar options'
    },
    or_select_default_avatars: {
        id: 'fabric.media.or_select_default_avatars',
        defaultMessage: 'Upload a photo or select from some default options',
        description: 'Announced when a user is required to select an avatar by uploading an avatar or selecting from default options'
    },
    loading: {
        id: 'fabric.media.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    loading_file: {
        id: 'fabric.media.loading_file',
        defaultMessage: 'Loading file...',
        description: 'Shown when a file is being fetched'
    },
    save: {
        id: 'fabric.media.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    or: {
        id: 'fabric.media.or',
        defaultMessage: 'or',
        description: 'Just the "or" word'
    },
    upload_photo: {
        id: 'fabric.media.upload_photo',
        defaultMessage: 'Upload a photo',
        description: 'Call to action for the user to upload a new photo'
    },
    default_avatars: {
        id: 'fabric.media.default_avatars',
        defaultMessage: 'Default avatars',
        description: 'Showed above the default avatar list'
    },
    avatar_picker_back_btn_label: {
        id: 'fabric.media.avatar_picker_back_btn_label',
        defaultMessage: 'Go Back',
        description: 'Button text to navigate back to the previous screen'
    },
    drag_and_drop_images_here: {
        id: 'fabric.media.drag_and_drop_images_here',
        defaultMessage: 'Drag and drop your images here',
        description: 'Indicates that the user can drag and drop images in that area'
    },
    alt_text: {
        id: 'fabric.media.alt_text_label',
        defaultMessage: 'Alt text',
        description: 'Shown above the alt text field'
    },
    alt_text_description: {
        id: 'fabric.media.alt_text_helper_message',
        defaultMessage: 'How would you describe the selected image to someone with low vision?',
        description: 'Shown below the alt text field'
    },
    image_url_invalid_error: {
        id: 'fabric.media.image_url_invalid_error',
        defaultMessage: 'Could not load image, the url is invalid.',
        description: 'There was an error parsing the image url'
    },
    image_format_invalid_error: {
        id: 'fabric.media.image_format_invalid_error',
        defaultMessage: 'Could not load image, the format is invalid.',
        description: 'The provided image format is not valid'
    },
    image_size_too_large_error: {
        id: 'fabric.media.image_size_too_large_error',
        defaultMessage: 'Image is too large, must be no larger than {MAX_SIZE_MB}Mb',
        description: 'The provided image size is too big'
    },
    something_went_wrong: {
        id: 'fabric.media.something_went_wrong',
        defaultMessage: 'Something went wrong.',
        description: 'Showed when an error happen but we dont have more info about it'
    },
    might_be_a_hiccup: {
        id: 'fabric.media.might_be_a_hiccup',
        defaultMessage: 'It might just be a hiccup.',
        description: 'Used when an unknow error happens, just in a funny way of saying that we dont have more info about it'
    },
    couldnt_generate_preview: {
        id: 'fabric.media.couldnt_generate_preview',
        defaultMessage: "We couldn't generate a preview for this file.",
        description: 'Error case for when the backend cant generate a preview for that file'
    },
    couldnt_generate_encrypted_entry_preview: {
        id: 'fabric.media.couldnt_generate_encrypted_entry_preview',
        defaultMessage: "We can't preview encrypted or password protected files.",
        description: 'Error case for when an entry selected is encrypted'
    },
    cant_preview_file_type: {
        id: 'fabric.media.cant_preview_file_type',
        defaultMessage: "We can't preview this file type.",
        description: 'Error case for when we have no available preview for that file'
    },
    item_not_found_in_list: {
        id: 'fabric.media.item_not_found_in_list',
        defaultMessage: 'The selected item was not found on the list.',
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.media.not_found_title',
        defaultMessage: "Uh oh. We can't find this link!",
        description: 'Error case for when a provided link is not found'
    },
    not_found_description: {
        id: 'fabric.media.not_found_description',
        defaultMessage: "We couldn't find the link. Check the url and try editing or paste again.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    no_pdf_artifacts: {
        id: 'fabric.media.no_pdf_artifacts',
        defaultMessage: 'No PDF artifacts found for this file.',
        description: 'Error case for when we cant preview a PDF file'
    },
    password_protected_pdf: {
        id: 'fabric.media.password_protected_pdf',
        defaultMessage: 'This file is password protected.',
        description: 'Describing that a PDF cannot be viewed because it is protected by password'
    },
    password: {
        id: 'fabric.media.password',
        defaultMessage: 'Password',
        description: 'Description of Password text field.'
    },
    enter_password: {
        id: 'fabric.media.enter_password',
        defaultMessage: 'Enter password',
        description: 'Prompting user to enter the password.'
    },
    incorrect_password: {
        id: 'fabric.media.incorrect_password',
        defaultMessage: 'Incorrect password. Please try again.',
        description: 'Error case for when a wrong password is inputted.'
    },
    submit: {
        id: 'fabric.media.submit',
        defaultMessage: 'Submit',
        description: 'Description for a button to submit the form.'
    },
    give_feedback: {
        id: 'fabric.media.give_feedback',
        defaultMessage: 'Give feedback',
        description: 'Call to action that opens a popup to get feedback from the users'
    },
    try_downloading_file: {
        id: 'fabric.media.try_downloading_file',
        defaultMessage: 'Try downloading the file to view it.',
        description: 'We show this message to allow users to download a file'
    },
    webgl_warning_description: {
        id: 'fabric.media.webgl_warning_description',
        defaultMessage: 'Your browser does not support WebGL. Use a WebGL enabled browser to annotate images.',
        description: 'We show this error message when the browser doesnt support this feature'
    },
    unable_to_annotate_image: {
        id: 'fabric.media.unable_to_annotate_image',
        defaultMessage: "You're unable to annotate this image",
        description: 'If there is an error trying to annotate an image we show this'
    },
    learn_more: {
        id: 'fabric.media.learn_more',
        defaultMessage: 'Learn More',
        description: ''
    },
    accounts: {
        id: 'fabric.media.accounts',
        defaultMessage: 'Accounts',
        description: ''
    },
    actions: {
        id: 'fabric.media.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    error_hint_retry: {
        id: 'fabric.media.error_hint_retry',
        defaultMessage: "Try again and we'll give it another shot.",
        description: 'Generic message that we show if an action failed'
    },
    error_hint_critical: {
        id: 'fabric.media.error_hint_critical',
        defaultMessage: 'If the problem keeps happening contact support.',
        description: 'We show this error message if we cant recover from the action'
    },
    close: {
        id: 'fabric.media.close',
        defaultMessage: 'Close',
        description: ''
    },
    could_not_load_editor: {
        id: 'fabric.media.could_not_load_editor',
        defaultMessage: 'Ouch! We could not load the editor',
        description: 'Error message to communicate that we cant load the editor'
    },
    could_not_save_image: {
        id: 'fabric.media.could_not_save_image',
        defaultMessage: 'Ouch! We could not save the image',
        description: 'Error message to communicate that we cant save an image'
    },
    could_not_load_link: {
        id: 'fabric.media.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    annotate: {
        id: 'fabric.media.annotate',
        defaultMessage: 'Annotate',
        description: ''
    },
    annotate_tool_arrow: {
        id: 'fabric.media.annotate.tool.arrow',
        defaultMessage: 'Arrow',
        description: ''
    },
    annotate_tool_text: {
        id: 'fabric.media.annotate.tool.text',
        defaultMessage: 'Text',
        description: ''
    },
    annotate_tool_shape: {
        id: 'fabric.media.annotate.tool.shape',
        defaultMessage: 'Shape',
        description: ''
    },
    annotate_tool_brush: {
        id: 'fabric.media.annotate.tool.brush',
        defaultMessage: 'Brush',
        description: ''
    },
    annotate_tool_blur: {
        id: 'fabric.media.annotate.tool.blur',
        defaultMessage: 'Blur',
        description: ''
    },
    annotate_tool_line_thickness: {
        id: 'fabric.media.annotate.tool.line.thickness',
        defaultMessage: 'Line thickness',
        description: ''
    },
    annotate_tool_color: {
        id: 'fabric.media.annotate.tool.color',
        defaultMessage: 'Color',
        description: ''
    },
    annotate_confirmation_close_anyway: {
        id: 'fabric.media.annotate.confirmation.close.anyway',
        defaultMessage: 'Close anyway',
        description: ''
    },
    annotate_confirmation_heading: {
        id: 'fabric.media.annotate.confirmation.heading',
        defaultMessage: 'Unsaved changes',
        description: ''
    },
    annotate_confirmation_content: {
        id: 'fabric.media.annotate.confirmation.content',
        defaultMessage: 'You have some unsaved changes. Are you sure you want to leave?',
        description: ''
    },
    drop_your_files_here: {
        id: 'fabric.media.drop_your_files_here',
        defaultMessage: 'Drop your files here',
        description: 'Info message that we show to indicate that the user can drag and drop files'
    },
    share_files_instantly: {
        id: 'fabric.media.share_files_instantly',
        defaultMessage: "We'll share them instantly",
        description: 'It means that we will upload the files you drag and drop automatically'
    },
    insert_files: {
        id: 'fabric.media.insert_files',
        defaultMessage: 'Insert {0, plural, one {a file} other {{0} files}}',
        description: 'Showed when the user selects 1 or more files to insert'
    },
    zoom_out: {
        id: 'fabric.media.zoom_out',
        defaultMessage: 'zoom out',
        description: 'Indicates the user can zoom out a file'
    },
    zoom_in: {
        id: 'fabric.media.zoom_in',
        defaultMessage: 'zoom in',
        description: 'Indicates the user can zoom in a file'
    },
    remove_image: {
        id: 'fabric.media.remove_image',
        defaultMessage: 'Remove image',
        description: 'Allows the user to remove a file'
    },
    play: {
        id: 'fabric.media.play',
        defaultMessage: 'Play',
        description: ''
    },
    pause: {
        id: 'fabric.media.pause',
        defaultMessage: 'Pause',
        description: ''
    },
    disable_fullscreen: {
        id: 'fabric.media.disable_fullscreen',
        defaultMessage: 'disable fullscreen',
        description: 'Hint to let the user know they can disable the fullscreen mode'
    },
    enable_fullscreen: {
        id: 'fabric.media.enable_fullscreen',
        defaultMessage: 'enable fullscreen',
        description: 'Hint to let the user know they can enable the fullscreen mode'
    },
    error_loading_file: {
        id: 'fabric.media.error_loading_file',
        defaultMessage: 'Error loading file',
        description: 'Message showed when we had an error trying to load the file'
    },
    error_generating_preview: {
        id: 'fabric.media.error_generating_preview',
        defaultMessage: 'Error generating preview',
        description: 'Message showed when we had an error trying generate a preview for a file'
    },
    download: {
        id: 'fabric.media.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_disabled_security_policy: {
        id: 'fabric.media.download_disabled_security_policy',
        defaultMessage: "Download is blocked by your organization's security policy.",
        description: ''
    },
    unknown: {
        id: 'fabric.media.unknown',
        defaultMessage: 'unknown',
        description: ''
    },
    document: {
        id: 'fabric.media.document',
        defaultMessage: 'document',
        description: ''
    },
    audio: {
        id: 'fabric.media.audio',
        defaultMessage: 'audio',
        description: ''
    },
    video: {
        id: 'fabric.media.video',
        defaultMessage: 'video',
        description: ''
    },
    image: {
        id: 'fabric.media.image',
        defaultMessage: 'image',
        description: ''
    },
    archive: {
        id: 'fabric.media.archive',
        defaultMessage: 'archive',
        description: ''
    },
    email: {
        id: 'fabric.media.email',
        defaultMessage: 'email',
        description: ''
    },
    text: {
        id: 'fabric.media.text',
        defaultMessage: 'text',
        description: ''
    },
    displayThumbnail: {
        id: 'fabric.media.display_thumbnail',
        defaultMessage: 'Display thumbnail',
        description: 'Display file with as a thumbnail.'
    },
    search: {
        id: 'fabric.media.search',
        defaultMessage: 'search',
        description: ''
    },
    view: {
        id: 'fabric.media.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.media.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.media.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    changeView: {
        id: 'fabric.media.change_view',
        defaultMessage: 'Change view',
        description: 'In the context of a file, it allows the user to select a different way of displaying the file either as inline or a card'
    },
    playbackSpeed: {
        id: 'fabric.media.playback_speed',
        defaultMessage: 'Playback speed',
        description: 'In the context of a video player, it allows user to switch the speed of the video'
    },
    skipBackward: {
        id: 'fabric.media.skip_backward',
        defaultMessage: 'Back 10 seconds',
        description: 'In the context of a video player, it allows user to skip 10 seconds of play time backward.'
    },
    skipForward: {
        id: 'fabric.media.skip_forward',
        defaultMessage: 'Forward 10 seconds',
        description: 'In the context of a video player, it allows user to skip 10 seconds of play time forward.'
    },
    sizeOptions: {
        id: 'fabric.media.size_options',
        defaultMessage: 'Size options',
        description: 'A dropdown with buttons that allow to convert an image to an inline or to an image or original size'
    },
    fileDisplayOptions: {
        id: 'fabric.media.file.display_options',
        defaultMessage: 'Display options',
        description: 'A dropdown with buttons that allow to convert between an inline file or a thumbnail file'
    },
    volumeLevelControlAria: {
        id: 'fabric.media.volume_level',
        defaultMessage: 'volume',
        description: 'In the context of a video player and screen reader. Aria label for volume level control'
    },
    volumeMuteButtonAria: {
        id: 'fabric.media.volume_level',
        defaultMessage: 'mute',
        description: 'In the context of a video player and screen reader. Aria label for mute button'
    },
    playbackDefaultSpeed: {
        id: 'fabric.media.playback_default_speed',
        defaultMessage: 'Default',
        description: 'In the context of a video player, it is a value of a default playback speed'
    },
    preview: {
        id: 'fabric.media.preview',
        defaultMessage: 'Preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    creating_preview: {
        id: 'fabric.media.creating_preview',
        defaultMessage: 'Creating preview...',
        description: 'Preview is being created for a media card'
    },
    preview_unavailable: {
        id: 'fabric.media.preview_unavailable',
        defaultMessage: 'Preview unavailable',
        description: 'Preview is unavailable for a media card'
    },
    couldnt_load_file: {
        id: 'fabric.media.couldnt_load_file',
        defaultMessage: "We couldn't load the file.",
        description: 'File is rate limited without metadata'
    },
    error_429: {
        id: 'fabric.media.error_429',
        defaultMessage: 'Error 429',
        description: 'Error 429 is thrown'
    },
    close_and_reopen: {
        id: 'fabric.media.close_and_reopen',
        defaultMessage: 'Try closing this file and reopening.',
        description: 'The preview is rate limited'
    },
    viewer_rateLimited: {
        id: 'fabric.media.viewer_rateLimited',
        defaultMessage: `We're having difficulties loading your file.`,
        description: 'Mediaviewer has been rate limited'
    },
    zip_entry_load_fail: {
        id: 'fabric.media.zip_entry_load_failed',
        defaultMessage: `We couldn't load that zip file item to preview`,
        description: 'Zip entry failed to load'
    },
    file_image_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Image {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded image'
    },
    file_video_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Video {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded video'
    },
    file_audio_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Audio {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded audio'
    },
    file_doc_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Document {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded document'
    },
    file_archive_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'Archive {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded archive'
    },
    file_unknown_is_selected: {
        id: 'fabric.media.file_is_selected',
        defaultMessage: 'File {name} is selected',
        description: '{name} it is the parameter, which saying alt text or file name of uploaded file'
    },
    open_file_in_viewer: {
        id: 'fabric.media.open_file_in_viewer',
        defaultMessage: 'Open {name}',
        description: 'Shown when user focuses on preview to open the full screen viewer of the file with {name}'
    },
    video_seeker_assistive_text_time_value: {
        id: 'fabric.media.video_seeker_assistive_text_time_value',
        defaultMessage: '{currentTimeHours} {currentTimeMinutes} {currentTimeSeconds} of {videoTotalHours} {videoTotalMinutes} {videoTotalSeconds}',
        description: 'Video time seeker information for screen reader users - final format example: 1 hour 12 minutes 13 seconds of 1 hours 16 minutes 1 second. Units are already translated via Intl.NumberFormat'
    },
    video_seeker_label_assistive_text: {
        id: 'fabric.media.video_seeker_label_assistive_text',
        defaultMessage: 'Seek slider',
        description: 'Video time seek slider aria-label'
    },
    abuse_modal_body: {
        id: 'fabric.media.abuse_modal_body',
        defaultMessage: 'For your security, our system automatically scans all uploaded files. The file you are about to download potentially contains malicious content',
        description: 'Abuse Modal Body Message'
    },
    abuse_modal_title: {
        id: 'fabric.media.abuse_modal_title',
        defaultMessage: 'Warning',
        description: 'Abuse Modal Title'
    },
    abuse_modal_submit: {
        id: 'fabric.media.abuse_modal_submit',
        defaultMessage: 'Proceed with download',
        description: 'Abuse Modal Submit button caption'
    },
    image_cropper_arrow_keys_label: {
        id: 'media.media-avatar-picker.image-cropper.arrow-keys.label',
        defaultMessage: 'Draggable Image, Ensure your screen reader is not in browse mode. use arrow keys to move & crop the image',
        description: 'Inform about the image crop functionality using arrow keys'
    },
    image_cropper_image_moved: {
        id: 'media.media-avatar-picker.image-cropper.arrow-keys.action',
        defaultMessage: 'You have moved the image from {key, select, left {left to right} right {right to left} top {top to bottom} other {bottom to top} }, use arrow keys to move & crop the image',
        description: 'Inform about the image movement when the arrow keys are pressed'
    },
    image_cropper_zoom_out: {
        id: 'media.media-avatar-picker.image-cropper.zoom_out',
        defaultMessage: 'Zoom out',
        description: 'Label for the zoom out button in image cropper slider'
    },
    image_cropper_zoom_in: {
        id: 'media.media-avatar-picker.image-cropper.zoom_in',
        defaultMessage: 'Zoom in',
        description: 'Label for the zoom in button in image cropper slider'
    },
    image_cropper_zoom_slider: {
        id: 'media.media-avatar-picker.image-cropper.zoom_slider',
        defaultMessage: 'set zoom',
        description: 'Label for the zoom slider to adjust image zoom'
    }
});

});

parcelRegister("2SXir", function(module, exports) {

$parcel$export(module.exports, "ImageRenderer", () => $041b384eba9bbfe1$export$a8e6523ab063becd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7CCO6 = parcelRequire("7CCO6");

var $8jUB8 = parcelRequire("8jUB8");

var $VSDnB = parcelRequire("VSDnB");
const $041b384eba9bbfe1$export$a8e6523ab063becd = (props)=>{
    return (0, $VSDnB.fg)('platform_media_card_image_render') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8jUB8.ImageRenderer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7CCO6.ImageRenderer), {
        ...props
    });
};

});
parcelRegister("7CCO6", function(module, exports) {

$parcel$export(module.exports, "ImageRenderer", () => $6ac1dc696713e224$export$a8e6523ab063becd);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1YZq6 = parcelRequire("1YZq6");

var $6C1vw = parcelRequire("6C1vw");

var $dnnKy = parcelRequire("dnnKy");
const $6ac1dc696713e224$export$a8e6523ab063becd = ({ cardPreview: cardPreview, alt: alt, resizeMode: resizeMode, onImageLoad: onImageLoad, onImageError: onImageError, onDisplayImage: onDisplayImage, mediaType: mediaType, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay })=>{
    const onDisplayImageRef = (0, $dnnKy.useCurrentValueRef)(onDisplayImage);
    (0, $5uXOq.useEffect)(()=>{
        // TODO: trigger accordingly with the succeeded event. This could be a breaking change
        if (mediaType === 'image') onDisplayImageRef.current?.();
    }, [
        mediaType,
        onDisplayImageRef
    ]);
    const onLoad = ()=>{
        onImageLoad && cardPreview && onImageLoad(cardPreview);
    };
    const onError = ()=>{
        onImageError && cardPreview && onImageError(cardPreview);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1YZq6.MediaImage), {
        dataURI: cardPreview?.dataURI,
        alt: alt,
        previewOrientation: cardPreview?.orientation,
        onImageLoad: onLoad,
        onImageError: onError,
        loading: nativeLazyLoad ? 'lazy' : undefined,
        forceSyncDisplay: forceSyncDisplay,
        ...(0, $6C1vw.resizeModeToMediaImageProps)(resizeMode)
    });
};

});
parcelRegister("1YZq6", function(module, exports) {

$parcel$export(module.exports, "MediaImage", () => $10d9f6670fc3d29b$export$1f97dc1e9d072692);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $lr1Nm = parcelRequire("lr1Nm");

var $ezQAH = parcelRequire("ezQAH");

var $hNjKA = parcelRequire("hNjKA");

var $3Du7S = parcelRequire("3Du7S");
const $10d9f6670fc3d29b$export$1f97dc1e9d072692 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ dataURI: dataURI, alt: alt = '', crop: crop = false, stretch: stretch = false, previewOrientation: previewOrientation = 1, crossOrigin: crossOrigin, onImageLoad: onImageLoad, onImageError: onImageError, loading: loading, forceSyncDisplay: forceSyncDisplay = false }, ref)=>{
    const [{ width: parentWidth, height: parentHeight }, setParentDimensions] = (0, $5uXOq.useState)({
        width: Infinity,
        height: Infinity
    });
    const [{ width: imgWidth, height: imgHeight }, setImageDimensions] = (0, $5uXOq.useState)({
        width: 0,
        height: 0
    });
    const [isImageLoaded, setIsImageLoaded] = (0, $5uXOq.useState)(false);
    const imgRef = (0, $5uXOq.useRef)(null);
    const imageRef = (0, $5uXOq.useCallback)((imgElem)=>{
        if (!imgElem || imgRef.current) return;
        if (imgElem.parentElement) {
            const { width: width, height: height } = imgElem.parentElement.getBoundingClientRect();
            setParentDimensions({
                width: width,
                height: height
            });
        }
        imgRef.current = imgElem;
    }, []);
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        imageRef,
        ref
    ]);
    const imageLoadHandler = (e)=>{
        if (!imgRef.current) return;
        setImageDimensions({
            width: imgRef.current.naturalWidth,
            height: imgRef.current.naturalHeight
        });
        setIsImageLoaded(true);
        onImageLoad?.(e.currentTarget);
    };
    const parentRatio = parentWidth / parentHeight;
    let imgRatio = imgWidth / imgHeight;
    let percentSize = '100%';
    /*
      Cover strategy means we want to full entire screen with an image. Here is an example:

         Image           Container   Result (░ - is what cropped out)
     ┌──────────────┐    ┌──────┐    ┌───┬──────┬───┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │░░░│▓▓▓▓▓▓│░░░│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    └──────┘    └───┴──────┴───┘
     └──────────────┘
    */ const isCoverStrategy = crop;
    /*
      Fit strategy means image is fully inside container even if there is empty space left.
      Here is an example:

             Image            Container     Result
     ┌────────────────────┐    ┌──────┐    ┌──────┐
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│ -> │      │ => │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    │▓▓▓▓▓▓│
     │▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓│    │      │    ├──────┤
     └────────────────────┘    └──────┘    └──────┘
     */ const isFitStrategy = !crop;
    const isImageRotated = previewOrientation !== 'from-image' && (0, $hNjKA.isRotated)(previewOrientation);
    /*
      When photo has orientation of 90deg or 270deg (stored in EXIF meta data)
      things get very tricky. Let me go through an two examples to explain how we deal with that:

      Example #1:

      Image comes in as    ________    But it needs to be     ┌──────┐
      horizontal picture  |        |   displayed as 750x1000  │      │
      of 1000x750         |        |   because orientation    │      │
                          |________|   say it must be rotated │      │
                                       90 degrees             │      │
                                                              └──────┘

      Container is smaller, and has dimensions of 100x200.
      So, input parameters are:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: true (means we want to cover)
        stretch: true
        previewOrientation: 6

      To see what true value of isImageMoreLandscapyThanContainer is we need to flip imgRatio.
      Since initial value is 1000/750 = 1.33 we can just do 1/1.3333 = 0.75.

      In this situation final values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: true
        isFitStrategy: false
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

      According to this variables state css will become:
        height: 100%;

      Now here is what going to happened.
      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply height: 100%.

      ┌────┬──────┬────┐  This will scale an image according to rules of proportions:
      │░░░░│▓▓▓▓▓▓│░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      │░░░░│▓▓▓▓▓▓│░░░░│  (orig img height) -> (scaled down img height)
      │░░░░│▓▓▓▓▓▓│░░░░│  750px             -> 200px  (is === container height, since `height: 100%`)
      └────┴──────┴────┘  (orig img width)  -> (scaled down img width)
              ↑           1000px            -> (200 x 1000) / 750 = 266.66px
       266x200 image in
       100x200 container.

      And only NOW browser will apply rotate: 90deg and turn image around.
      And we end up with this:

      ┌──────────┐   Where 200x266 image
      │░░░░░░░░░░│   in the 100x200 container.
      │░┌──────┐░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░└──────┘░│
      │░░░░░░░░░░│
      └──────────┘

      To combat this we will not make height: 100% but use ratio of an image.
      In this case imgRatio is now 0.75 (after flipping)

      New math will look like this:
      (orig img height) -> (scaled down img height)
      750px             -> (0.75 x 200px) = 150px (since `height: 75%`)
      (orig img width)  -> (scaled down img width)
      1000px            -> (150 x 1000) / 750 = 200px

      ┌─┬──────┬─┐  Now 150x200 image
      │░│▓▓▓▓▓▓│░│  is in 100x200 container.
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      │░│▓▓▓▓▓▓│░│
      └─┴──────┴─┘

      Unfortunately this is not over yet.



      Example #2:

      Input parameters:
        parentWidth: 100
        parentHeight: 200
        imgWidth: 1000
        imgHeight: 750
        crop: false (means we want to fit)  <-- This is only changed parameter
        stretch: true
        previewOrientation: 6

      Final variable values will be:
        imgRatio: 0.75
        parentRatio: 0.5
        isCoverStrategy: false
        isFitStrategy: true
        isImageRotated: true
        isImageMoreLandscapyThanContainer: true
        isStretchingAllowed: true

       According to this variables state css will become:
        width: 100%;

      FIRST, Browser will put an image with 1000x750 (NB! Not yet rotated) into the box 100x200
      and apply width: 100%.

      ┌────────┐  This will scale an image according to rules of proportions:
      │░░░░░░░░│  (https://en.wikipedia.org/wiki/Cross-multiplication#Rule_of_Three)
      ├────────┤  (orig img width)  -> (scaled down img width)
      │▓▓▓▓▓▓▓▓│  1000px            -> 100px (is === container width, since `width: 100%`)
      │▓▓▓▓▓▓▓▓│  (orig img height) -> (scaled down img height)
      ├────────┤  750px             -> (750x100) / 1000 = 75px
      │░░░░░░░░│
      └────────┘
          ↑
       100x75 image in
       100x200 container.

      Now browser will turn image 90degrees and we und up with:
      ┌──────────┐
      │          │  75x100 image in
      │ ┌──────┐ │  100x200 container
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ │▓▓▓▓▓▓│ │
      │ └──────┘ │
      │          │
      └──────────┘

      This looks familiar, and you might want to try what we did before and apply 75% not 100%.
      Unfortunately this will make it even worse. If you do calculation you will find out that
      final result will be 75x56 image in 100x200 container. For this and one more specific
      variables state we need to use original imgRatio for percent size. In this case it's 1.333, so
      134%

      New math will look like this:
      (orig img width)  -> (scaled down img width)
      1000px            -> (100px * 1.34) = 134px (since `width: 134%`)
      (orig img height) -> (scaled down img height)
      750px             -> (750x134) / 1000 = 100px

      So, 100x134 image in 100x200 container.
     */ if (isImageRotated) {
        imgRatio = 1 / imgRatio;
        percentSize = `${Math.ceil(imgRatio * 100)}%`;
    }
    /*
      Here is an example of when isImageMoreLandscapyThanContainer is true:

        Image      Container   OR   Image      Container
       ________      _____          ____           __
      |        | -> |     |        |    |   ->    |  |
      |________|    |_____|        |    |         |  |
                                   |    |         |  |
                                   |    |         |  |
                                   |____|         |__|

      For false just swap "Image" and "Container" in the example above.
     */ const isImageMoreLandscapyThanContainer = imgRatio > parentRatio;
    const isImgLandscape = imgWidth > imgHeight;
    /*
    This is two cases we need to cover as described in Example #2 above, but only for rotated landscape images.
     */ if (isImageRotated && isImgLandscape) {
        if (isFitStrategy || isImageMoreLandscapyThanContainer || isCoverStrategy && !isImageMoreLandscapyThanContainer) percentSize = `${Math.ceil(1 / imgRatio * 100)}%`;
    }
    /*
      When isStretchingAllowed is false image is as big as it is, but as small as container
      (according to strategy - cover or fit).
      isStretchingAllowed is true if image is bigger then container.
     */ const isStretchingAllowed = stretch;
    /*
      We do not want to show image until we finish deciding on sizing strategy.
      Though if it is a "fit" strategy (and image hasn't been rotated) we can display it right away,
      since it doesn't depend on isImageMoreLandscapyThanContainer nor it will change when isStretchingAllowed
      changes it's value after imgRatio and parentRatio get defined.
      The reason for exclude isImageRotated is that we need to calculate percentSize variable
      and we can do that only when image is loaded (and we have image size)
     */ const showImage = forceSyncDisplay || isImageLoaded || isFitStrategy && !isImageRotated;
    const style = {
        transform: 'translate(-50%, -50%)'
    };
    if (isStretchingAllowed) {
        if (isFitStrategy && isImageMoreLandscapyThanContainer) /*
          Image matches its width to container's and height scales accordingly.

            Image       Container       Result
                       ┌─────────┐    ┌─────────┐
           ┌──────┐    │         │    ├─────────┤
           │▓▓▓▓▓▓│ -> │         │ => │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           └──────┘    │         │    ├─────────┤
                       └─────────┘    └─────────┘
         */ style.width = percentSize;
        else if (isFitStrategy && !isImageMoreLandscapyThanContainer) /*
          Image matches its height to container's and width scales accordingly.
         */ style.height = percentSize;
        else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          In order to cover whole container guaranteed (even in expense of stretching)
          image matches its height to container's. Width scales accordingly and crops out sides.

             Image       Container    Result (░ - is what cropped out)
                       ┌─────────┐    ┌──┬──────┬──┐
           ┌──────┐    │         │    │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│ -> │         │ => │░░│▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓│    │         │    │░░│▓▓▓▓▓▓│░░│
           └──────┘    │         │    │░░│▓▓▓▓▓▓│░░│
                       └─────────┘    └──┴──────┴──┘
         */ style.height = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.width = percentSize;
    } else {
        if (isFitStrategy) {
            /*
          We want image to be as wide and as height as container but not bigger then it's own size.

            Image       Container       Result
           ┌───────────┐    ┌─────────┐    ┌─────────┐
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    ├─────────┤
           │▓▓▓▓▓▓▓▓▓▓▓│    │         │    │▓▓▓▓▓▓▓▓▓│
           │▓▓▓▓▓▓▓▓▓▓▓│->  │         │ => │▓▓▓▓▓▓▓▓▓│
           └───────────┘    │         │    │▓▓▓▓▓▓▓▓▓│
                            │         │    ├─────────┤
                            └─────────┘    └─────────┘

         And if image is smaller it doesn't change its size

            Image       Container       Result
                       ┌──────────┐    ┌──────────┐
                       │          │    │          │
           ┌──────┐    │          │    │ ┌──────┐ │
           │▓▓▓▓▓▓│ -> │          │ => │ │▓▓▓▓▓▓│ │
           │▓▓▓▓▓▓│    │          │    │ │▓▓▓▓▓▓│ │
           └──────┘    │          │    │ └──────┘ │
                       │          │    │          │
                       └──────────┘    └──────────┘
         */ style.maxWidth = percentSize;
            style.maxHeight = percentSize;
        } else if (isCoverStrategy && isImageMoreLandscapyThanContainer) /*
          We want to fill container but we can't stretch an image if it's smaller then container.

            Image            Container       Result
           ┌────────────┐    ┌───────┐    ┌──┬───────┬──┐
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    │       │    │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│->  │       │ => │░░│▓▓▓▓▓▓▓│░░│
           │▓▓▓▓▓▓▓▓▓▓▓▓│    └───────┘    └──┴───────┴──┘
           └────────────┘

         */ style.maxHeight = percentSize;
        else if (isCoverStrategy && !isImageMoreLandscapyThanContainer) style.maxWidth = percentSize;
    }
    if (!showImage || !dataURI) style.display = 'none';
    if (previewOrientation === 'from-image') style.imageOrientation = 'from-image';
    else if (previewOrientation > 1) {
        const transform = (0, $hNjKA.getCssFromImageOrientation)(previewOrientation);
        style.transform += ` ${transform}`;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ezQAH.ImageComponent), {
        loading: loading,
        "data-testid": "media-image",
        "data-vc": "media-image",
        draggable: false,
        alt: alt,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onLoad: imageLoadHandler,
        onError: onImageError,
        imageRef: mergedRef,
        src: dataURI,
        crossOrigin: crossOrigin,
        ...(0, $VSDnB.fg)('platform_exclude_media_offender_from_vc') && (0, $lr1Nm.VcMediaWrapperProps)
    });
});

});
parcelRegister("ezQAH", function(module, exports) {

$parcel$export(module.exports, "ImageComponent", () => $c0856e9eb2caef39$export$fd536c918b58ab76);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");
/*
  TODO: https://product-fabric.atlassian.net/browse/CXP-3132

  We need to revisit omitting percentage values for Design Token since the parent applies transform(-50%, -50%) on it (packages/media/media-ui/src/mediaImage/index.tsx). This styling is complex and may potentially cause a bug if not treaded carefully.
*/ const $c0856e9eb2caef39$var$imgStyle = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    objectFit: 'contain',
    imageOrientation: 'none'
};
const $c0856e9eb2caef39$export$fd536c918b58ab76 = (props)=>{
    const { style: style, imageRef: imageRef, ...otherProps } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, jsx-a11y/alt-text -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        ...otherProps,
        ref: imageRef,
        style: {
            ...$c0856e9eb2caef39$var$imgStyle,
            ...style
        }
    }));
};

});

parcelRegister("hNjKA", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $81d3fceca65be0fc$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $81d3fceca65be0fc$export$43142f95b8de7a91);
const $81d3fceca65be0fc$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $81d3fceca65be0fc$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $81d3fceca65be0fc$export$43142f95b8de7a91 = (orientation)=>{
    return $81d3fceca65be0fc$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("6C1vw", function(module, exports) {

$parcel$export(module.exports, "resizeModeToMediaImageProps", () => $785f11d38a7190ac$export$31853d267a6d0b0b);
function $785f11d38a7190ac$export$31853d267a6d0b0b(resizeMode) {
    return {
        crop: resizeMode === 'crop',
        stretch: resizeMode === 'stretchy-fit'
    };
}

});


parcelRegister("8jUB8", function(module, exports) {

$parcel$export(module.exports, "ImageRenderer", () => $6912ed76e930cb2d$export$a8e6523ab063becd);
/* imageRendererV2.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3jjJr = parcelRequire("3jjJr");

var $dnnKy = parcelRequire("dnnKy");

var $ewpca = parcelRequire("ewpca");

var $7qjGu = parcelRequire("7qjGu");
const $6912ed76e930cb2d$var$baseStyles = null;
const $6912ed76e930cb2d$var$backgroundStyles = null;
const $6912ed76e930cb2d$export$a8e6523ab063becd = ({ cardPreview: cardPreview, alt: alt = '', resizeMode: resizeMode = 'crop', onImageLoad: onImageLoad, onImageError: onImageError, onDisplayImage: onDisplayImage, mediaType: mediaType, nativeLazyLoad: nativeLazyLoad, forceSyncDisplay: forceSyncDisplay, identifier: identifier, wrapperRef: wrapperRef, useWhiteBackground: useWhiteBackground, testId: testId })=>{
    const onDisplayImageRef = (0, $dnnKy.useCurrentValueRef)(onDisplayImage);
    (0, $5uXOq.useEffect)(()=>{
        if (mediaType === 'image') onDisplayImageRef.current?.();
    }, [
        mediaType,
        onDisplayImageRef
    ]);
    const [didRender, setDidRender] = (0, $5uXOq.useState)(false);
    const [resolvedDimensions, setResolvedDimensions] = (0, $5uXOq.useState)((0, $3jjJr.calculateInitialDimensions)(resizeMode));
    const imgRef = (0, $5uXOq.useRef)(null);
    const onLoad = (evt)=>{
        wrapperRef.current && setResolvedDimensions((0, $3jjJr.calculateDimensions)(evt.currentTarget, wrapperRef.current, resizeMode));
        setDidRender(true);
        cardPreview && onImageLoad?.(cardPreview);
    };
    const onError = ()=>{
        onImageError && cardPreview && onImageError(cardPreview);
    };
    (0, $5uXOq.useEffect)(()=>{
        if (imgRef.current && wrapperRef.current && imgRef.current) setResolvedDimensions((0, $3jjJr.calculateDimensions)(imgRef.current, wrapperRef.current, resizeMode));
    }, [
        resizeMode,
        wrapperRef
    ]);
    return cardPreview ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ewpca.ImageRendererWrapper), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
            ref: imgRef,
            "data-testid": testId,
            "data-fileid": (0, $7qjGu.isFileIdentifier)(identifier) ? identifier.id : null,
            "data-filecollection": (0, $7qjGu.isFileIdentifier)(identifier) ? identifier.collectionName : null,
            "data-resizemode": resizeMode,
            "data-source": cardPreview.source,
            src: cardPreview.dataURI,
            alt: alt,
            onLoad: onLoad,
            onError: onError,
            loading: nativeLazyLoad ? 'lazy' : undefined,
            style: {
                visibility: didRender || forceSyncDisplay ? 'visible' : 'hidden',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...resolvedDimensions
            },
            className: (0, $bwpsq.default)([
                "_5ral1f51",
                useWhiteBackground && "_bfhku67f"
            ])
        })
    }) : null;
};

});
parcelRegister("3jjJr", function(module, exports) {

$parcel$export(module.exports, "calculateDimensions", () => $b3ac2669a0348a49$export$da67e68efa508cf6);
$parcel$export(module.exports, "calculateInitialDimensions", () => $b3ac2669a0348a49$export$6e6f68a4ed3ceffe);
const $b3ac2669a0348a49$export$da67e68efa508cf6 = (imgElement, parentElement, resizeMode)=>{
    const { naturalWidth: naturalWidth, width: width, naturalHeight: naturalHeight, height: height } = imgElement;
    // Firefox & Safari can't always read the "natural" dimensions correctly.
    // When these are undefined or zero, we replace them with the rendered values
    const imgWidth = naturalWidth || width;
    const imgHeight = naturalHeight || height;
    const { width: parentWidth, height: parentHeight } = parentElement.getBoundingClientRect();
    if (resizeMode === 'fit' || resizeMode === 'full-fit') return {
        maxWidth: `min(100%, ${imgWidth}px)`,
        maxHeight: `min(100%, ${imgHeight}px)`
    };
    const imgRatio = imgWidth / imgHeight;
    const cardRatio = parentWidth / parentHeight;
    const isImageLandscapier = imgRatio > cardRatio;
    if (resizeMode === 'stretchy-fit') {
        if (isImageLandscapier) return {
            width: '100%',
            maxHeight: '100%'
        };
        else return {
            height: '100%',
            maxWidth: '100%'
        };
    }
    if (resizeMode === 'crop') {
        if (isImageLandscapier) return {
            height: imgHeight,
            maxHeight: '100%'
        };
        else return {
            width: imgWidth,
            maxWidth: '100%'
        };
    }
    return {};
};
const $b3ac2669a0348a49$export$6e6f68a4ed3ceffe = (resizeMode)=>{
    if (resizeMode === 'fit' || resizeMode === 'full-fit') return {
        maxWidth: `100%`,
        maxHeight: `100%`
    };
    if (resizeMode === 'stretchy-fit') // assume the image is landscape
    return {
        width: '100%',
        maxHeight: '100%'
    };
    // resizeMode === 'crop'
    // assume the image is landscape
    return {
        width: '100%'
    };
};

});

parcelRegister("ewpca", function(module, exports) {

$parcel$export(module.exports, "ImageRendererWrapper", () => $b517d378eb14aadc$export$e2adeb4aa5a3be1d);
/* wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $b517d378eb14aadc$var$wrapperStyles = null;
const $b517d378eb14aadc$export$e2adeb4aa5a3be1d = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": "ImageRendererWrapper",
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"
        ]),
        children: children
    });

});



parcelRegister("8uJVP", function(module, exports) {

$parcel$export(module.exports, "TitleBox", () => $23f68c7a2076330b$export$e3ce443f3b72c291);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $hlfFr = parcelRequire("hlfFr");

var $4lTz8 = parcelRequire("4lTz8");

var $ajw2o = parcelRequire("ajw2o");

var $4W3CS = parcelRequire("4W3CS");
const $23f68c7a2076330b$var$placeholderText = ' ';
const $23f68c7a2076330b$var$isValidTimestamp = (timeStamp)=>new Date(timeStamp).getTime() > 0;
const $23f68c7a2076330b$export$e3ce443f3b72c291 = (0, $8RXs9.default)(({ name: name, createdAt: createdAt, breakpoint: breakpoint, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, hidden: hidden, intl: intl })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4W3CS.TitleBoxWrapper), {
        hidden: hidden,
        breakpoint: breakpoint,
        titleBoxBgColor: titleBoxBgColor,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4W3CS.TitleBoxHeader), {
                hasIconOverlap: !!titleBoxIcon && !createdAt,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4lTz8.Truncate), {
                    text: name ?? $23f68c7a2076330b$var$placeholderText
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4W3CS.TitleBoxFooter), {
                hasIconOverlap: !!titleBoxIcon,
                children: createdAt !== undefined && $23f68c7a2076330b$var$isValidTimestamp(createdAt) ? (0, $ajw2o.formatDate)(createdAt, intl?.locale ?? 'en') : $23f68c7a2076330b$var$placeholderText
            }),
            titleBoxIcon === 'LockFilledIcon' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4W3CS.TitleBoxIcon), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hlfFr))), {
                    color: "currentColor",
                    label: "",
                    LEGACY_size: "small"
                })
            })
        ]
    }), {
    enforceContext: false
});

});
parcelRegister("hlfFr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::12e887978e067f283b075051c47472cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca008d0d568989f5$var$_react = $ca008d0d568989f5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ca008d0d568989f5$var$_lockLocked = $ca008d0d568989f5$var$_interopRequireDefault((parcelRequire("3SxCI")));

var $ca008d0d568989f5$var$_lockFilled = $ca008d0d568989f5$var$_interopRequireDefault((parcelRequire("gs7PQ")));
function $ca008d0d568989f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockFilledIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for indicating something is locked in the side navigation Menu Item.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ca008d0d568989f5$var$LockLockedIcon = (props)=>/*#__PURE__*/ $ca008d0d568989f5$var$_react.default.createElement($ca008d0d568989f5$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $ca008d0d568989f5$var$_lockFilled.default
    }, props));
$ca008d0d568989f5$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $ca008d0d568989f5$var$_default = module.exports.default = $ca008d0d568989f5$var$LockLockedIcon;

});
parcelRegister("3SxCI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68229889f75a07fa608250b88614c064>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2d307f299c609106$var$_react = $2d307f299c609106$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2d307f299c609106$var$_baseNew = $2d307f299c609106$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $2d307f299c609106$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for indicating something is locked in the side navigation Menu Item.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2d307f299c609106$var$LockLockedIcon = (props)=>/*#__PURE__*/ $2d307f299c609106$var$_react.default.createElement($2d307f299c609106$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1.5A1.5 1.5 0 0 0 4.5 3v2.5h3V3A1.5 1.5 0 0 0 6 1.5m3 4.01V3a3 3 0 0 0-6 0v2.51c-.844.094-1.5.809-1.5 1.678v3.125c0 .931.756 1.687 1.688 1.687h5.624c.932 0 1.688-.755 1.688-1.687V7.187c0-.868-.656-1.583-1.5-1.677" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$2d307f299c609106$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $2d307f299c609106$var$_default = module.exports.default = $2d307f299c609106$var$LockLockedIcon;

});

parcelRegister("gs7PQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfa556ca72f8a34c$var$_react = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfa556ca72f8a34c$var$_lockLocked = $bfa556ca72f8a34c$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $bfa556ca72f8a34c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfa556ca72f8a34c$var$LockFilledIcon = (props)=>/*#__PURE__*/ $bfa556ca72f8a34c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0 1 12 4a4 4 0 0 1 4 4.002V10a2 2 0 0 1 2 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 0 1 6 18v-6c0-1.102.897-1.995 2-2m2 0h4V8.002A2 2 0 0 0 12 6c-1.102 0-2 .898-2 2.002zm2 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/></svg>`
    }, props, {
        newIcon: $bfa556ca72f8a34c$var$_lockLocked.default
    }));
$bfa556ca72f8a34c$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $bfa556ca72f8a34c$var$_default = module.exports.default = $bfa556ca72f8a34c$var$LockFilledIcon;

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});



parcelRegister("4lTz8", function(module, exports) {

$parcel$export(module.exports, "Truncate", () => $68402c358f5f2495$export$cf4c160b6f7612df);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5uXm6 = parcelRequire("5uXm6");

var $4fD7E = parcelRequire("4fD7E");

var $VSDnB = parcelRequire("VSDnB");
const $68402c358f5f2495$export$cf4c160b6f7612df = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4fD7E.Truncate), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXm6.Truncate), {
        ...props
    });
const $68402c358f5f2495$export$79559b74b73162c4 = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4fD7E.TruncateLeft), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXm6.TruncateLeft), {
        ...props
    });
const $68402c358f5f2495$export$59f20ffe54d328be = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4fD7E.TruncateRight), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXm6.TruncateRight), {
        ...props
    });

});
parcelRegister("5uXm6", function(module, exports) {

$parcel$export(module.exports, "TruncateLeft", () => $c2750f2832e788bd$export$79559b74b73162c4);
$parcel$export(module.exports, "TruncateRight", () => $c2750f2832e788bd$export$59f20ffe54d328be);
$parcel$export(module.exports, "Truncate", () => $c2750f2832e788bd$export$cf4c160b6f7612df);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $4fD7E = parcelRequire("4fD7E");

var $bWGt6 = parcelRequire("bWGt6");
const $c2750f2832e788bd$var$truncateCommonStyles = `
  display: inline-block;
  vertical-align: bottom;
  white-space: nowrap;
  overflow: hidden;
`;
const $c2750f2832e788bd$export$79559b74b73162c4 = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ery3jaq1"
})($c2750f2832e788bd$var$truncateCommonStyles, " max-width:calc(100% - ", ({ fontSizePX: fontSizePX, endFixedChars: endFixedChars })=>$c2750f2832e788bd$var$fontFaceScaleFactor(fontSizePX) * endFixedChars + 1, "em);min-width:", ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars })=>$c2750f2832e788bd$var$fontFaceScaleFactor(fontSizePX) * startFixedChars, ";text-overflow:ellipsis;");
const $c2750f2832e788bd$export$59f20ffe54d328be = /*#__PURE__*/ (0, $bWGt6.default)("span", {
    target: "ery3jaq0"
})($c2750f2832e788bd$var$truncateCommonStyles, " max-width:calc(100% - ", ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars })=>$c2750f2832e788bd$var$fontFaceScaleFactor(fontSizePX) * startFixedChars, ");position:relative;");
const $c2750f2832e788bd$var$fontFaceScaleFactor = (fontSizePX)=>fontSizePX / 11 * 0.46; /* factor for fontSize of 11px */ 
const $c2750f2832e788bd$var$placeholder = ' ';
const $c2750f2832e788bd$export$cf4c160b6f7612df = ({ text: text, fontSizePX: fontSizePX = 11, startFixedChars: // Must be calibrated with fontSize
startFixedChars = 4, endFixedChars: // 1 char + 3 dots
endFixedChars = 7 // file extension 3/4 chars + a fraction of the name
 })=>{
    const { left: leftStr, right: rightStr } = (0, $4fD7E.calculateTruncation)(text, startFixedChars, endFixedChars);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($c2750f2832e788bd$export$79559b74b73162c4, {
                fontSizePX: fontSizePX,
                startFixedChars: startFixedChars,
                endFixedChars: endFixedChars,
                "data-testid": "truncate-left",
                children: leftStr
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($c2750f2832e788bd$export$59f20ffe54d328be, {
                fontSizePX: fontSizePX,
                startFixedChars: startFixedChars,
                endFixedChars: endFixedChars,
                "data-testid": "truncate-right",
                children: leftStr === rightStr ? $c2750f2832e788bd$var$placeholder : rightStr
            })
        ]
    });
};

});
parcelRegister("4fD7E", function(module, exports) {

$parcel$export(module.exports, "calculateTruncation", () => $6a96659865ba353e$export$76bc6de55c805afb);
$parcel$export(module.exports, "TruncateLeft", () => $6a96659865ba353e$export$79559b74b73162c4);
$parcel$export(module.exports, "TruncateRight", () => $6a96659865ba353e$export$59f20ffe54d328be);
$parcel$export(module.exports, "Truncate", () => $6a96659865ba353e$export$cf4c160b6f7612df);
/* truncateText-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $6a96659865ba353e$export$76bc6de55c805afb = (text, startFixedChars, endFixedChars)=>{
    const minAllowedLength = endFixedChars + startFixedChars;
    if (text.length <= minAllowedLength) // if no truncation return same value for left and right
    return {
        left: text,
        right: text
    };
    const splitAt = text.length - endFixedChars;
    const left = text.substr(0, splitAt);
    const right = text.substr(splitAt);
    return {
        left: left,
        right: right
    };
};
const $6a96659865ba353e$var$truncateCommonStyles = null;
const $6a96659865ba353e$var$truncateLeftStyles = null;
const $6a96659865ba353e$export$79559b74b73162c4 = ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars, endFixedChars: endFixedChars, children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            maxWidth: `calc(
		100% -
			${$6a96659865ba353e$var$fontFaceScaleFactor(fontSizePX) * endFixedChars + 1}em
	)`,
            minWidth: $6a96659865ba353e$var$fontFaceScaleFactor(fontSizePX) * startFixedChars
        },
        "data-testid": "truncate-left",
        ...props,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _s7n4yfq0 _o5721q9c",
            "_1bto1l2s"
        ]),
        children: children
    });
const $6a96659865ba353e$var$truncateRightStyles = null;
const $6a96659865ba353e$export$59f20ffe54d328be = ({ fontSizePX: fontSizePX, startFixedChars: startFixedChars, endFixedChars: endFixedChars, children: children, ...props })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        style: {
            maxWidth: `calc(
				100% -
					${({ fontSizePX: fontSizePX, startFixedChars: startFixedChars })=>$6a96659865ba353e$var$fontFaceScaleFactor(fontSizePX) * startFixedChars}
			)`
        },
        "data-testid": "truncate-right",
        ...props,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _s7n4yfq0 _o5721q9c",
            "_kqswh2mm"
        ]),
        children: children
    });
const $6a96659865ba353e$var$fontFaceScaleFactor = (fontSizePX)=>fontSizePX / 11 * 0.46; /* factor for fontSize of 11px */ 
const $6a96659865ba353e$var$placeholder = ' ';
const $6a96659865ba353e$export$cf4c160b6f7612df = ({ text: text, fontSizePX: fontSizePX = 11, startFixedChars: // Must be calibrated with fontSize
startFixedChars = 4, endFixedChars: // 1 char + 3 dots
endFixedChars = 7 // file extension 3/4 chars + a fraction of the name
 })=>{
    const { left: leftStr, right: rightStr } = $6a96659865ba353e$export$76bc6de55c805afb(text, startFixedChars, endFixedChars);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($6a96659865ba353e$export$79559b74b73162c4, {
                fontSizePX: fontSizePX,
                startFixedChars: startFixedChars,
                endFixedChars: endFixedChars,
                children: leftStr
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)($6a96659865ba353e$export$59f20ffe54d328be, {
                fontSizePX: fontSizePX,
                startFixedChars: startFixedChars,
                endFixedChars: endFixedChars,
                children: leftStr === rightStr ? $6a96659865ba353e$var$placeholder : rightStr
            })
        ]
    });
};

});



parcelRegister("ajw2o", function(module, exports) {

$parcel$export(module.exports, "formatDate", () => $070766af7cdc291f$export$3ae94a2503e890a1);

var $7qZ1x = parcelRequire("7qZ1x");
const $070766af7cdc291f$export$f34a3540a1aa68e4 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
};
const $070766af7cdc291f$export$20911720278c41 = ({ day: day, month: month, year: year, hour: hour, minute: minute, dayPeriod: dayPeriod = '' })=>{
    const formattedDayPeriod = dayPeriod.replace(/\./g, '').replace(/\s/g, '');
    return `${day} ${month} ${year}, ${hour}:${minute} ${formattedDayPeriod}`;
};
const $070766af7cdc291f$export$3ae94a2503e890a1 = (timestamp, locale = 'en')=>{
    const l10n = (0, $7qZ1x.createLocalizationProvider)(locale, $070766af7cdc291f$export$f34a3540a1aa68e4);
    return $070766af7cdc291f$export$20911720278c41(l10n.formatToParts(timestamp));
};

});
parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $is0Fy.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $lCAti = parcelRequire("lCAti");

var $3wYKB = parcelRequire("3wYKB");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});



parcelRegister("4W3CS", function(module, exports) {

$parcel$export(module.exports, "TitleBoxWrapper", () => $66eb7277fe58210d$export$213c428ce4ec143c);
$parcel$export(module.exports, "TitleBoxHeader", () => $66eb7277fe58210d$export$43970d913b015380);
$parcel$export(module.exports, "TitleBoxFooter", () => $66eb7277fe58210d$export$1004da4fc5583975);
$parcel$export(module.exports, "TitleBoxIcon", () => $66eb7277fe58210d$export$70e996312f72d22d);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $66eb7277fe58210d$export$9e874bb1adc98a55);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $1i0jO = parcelRequire("1i0jO");

var $galQf = parcelRequire("galQf");
const $66eb7277fe58210d$export$213c428ce4ec143c = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1i0jO.TitleBoxWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $galQf.TitleBoxWrapper), {
        ...props
    });
const $66eb7277fe58210d$export$43970d913b015380 = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1i0jO.TitleBoxHeader), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $galQf.TitleBoxHeader), {
        ...props
    });
const $66eb7277fe58210d$export$1004da4fc5583975 = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1i0jO.TitleBoxFooter), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $galQf.TitleBoxFooter), {
        ...props
    });
const $66eb7277fe58210d$export$70e996312f72d22d = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1i0jO.TitleBoxIcon), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $galQf.TitleBoxIcon), {
        ...props
    });
const $66eb7277fe58210d$export$9e874bb1adc98a55 = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1i0jO.ErrorMessageWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $galQf.ErrorMessageWrapper), {
        ...props
    });

});
parcelRegister("1i0jO", function(module, exports) {

$parcel$export(module.exports, "TitleBoxWrapper", () => $7801647b7b6c9469$export$213c428ce4ec143c);
$parcel$export(module.exports, "TitleBoxHeader", () => $7801647b7b6c9469$export$43970d913b015380);
$parcel$export(module.exports, "TitleBoxFooter", () => $7801647b7b6c9469$export$1004da4fc5583975);
$parcel$export(module.exports, "TitleBoxIcon", () => $7801647b7b6c9469$export$70e996312f72d22d);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $7801647b7b6c9469$export$9e874bb1adc98a55);
/* titleBoxComponents-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");


var $gC46K = parcelRequire("gC46K");
const $7801647b7b6c9469$var$smallLineHeight = 14;
const $7801647b7b6c9469$var$smallVerticalPadding = 4;
const $7801647b7b6c9469$var$smallHorizontalPadding = 8;
const $7801647b7b6c9469$var$largeLineHeight = 22;
const $7801647b7b6c9469$var$largeVerticalPadding = 8;
const $7801647b7b6c9469$var$largeHorizontalPadding = 12;
const $7801647b7b6c9469$var$responsiveStyleMap = {
    small: "_ca0q1y44 _u5f3ftgi _n3td1y44 _19bvftgi _4t3i14no",
    large: "_ca0qftgi _u5f31crf _n3tdftgi _19bv1crf _4t3i1wqb"
};
const $7801647b7b6c9469$var$HEX_REGEX = /^#[0-9A-F]{6}$/i;
const $7801647b7b6c9469$var$titleBoxWrapperStyles = null;
const $7801647b7b6c9469$export$213c428ce4ec143c = (props)=>{
    const { breakpoint: breakpoint, titleBoxBgColor: titleBoxBgColor, hidden: hidden } = props;
    const color = titleBoxBgColor && (0, $gC46K.rgba)($7801647b7b6c9469$var$HEX_REGEX.test(titleBoxBgColor) ? titleBoxBgColor : (0, $829f609a65d26a98$export$29a4f05edc054374), 1);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: "titleBoxWrapper",
        "data-testid": "media-title-box",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            backgroundColor: color,
            display: hidden ? 'none' : undefined
        },
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_kqswstnw _94n5idpf _1bsb1osq _bfhkvuon _syaz1fxt _80om1kw7 _lcxvglyw _1e0c1txw _2lx21bp4 _1bah1h6o",
            $7801647b7b6c9469$var$responsiveStyleMap[breakpoint]
        ]),
        children: props.children
    });
};
$7801647b7b6c9469$export$213c428ce4ec143c.displayName = 'TitleBoxWrapper';
const $7801647b7b6c9469$var$infoStyles = null;
const $7801647b7b6c9469$var$iconOverlapStyle = null;
const $7801647b7b6c9469$var$titleBoxHeaderStyles = null;
const $7801647b7b6c9469$export$43970d913b015380 = (props)=>{
    const { hasIconOverlap: hasIconOverlap } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: "titleBoxHeader",
        "data-testid": "title-box-header",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_k48p1pd9",
            "_1reo15vq _18m915vq _o5721q9c",
            hasIconOverlap && "_u5f319bv"
        ]),
        children: props.children
    });
};
$7801647b7b6c9469$export$43970d913b015380.displayName = 'FailedTitleBoxHeader';
const $7801647b7b6c9469$var$titleBoxFooterStyles = null;
const $7801647b7b6c9469$export$1004da4fc5583975 = (props)=>{
    const { hasIconOverlap: hasIconOverlap } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: "titleBoxFooter",
        "data-testid": "title-box-footer",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1bto1l2s",
            "_1reo15vq _18m915vq _o5721q9c",
            hasIconOverlap && "_u5f319bv"
        ]),
        children: props.children
    });
};
$7801647b7b6c9469$export$1004da4fc5583975.displayName = 'TitleBoxFooter';
const $7801647b7b6c9469$var$titleBoxIconStyles = null;
const $7801647b7b6c9469$var$newTitleBoxIconStyles = null;
const $7801647b7b6c9469$export$70e996312f72d22d = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: "titleBoxIcon",
        "data-testid": "title-box-icon",
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-visual-refresh-icons') && "_kqswstnw _1xi21b66 _94n51b66",
            !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_kqswstnw _1xi21b66 _94n5idpf"
        ]),
        children: props.children
    });
};
const $7801647b7b6c9469$var$errorMessageWrapperStyles = null;
const $7801647b7b6c9469$export$9e874bb1adc98a55 = (props)=>{
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_zulpv77o _1e0c1txw _4cvr1h6o _1bah1y6m _bozgv77o _e4kmnkob _1nm41b66 _184u1b66"
        ]),
        children: props.children
    });
};

});
parcelRegister("gC46K", function(module, exports) {

$parcel$export(module.exports, "calcBreakpointSize", () => $10de97f98d8e51a0$export$e1417862e51f29fd);
$parcel$export(module.exports, "generateResponsiveStyles", () => $10de97f98d8e51a0$export$bb6eded75bc31192);
$parcel$export(module.exports, "getWrapperDimensions", () => $10de97f98d8e51a0$export$eef272c84d43db07);
$parcel$export(module.exports, "getWrapperShadow", () => $10de97f98d8e51a0$export$c180fc73343eee05);
$parcel$export(module.exports, "getCursorStyle", () => $10de97f98d8e51a0$export$fa35f3322c52262f);
$parcel$export(module.exports, "getClickablePlayButtonStyles", () => $10de97f98d8e51a0$export$38af25052ecc50f9);
$parcel$export(module.exports, "getSelectableTickBoxStyles", () => $10de97f98d8e51a0$export$364272ae84df16a);
$parcel$export(module.exports, "transition", () => $10de97f98d8e51a0$export$66bb15e2994e6a26);
$parcel$export(module.exports, "rgba", () => $10de97f98d8e51a0$export$4e46ac54fc82cf3b);


var $iHYdz = parcelRequire("iHYdz");

var $VSDnB = parcelRequire("VSDnB");

var $a52gQ = parcelRequire("a52gQ");

var $kwmmf = parcelRequire("kwmmf");

var $hECXM = parcelRequire("hECXM");

var $eWD2s = parcelRequire("eWD2s");

var $aQrxl = parcelRequire("aQrxl");
const $10de97f98d8e51a0$var$breakpointSizes = [
    [
        (0, $aQrxl.Breakpoint).SMALL,
        599
    ],
    [
        (0, $aQrxl.Breakpoint).LARGE,
        Infinity
    ]
];
const $10de97f98d8e51a0$export$e1417862e51f29fd = (wrapperWidth = 0)=>{
    const [breakpoint] = $10de97f98d8e51a0$var$breakpointSizes.find(([_breakpoint, limit])=>wrapperWidth <= limit) || [
        (0, $aQrxl.Breakpoint).SMALL
    ];
    return breakpoint;
};
const $10de97f98d8e51a0$export$bb6eded75bc31192 = (breakpoint = (0, $aQrxl.Breakpoint).SMALL)=>{
    const setting = (0, $aQrxl.responsiveSettings)[breakpoint];
    return `
    font-size: ${setting.fontSize}px;
    line-height: ${setting.lineHeight}px;
  `;
};
const $10de97f98d8e51a0$export$eef272c84d43db07 = (dimensions, appearance)=>{
    const { width: width, height: height } = dimensions || {};
    const { width: defaultWidth, height: defaultHeight } = (0, $kwmmf.getDefaultCardDimensions)(appearance);
    return `
     ${(0, $VSDnB.fg)('platform_fix_media_image_resizing') ? `@container view-page-content (min-width: 1px) { width: 100cqw; }` : ''}
	/* If container doesn't exists, it will fallback to this */
	width: ${(0, $a52gQ.getCSSUnitValue)(width || defaultWidth)};

    max-width: 100%;
    height: ${(0, $a52gQ.getCSSUnitValue)(height || defaultHeight)};
    max-height: 100%;
  `;
};
const $10de97f98d8e51a0$export$c180fc73343eee05 = (disableOverlay, selected)=>{
    const withOverlayShadow = !disableOverlay ? `${`var(--ds-shadow-raised, ${`0 1px 1px ${0, $829f609a65d26a98$export$d2d3bedfb276cac0}, 0 0 1px 0 ${0, $829f609a65d26a98$export$d2d3bedfb276cac0}`})`}` : '';
    const selectedShadow = selected ? (0, $iHYdz.akEditorSelectedBoxShadow) : '';
    const shadow = [
        selectedShadow,
        withOverlayShadow
    ].filter(Boolean).join(', ');
    return shadow ? `box-shadow: ${shadow};` : '';
};
const $10de97f98d8e51a0$export$fa35f3322c52262f = (cursor)=>!!cursor ? `cursor: ${cursor};` : '';
const $10de97f98d8e51a0$export$38af25052ecc50f9 = (isPlayButtonClickable)=>{
    if (!isPlayButtonClickable) return '';
    return `
    &:hover .${0, $eWD2s.playButtonClassName} {
      ${0, $eWD2s.fixedPlayButtonStyles}
    }
  `;
};
const $10de97f98d8e51a0$export$364272ae84df16a = (isTickBoxSelectable)=>{
    if (!isTickBoxSelectable) return '';
    return `
    &:hover .${0, $hECXM.tickBoxClassName} {
      ${0, $hECXM.tickboxFixedStyles}
    }
  `;
};
const $10de97f98d8e51a0$var$defaultTransitionDuration = '.3s';
const $10de97f98d8e51a0$export$66bb15e2994e6a26 = (propertyName = 'all')=>`
  transition: ${propertyName} ${$10de97f98d8e51a0$var$defaultTransitionDuration};
`;
const $10de97f98d8e51a0$var$hexToRgb = (hex)=>{
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? `${parseInt(result[1], 16)},${parseInt(result[2], 16)},${parseInt(result[3], 16)}` : null;
};
const $10de97f98d8e51a0$export$4e46ac54fc82cf3b = (hex, opacity)=>`rgba(${$10de97f98d8e51a0$var$hexToRgb(hex)}, ${opacity})`;

});
parcelRegister("iHYdz", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $01f0a5ace820da37$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $01f0a5ace820da37$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $01f0a5ace820da37$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $01f0a5ace820da37$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $01f0a5ace820da37$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $01f0a5ace820da37$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $01f0a5ace820da37$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $01f0a5ace820da37$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $01f0a5ace820da37$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $01f0a5ace820da37$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $01f0a5ace820da37$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $01f0a5ace820da37$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $01f0a5ace820da37$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $01f0a5ace820da37$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBoldBoxShadow", () => $01f0a5ace820da37$export$37e178ca41c198ca);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $01f0a5ace820da37$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $01f0a5ace820da37$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $01f0a5ace820da37$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $01f0a5ace820da37$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $01f0a5ace820da37$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $01f0a5ace820da37$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $01f0a5ace820da37$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $01f0a5ace820da37$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $01f0a5ace820da37$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $01f0a5ace820da37$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $01f0a5ace820da37$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $01f0a5ace820da37$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $01f0a5ace820da37$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $01f0a5ace820da37$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $01f0a5ace820da37$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $01f0a5ace820da37$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $01f0a5ace820da37$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $01f0a5ace820da37$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $01f0a5ace820da37$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $01f0a5ace820da37$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $01f0a5ace820da37$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPadding", () => $01f0a5ace820da37$export$6e0f4d52efd3d2d);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $01f0a5ace820da37$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $01f0a5ace820da37$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $01f0a5ace820da37$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $01f0a5ace820da37$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $01f0a5ace820da37$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $01f0a5ace820da37$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $01f0a5ace820da37$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $01f0a5ace820da37$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $01f0a5ace820da37$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidthSmallViewport", () => $01f0a5ace820da37$export$60da500206e2ceec);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $01f0a5ace820da37$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $01f0a5ace820da37$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $01f0a5ace820da37$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $01f0a5ace820da37$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorToolbarKeylineHeight", () => $01f0a5ace820da37$export$d29cb2c31fcbb7c5);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $01f0a5ace820da37$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $01f0a5ace820da37$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $01f0a5ace820da37$export$de3cef07cda55645);
$parcel$export(module.exports, "akEditorWrappedNodeZIndex", () => $01f0a5ace820da37$export$e88f6c898960b391);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $01f0a5ace820da37$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $01f0a5ace820da37$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $01f0a5ace820da37$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $01f0a5ace820da37$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $01f0a5ace820da37$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $01f0a5ace820da37$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $01f0a5ace820da37$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $01f0a5ace820da37$export$59733a9f61449b25);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $01f0a5ace820da37$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "participantColors", () => $01f0a5ace820da37$export$42608c013398a830);

var $VSDnB = parcelRequire("VSDnB");

var $gmhCD = parcelRequire("gmhCD");
const $01f0a5ace820da37$export$fe6b0b821a0e9067 = 16;
const $01f0a5ace820da37$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $01f0a5ace820da37$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$a7a75e50ae62d0a8 = "var(--ds-border, #091E4224)";
const $01f0a5ace820da37$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$f0e953d95429ca1 = '12px';
const $01f0a5ace820da37$export$a309dbdeca0adb1a = '2px 4px';
const $01f0a5ace820da37$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $01f0a5ace820da37$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $01f0a5ace820da37$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $01f0a5ace820da37$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $01f0a5ace820da37$export$d2715266dd4a1fd1 = 20;
const $01f0a5ace820da37$export$cf524c1b49838a49 = "var(--ds-border-selected, #0C66E4)";
const $01f0a5ace820da37$export$8dac549e32469ac4 = 1;
const $01f0a5ace820da37$export$befaaae517e3d864 = 2;
const $01f0a5ace820da37$export$6e1e1996c4e8cc51 = `${$01f0a5ace820da37$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$b6a59ac3a19b6343 = `0 0 0 ${$01f0a5ace820da37$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$37e178ca41c198ca = `0 0 0 ${$01f0a5ace820da37$export$befaaae517e3d864}px ${"var(--ds-border-selected, #0C66E4)"}`;
const $01f0a5ace820da37$export$4a007c22e25e31f6 = 0.3;
const $01f0a5ace820da37$export$f35cc48f3398ab79 = 1;
const $01f0a5ace820da37$export$b46cda584c619451 = 2;
const $01f0a5ace820da37$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $01f0a5ace820da37$export$321ddd2f049dd12 = $01f0a5ace820da37$export$6bed85de54b5de42 + 1;
const $01f0a5ace820da37$export$daeac9b8422ac3c2 = 2;
const $01f0a5ace820da37$export$501d46e11ed5bf73 = 500;
const $01f0a5ace820da37$export$6817b4b6a5ef78f1 = 400;
const $01f0a5ace820da37$export$93768eb72dec48ce = $01f0a5ace820da37$export$501d46e11ed5bf73 + 10;
const $01f0a5ace820da37$export$c0aec4e0896849a0 = $01f0a5ace820da37$export$93768eb72dec48ce - 5;
const $01f0a5ace820da37$export$5886f057e4f21fe4 = $01f0a5ace820da37$export$6817b4b6a5ef78f1 + 5;
const $01f0a5ace820da37$export$6e85faa46d537a3f = 11;
const $01f0a5ace820da37$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DCDFE4)";
const $01f0a5ace820da37$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $01f0a5ace820da37$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $01f0a5ace820da37$export$95e9a0285b97474d = '#2C333A';
const $01f0a5ace820da37$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #388BFF)";
const $01f0a5ace820da37$export$76b5e653883e5290 = '3px';
const $01f0a5ace820da37$export$6d85fe8177a50c0c = 0.5;
const $01f0a5ace820da37$export$fad19f16d3f953a3 = 680;
const $01f0a5ace820da37$export$9db045950eedb49f = 760;
const $01f0a5ace820da37$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $01f0a5ace820da37$export$f580e3d28d0986de = 1800;
const $01f0a5ace820da37$export$9d5488b5afad62bf = 1792;
const $01f0a5ace820da37$export$37df10057d36a0e5 = 42;
const $01f0a5ace820da37$export$437293c5e9fc2703 = 96;
const $01f0a5ace820da37$export$6e0f4d52efd3d2d = 32;
const $01f0a5ace820da37$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $VSDnB.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $01f0a5ace820da37$export$efe8561bbd3f74d2 = 720;
const $01f0a5ace820da37$export$e4d39a9e8607c1d3 = 48;
const $01f0a5ace820da37$export$43946f2400ab6f1f = 128;
const $01f0a5ace820da37$export$558438ae7fd4b8ce = 12;
const $01f0a5ace820da37$export$6beb98d32d4ca149 = 4;
const $01f0a5ace820da37$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $01f0a5ace820da37$export$5edb4f38c3eacb1a = 1024;
const $01f0a5ace820da37$export$e60820063058ed59 = 1.33;
const $01f0a5ace820da37$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $01f0a5ace820da37$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $01f0a5ace820da37$export$fb15fade89f67217 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 99;
const $01f0a5ace820da37$export$847030921e9d5a40 = 12;
const $01f0a5ace820da37$export$40eb41ab799f0329 = 1.714;
const $01f0a5ace820da37$export$e271312fc7124aec = '1px';
const $01f0a5ace820da37$export$d29cb2c31fcbb7c5 = 2;
const $01f0a5ace820da37$export$688a6dc01e760755 = 320;
const $01f0a5ace820da37$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $01f0a5ace820da37$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $01f0a5ace820da37$export$e88f6c898960b391 = $01f0a5ace820da37$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $01f0a5ace820da37$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $01f0a5ace820da37$export$1d0d506416d457f1 = '0.75rem';
const $01f0a5ace820da37$export$e683ef42725d1713 = 680;
const $01f0a5ace820da37$export$226c784ba04bd04b = 480;
const $01f0a5ace820da37$export$214ff00e5618d86c = 20;
const $01f0a5ace820da37$export$c82675fa56f2eefd = '56px';
const $01f0a5ace820da37$var$DEFAULT_FONT_SIZE = 14;
const $01f0a5ace820da37$export$d7726a000ae2d7c = ()=>{
    if ((0, $gmhCD.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    if ((0, $VSDnB.fg)('live_pages_content_jump_mitigation')) return '2.188rem';
    return "var(--ds-space-500, 40px)";
};
const $01f0a5ace820da37$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $01f0a5ace820da37$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $01f0a5ace820da37$var$DEFAULT_FONT_SIZE;
const $01f0a5ace820da37$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$01f0a5ace820da37$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $01f0a5ace820da37$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $01f0a5ace820da37$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $01f0a5ace820da37$export$9369fd010fa0ddd6 = 0;
const $01f0a5ace820da37$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $01f0a5ace820da37$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $01f0a5ace820da37$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E56910)",
    "var(--ds-background-accent-orange-bolder-hovered, #A54800)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #1D7AFC)",
    "var(--ds-background-accent-blue-bolder-hovered, #0055CC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #8270DB)",
    "var(--ds-background-accent-purple-bolder-hovered, #5E4DB2)",
    "var(--ds-icon-accent-gray, #758195)",
    "var(--ds-background-accent-gray-bolder-hovered, #44546F)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #533F04)"
];
const $01f0a5ace820da37$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #626F86)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)"
    }
];

});
parcelRegister("gmhCD", function(module, exports) {

$parcel$export(module.exports, "editorExperiment", () => $a90e6fd79e0e0cb2$export$9b7cf3b74f250027);
$parcel$export(module.exports, "unstable_editorExperimentParam", () => $a90e6fd79e0e0cb2$export$92316ae898e357eb);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $iEN9D = parcelRequire("iEN9D");

var $hdkTE = parcelRequire("hdkTE");

var $a0Psj = parcelRequire("a0Psj");
function $a90e6fd79e0e0cb2$export$9b7cf3b74f250027(experimentName, expectedExperimentValue, options = {
    exposure: false
}) {
    const experimentConfig = (0, $hdkTE.editorExperimentsConfig)[experimentName];
    if ((0, $a0Psj._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._overrides)[experimentName] === expectedExperimentValue;
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if (!(0, $a0Psj._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return experimentConfig.defaultValue === expectedExperimentValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig?.productKeys?.[0, $a0Psj._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return (0, $hdkTE.editorExperimentsConfig)[experimentName]?.defaultValue === expectedExperimentValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(// @ts-ignore
    experimentKey, experimentConfig.param, experimentConfig.defaultValue, {
        typeGuard: experimentConfig.typeGuard,
        fireExperimentExposure: options.exposure
    });
    return expectedExperimentValue === experimentValue;
}
function $a90e6fd79e0e0cb2$export$92316ae898e357eb(experimentName, paramName, options) {
    if ((0, $a0Psj._paramOverrides)[experimentName]?.[paramName] !== undefined) // This will be hit in the case of a test setting an override
    return (0, $a0Psj._paramOverrides)[experimentName][paramName];
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $iEN9D.default).getExperimentValue(experimentName, paramName, options.defaultValue, {
        typeGuard: options.typeGuard,
        fireExperimentExposure: options.exposure ?? false
    });
    return experimentValue;
}

});
parcelRegister("hdkTE", function(module, exports) {

$parcel$export(module.exports, "editorExperimentsConfig", () => $7a273b3c03491c92$export$6cbb856f286b07ef);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $7rlXf = parcelRequire("7rlXf");
const $7a273b3c03491c92$export$6cbb856f286b07ef = {
    // Added 2024-08-08
    'example-boolean': (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_boolean'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-08-08
    'example-multivariate': (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package_multivariate'
        },
        param: 'variant',
        values: [
            'one',
            'two',
            'three'
        ],
        defaultValue: 'one'
    }),
    // Added 2024-08-08
    'test-new-experiments-package': (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'confluence_editor_experiment_test_new_package',
            jira: 'jira_editor_experiment_test_new_package'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-05
    support_table_in_comment: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_support_table_in_comment_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-07
    platform_editor_exp_lazy_node_views: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_exp_lazy_node_views'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-09-18
    platform_renderer_table_sticky_scrollbar: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_table_sticky_scrollbar'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-01
    comment_on_bodied_extensions: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_comment_on_bodied_extensions'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-14
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_advanced_layouts/setup
    advanced_layouts: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_layouts'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-3-15
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_single_column_layout/setup
    single_column_layouts: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_single_column_layout'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-10-08
    support_table_in_comment_jira: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            jira: 'platform_editor_support_table_in_comment_jira'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    'platform_editor_ai-prompts-placeholder': (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai-prompts-placeholder'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // added 2024-11-06
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_nested_tables/setup
    'nested-tables-in-tables': (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_nested_tables'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-11-26
    platform_editor_ai_unsplash_page_header: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_unsplash_page_header'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2024-12-05
    platform_editor_blockquote_in_text_formatting_menu: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_blockquote_in_text_formatting_menu'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-09
    platform_editor_advanced_code_blocks: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_advanced_code_blocks'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-13
    platform_editor_element_drag_and_drop_multiselect: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_element_drag_and_drop_multiselect'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-01-16
    live_pages_graceful_edit: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'live_pages_graceful_edit'
        },
        param: 'cohort',
        values: [
            'control',
            'text-click-delayed',
            'text-click-no-delay',
            'initially-hide-toolbar'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-01-19
    platform_editor_ai_edit_response_in_preview: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_edit_response_in_preview'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-02-10
    platform_editor_controls: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    platform_editor_controls_shadow: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_controls_shadow'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 28-02-2025
    platform_editor_insertion: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_insertion'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-01
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/platform_editor_vanilla_dom/setup
    platform_editor_vanilla_dom: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_vanilla_dom'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-13
    editor_text_highlight_orange_to_yellow: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_text_highlight_orange_to_yellow'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-03-28
    platform_editor_ai_proactive_ai_nudge_parameters: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'platform_editor_ai_proactive_ai_nudge_parameters'
        },
        param: 'cohort',
        values: [
            'control',
            'variant1'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-14
    // https://switcheroo.atlassian.com/ui/gates/b159b45a-86d9-4f4b-b482-f9aca5b615d6/key/platform_editor_offline_editing_web
    platform_editor_offline_editing_web: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_offline_editing_web'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-03-26
    platform_editor_markdown_next_media_plugin_exp: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_markdown_next_media_plugin_exp'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-14
    editor_ai_inline_suggestion_date_v2: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_inline_suggestion_date_v2'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-04-17
    platform_editor_tables_drag_and_drop: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_drag_and_drop'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-17
    platform_editor_tables_table_selector: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_tables_table_selector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_editor_usesharedpluginstateselector: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_usesharedpluginstateselector'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-04-23
    platform_renderer_fix_analytics_memo_callback: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_renderer_fix_analytics_memo_callback'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-05
    editor_ai_contextual_selection_toolbar_button: (0, $7rlXf.createMultivariateExperiment)({
        productKeys: {
            confluence: 'editor_ai_contextual_selection_toolbar_button'
        },
        param: 'cohort',
        values: [
            'control',
            'test'
        ],
        defaultValue: 'control'
    }),
    // Added 2025-05-07
    editor_ai_cmd_palette_remove_retry: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_cmd_palette_remove_retry'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-08
    platform_editor_core_static_emotion: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'platform_editor_core_static_emotion'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-08
    editor_ai_converge_free_gen_on_rovo: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_converge_free_gen_on_rovo'
        },
        param: 'isEnabled',
        defaultValue: false
    }),
    // Added 2025-05-13
    editor_ai_comment_freegen_rovo: (0, $7rlXf.createBooleanExperiment)({
        productKeys: {
            confluence: 'editor_ai_comment_freegen_rovo'
        },
        param: 'isEnabled',
        defaultValue: false
    })
};

});
parcelRegister("7rlXf", function(module, exports) {

$parcel$export(module.exports, "createBooleanExperiment", () => $641ded07329846f0$export$456f1587c9c92021);
$parcel$export(module.exports, "createMultivariateExperiment", () => $641ded07329846f0$export$fb89e8a786694d1);

var $9qwvi = parcelRequire("9qwvi");
function $641ded07329846f0$export$456f1587c9c92021(config) {
    return {
        ...config,
        typeGuard: (0, $9qwvi.isBoolean),
        defaultValue: config.defaultValue
    };
}
function $641ded07329846f0$export$fb89e8a786694d1(config) {
    const { values: values } = config;
    return {
        ...config,
        values: [
            ...values
        ],
        typeGuard: (0, $9qwvi.oneOf)(config.values),
        defaultValue: config.defaultValue
    };
}

});
parcelRegister("9qwvi", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $41035ee8947774ef$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "oneOf", () => $41035ee8947774ef$export$a9a18ae5ba42aeab);
function $41035ee8947774ef$export$f9ce7b637dfbe238(value) {
    return typeof value === 'boolean';
}
function $41035ee8947774ef$export$a9a18ae5ba42aeab(values) {
    function typeGuard(value) {
        return values.includes(value);
    }
    /**
	 * This is used by test utils to get the variants when running describe.each
	 */ if ($41035ee8947774ef$var$IS_TESTING_ENV) typeGuard.values = values;
    return typeGuard;
}
const $41035ee8947774ef$var$IS_TESTING_ENV = false;

});



parcelRegister("a0Psj", function(module, exports) {

$parcel$export(module.exports, "_overrides", () => $ae2371e90434836c$export$e5d73bf4f8e2ae96);
$parcel$export(module.exports, "_paramOverrides", () => $ae2371e90434836c$export$4e849416bb5c5b52);
$parcel$export(module.exports, "_product", () => $ae2371e90434836c$export$cf7305fc65acbf0d);
$parcel$export(module.exports, "setupEditorExperiments", () => $ae2371e90434836c$export$1c2b6dbf79eb3560);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json

var $hdkTE = parcelRequire("hdkTE");
let $ae2371e90434836c$export$e5d73bf4f8e2ae96 = {};
let $ae2371e90434836c$export$4e849416bb5c5b52 = {};
let $ae2371e90434836c$export$cf7305fc65acbf0d;
function $ae2371e90434836c$export$1c2b6dbf79eb3560(product, /**
	 * Overrides are used to set the group of an experiment for testing purposes.
	 * This is useful when you want to test a specific experiment group.
	 */ groupOverrides, /**
	 * Param overrides are used to set the experiment parameters for testing purposes.
	 * This is useful when you want to tweak the experiment parameters for testing.
	 */ paramOverrides) {
    if (groupOverrides) {
        // When setting up overrides, we want to ensure that experiments don't end up with invalid
        // values.
        // For production usage -- this is done via the feature flag client which takes the type
        // and performs equivalent logic.
        // @ts-ignore
        groupOverrides = Object.entries(groupOverrides).reduce((acc, [key, value])=>{
            const config = (0, $hdkTE.editorExperimentsConfig)[key];
            if (config) acc = {
                ...acc,
                [key]: config.typeGuard(value) ? value : config.defaultValue
            };
            return acc;
        }, {});
        $ae2371e90434836c$export$e5d73bf4f8e2ae96 = groupOverrides;
    }
    $ae2371e90434836c$export$cf7305fc65acbf0d = product;
    if (paramOverrides) $ae2371e90434836c$export$4e849416bb5c5b52 = paramOverrides;
}

});



parcelRegister("a52gQ", function(module, exports) {

$parcel$export(module.exports, "getCSSUnitValue", () => $f654dbc300aaf219$export$c42371b64d1354a0);
function $f654dbc300aaf219$export$c42371b64d1354a0(value) {
    return typeof value === 'string' ? value : `${value}px`;
}

});

parcelRegister("hECXM", function(module, exports) {

$parcel$export(module.exports, "tickBoxClassName", () => $002d8fc4389e10c7$export$9f1541de0780ef27);
$parcel$export(module.exports, "tickboxFixedStyles", () => $002d8fc4389e10c7$export$5ce7b7639ec5e726);

const $002d8fc4389e10c7$export$9f1541de0780ef27 = 'media-card-tickbox';
const $002d8fc4389e10c7$export$5ce7b7639ec5e726 = `
  background-color: ${`var(--ds-background-input, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`};
  color: ${`var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$d6447c357493214f)})`};
`;

});

parcelRegister("eWD2s", function(module, exports) {

$parcel$export(module.exports, "playButtonClassName", () => $f5a395156eab9e32$export$2fb57774a6fa9716);
$parcel$export(module.exports, "bkgClassName", () => $f5a395156eab9e32$export$4199e73dcf70a929);
$parcel$export(module.exports, "fixedPlayButtonStyles", () => $f5a395156eab9e32$export$8d26a4dc335bc84b);
$parcel$export(module.exports, "playButtonWrapperStyles", () => $f5a395156eab9e32$export$1daeab9e7392037d);
$parcel$export(module.exports, "backgroundStyles", () => $f5a395156eab9e32$export$1e38306701346cd5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

const $f5a395156eab9e32$export$2fb57774a6fa9716 = 'media-card-play-button';
const $f5a395156eab9e32$export$4199e73dcf70a929 = 'play-icon-background';
const $f5a395156eab9e32$var$discSize = 48;
const $f5a395156eab9e32$var$discSizeHover = 56;
const $f5a395156eab9e32$export$8d26a4dc335bc84b = `
  .${$f5a395156eab9e32$export$4199e73dcf70a929} {
    width: ${$f5a395156eab9e32$var$discSizeHover}px;
    height: ${$f5a395156eab9e32$var$discSizeHover}px;
  }
`;
const $f5a395156eab9e32$export$1daeab9e7392037d = /*#__PURE__*/ (0, $f8Sb3.css)({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    span: {
        position: 'absolute'
    }
});
const $f5a395156eab9e32$export$1e38306701346cd5 = /*#__PURE__*/ (0, $f8Sb3.css)({
    transitionProperty: 'width, height',
    transitionDuration: '0.1s',
    position: 'absolute',
    width: `${$f5a395156eab9e32$var$discSize}px`,
    height: `${$f5a395156eab9e32$var$discSize}px`,
    background: `var(--ds-background-neutral-bold, ${(0, $829f609a65d26a98$export$d092757d7c64925c)})`,
    borderRadius: '100%'
});

});

parcelRegister("aQrxl", function(module, exports) {

$parcel$export(module.exports, "Breakpoint", () => $8647fd16c736eff5$export$114247090b0aae30);
$parcel$export(module.exports, "responsiveSettings", () => $8647fd16c736eff5$export$195ea22bb2417d03);
$parcel$export(module.exports, "getTitleBoxHeight", () => $8647fd16c736eff5$export$5141d851393c8198);
var $8647fd16c736eff5$export$114247090b0aae30 = /*#__PURE__*/ function(Breakpoint) {
    Breakpoint["SMALL"] = "small";
    Breakpoint["LARGE"] = "large";
    return Breakpoint;
}({});
const $8647fd16c736eff5$export$195ea22bb2417d03 = {
    ["small"]: {
        fontSize: 11,
        lineHeight: 14,
        titleBox: {
            verticalPadding: 4,
            horizontalPadding: 8
        }
    },
    ["large"]: {
        fontSize: 14,
        lineHeight: 22,
        titleBox: {
            verticalPadding: 8,
            horizontalPadding: 12
        }
    }
};
const $8647fd16c736eff5$export$5141d851393c8198 = (breakpoint)=>($8647fd16c736eff5$export$195ea22bb2417d03[breakpoint].lineHeight + $8647fd16c736eff5$export$195ea22bb2417d03[breakpoint].titleBox.verticalPadding) * 2;

});



parcelRegister("galQf", function(module, exports) {

$parcel$export(module.exports, "TitleBoxWrapper", () => $ea5ef4ecef3ac5c1$export$213c428ce4ec143c);
$parcel$export(module.exports, "TitleBoxHeader", () => $ea5ef4ecef3ac5c1$export$43970d913b015380);
$parcel$export(module.exports, "TitleBoxFooter", () => $ea5ef4ecef3ac5c1$export$1004da4fc5583975);
$parcel$export(module.exports, "TitleBoxIcon", () => $ea5ef4ecef3ac5c1$export$70e996312f72d22d);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $ea5ef4ecef3ac5c1$export$9e874bb1adc98a55);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $5D66X = parcelRequire("5D66X");
const $ea5ef4ecef3ac5c1$export$213c428ce4ec143c = (props)=>{
    const { breakpoint: breakpoint, titleBoxBgColor: titleBoxBgColor, hidden: hidden } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "titleBoxWrapper",
        "data-testid": "media-title-box",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $5D66X.titleBoxWrapperStyles)({
            breakpoint: breakpoint,
            display: hidden ? 'none' : 'flex',
            titleBoxBgColor: titleBoxBgColor
        })
    }, props.children);
};
const $ea5ef4ecef3ac5c1$export$43970d913b015380 = (props)=>{
    const { hasIconOverlap: hasIconOverlap } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "titleBoxHeader",
        "data-testid": "title-box-header",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $5D66X.titleBoxHeaderStyles)({
            hasIconOverlap: hasIconOverlap
        })
    }, props.children);
};
const $ea5ef4ecef3ac5c1$export$1004da4fc5583975 = (props)=>{
    const { hasIconOverlap: hasIconOverlap } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "titleBoxFooter",
        "data-testid": "title-box-footer",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $5D66X.titleBoxFooterStyles)({
            hasIconOverlap: hasIconOverlap
        })
    }, props.children);
};
const $ea5ef4ecef3ac5c1$export$70e996312f72d22d = (props)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "titleBoxIcon",
        "data-testid": "title-box-icon",
        css: (0, $VSDnB.fg)('platform-visual-refresh-icons') ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        (0, $5D66X.newTitleBoxIconStyles) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        (0, $5D66X.titleBoxIconStyles)
    }, props.children);
};
const $ea5ef4ecef3ac5c1$export$9e874bb1adc98a55 = (props)=>{
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $5D66X.errorMessageWrapperStyles)
    }, props.children);
};

});
parcelRegister("5D66X", function(module, exports) {

$parcel$export(module.exports, "titleBoxWrapperStyles", () => $e9338ccde4a24793$export$67519283632017a5);
$parcel$export(module.exports, "titleBoxHeaderStyles", () => $e9338ccde4a24793$export$ad849f87817ca9ae);
$parcel$export(module.exports, "titleBoxFooterStyles", () => $e9338ccde4a24793$export$ef98c107c6908fb2);
$parcel$export(module.exports, "titleBoxIconStyles", () => $e9338ccde4a24793$export$4d49b02261d82f);
$parcel$export(module.exports, "newTitleBoxIconStyles", () => $e9338ccde4a24793$export$c614ab182d7a390d);
$parcel$export(module.exports, "errorMessageWrapperStyles", () => $e9338ccde4a24793$export$6fed64482f59b82c);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $aQrxl = parcelRequire("aQrxl");


var $gC46K = parcelRequire("gC46K");
function $e9338ccde4a24793$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e9338ccde4a24793$var$generateResponsiveStyles = (breakpoint = (0, $aQrxl.Breakpoint).SMALL)=>{
    const setting = (0, $aQrxl.responsiveSettings)[breakpoint];
    const verticalPadding = setting.titleBox.verticalPadding;
    const horizontalPadding = setting.titleBox.horizontalPadding;
    const height = (0, $aQrxl.getTitleBoxHeight)(breakpoint);
    return `height: ${height}px;
    padding: ${verticalPadding}px ${horizontalPadding}px;`;
};
const $e9338ccde4a24793$var$HEX_REGEX = /^#[0-9A-F]{6}$/i;
const $e9338ccde4a24793$export$67519283632017a5 = ({ breakpoint: breakpoint, display: display = 'flex', titleBoxBgColor: titleBoxBgColor })=>/*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'absolute',
        bottom: 0,
        width: '100%',
        backgroundColor: `var(--ds-surface, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        (0, $gC46K.rgba)(titleBoxBgColor && $e9338ccde4a24793$var$HEX_REGEX.test(titleBoxBgColor) ? titleBoxBgColor : (0, $829f609a65d26a98$export$29a4f05edc054374), 1)})`,
        color: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
        cursor: 'inherit',
        pointerEvents: 'none',
        display: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        display,
        flexDirection: 'column',
        justifyContent: 'center'
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $e9338ccde4a24793$var$generateResponsiveStyles(breakpoint));
$e9338ccde4a24793$export$67519283632017a5.displayName = 'TitleBoxWrapper';
const $e9338ccde4a24793$var$infoStyles = `white-space: nowrap;overflow: hidden;`;
const $e9338ccde4a24793$var$iconOverlapStyles = `padding-right: 10px;`;
const $e9338ccde4a24793$export$ad849f87817ca9ae = ({ hasIconOverlap: hasIconOverlap })=>/*#__PURE__*/ (0, $f8Sb3.css)("font-weight:var(--ds-font-weight-semibold, 600);", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $e9338ccde4a24793$var$infoStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasIconOverlap && $e9338ccde4a24793$var$iconOverlapStyles);
$e9338ccde4a24793$export$ad849f87817ca9ae.displayName = 'FailedTitleBoxHeader';
const $e9338ccde4a24793$export$ef98c107c6908fb2 = ({ hasIconOverlap: hasIconOverlap })=>/*#__PURE__*/ (0, $f8Sb3.css)("text-overflow:ellipsis;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $e9338ccde4a24793$var$infoStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasIconOverlap && $e9338ccde4a24793$var$iconOverlapStyles);
$e9338ccde4a24793$export$ef98c107c6908fb2.displayName = 'TitleBoxFooter';
const $e9338ccde4a24793$export$4d49b02261d82f = {
    name: "9adycr",
    styles: "position:absolute;right:var(--ds-space-050, 4px);bottom:0px"
};
const $e9338ccde4a24793$export$c614ab182d7a390d = {
    name: "1w19ra2",
    styles: "position:absolute;right:var(--ds-space-050, 4px);bottom:var(--ds-space-050, 4px)"
};
const $e9338ccde4a24793$export$6fed64482f59b82c = {
    name: "clvfm2",
    styles: "display:flex;align-items:center;justify-content:flex-start;padding-inline-start:var(--ds-space-025, 2px);gap:var(--ds-space-025, 2px);span{vertical-align:middle;:nth-child(2){margin-left:var(--ds-space-050, 4px);margin-right:var(--ds-space-050, 4px);}}"
};

});




parcelRegister("b0ccC", function(module, exports) {

$parcel$export(module.exports, "FailedTitleBox", () => $51651ed6eeeaa593$export$9b3b0baef32e2e39);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $4tdZt = parcelRequire("4tdZt");

var $fUEF9 = parcelRequire("fUEF9");


var $4W3CS = parcelRequire("4W3CS");
const $51651ed6eeeaa593$export$9b3b0baef32e2e39 = ({ breakpoint: breakpoint, customMessage: customMessage = (0, $fUEF9.messages).failed_to_load })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4W3CS.TitleBoxWrapper), {
        breakpoint: breakpoint,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $4W3CS.ErrorMessageWrapper), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4tdZt))), {
                    label: 'Warning',
                    LEGACY_size: 'small',
                    LEGACY_margin: `0 ${"var(--ds-space-negative-025, -2px)"}`,
                    color: `var(--ds-text-danger, ${(0, $829f609a65d26a98$export$4a7404f376229999)})`
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...customMessage
                    })
                })
            ]
        })
    });
};

});
parcelRegister("4tdZt", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ffddc60c674c09a53523106d3af38531>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3414b9152937a2c1$var$_react = $3414b9152937a2c1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3414b9152937a2c1$var$_warning = $3414b9152937a2c1$var$_interopRequireDefault((parcelRequire("bZC6Q")));

var $3414b9152937a2c1$var$_warning2 = $3414b9152937a2c1$var$_interopRequireDefault((parcelRequire("hD8l9")));
function $3414b9152937a2c1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "EditorWarningIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3414b9152937a2c1$var$WarningIcon = (props)=>/*#__PURE__*/ $3414b9152937a2c1$var$_react.default.createElement($3414b9152937a2c1$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $3414b9152937a2c1$var$_warning2.default
    }, props));
$3414b9152937a2c1$var$WarningIcon.Name = 'WarningIconMigration';
var $3414b9152937a2c1$var$_default = module.exports.default = $3414b9152937a2c1$var$WarningIcon;

});


parcelRegister("dejfZ", function(module, exports) {

$parcel$export(module.exports, "ProgressBar", () => $2746eac98ef9e8af$export$c17561cb55d4db30);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $i0UYg = parcelRequire("i0UYg");

var $aQrxl = parcelRequire("aQrxl");
const $2746eac98ef9e8af$export$7b5a7c65f0c5d278 = (progress)=>{
    return Math.min(1, Math.max(0, progress || 0)) * 100;
};
const $2746eac98ef9e8af$export$c17561cb55d4db30 = ({ progress: progress, breakpoint: breakpoint = (0, $aQrxl.Breakpoint).SMALL, positionBottom: positionBottom = false, showOnTop: showOnTop = false })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i0UYg.StyledBar), {
        progress: $2746eac98ef9e8af$export$7b5a7c65f0c5d278(progress),
        breakpoint: breakpoint,
        positionBottom: positionBottom,
        showOnTop: showOnTop
    });
};

});
parcelRegister("i0UYg", function(module, exports) {

$parcel$export(module.exports, "StyledBar", () => $0edf1c1844452617$export$cb8b5a20ccbacd09);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $6LmZn = parcelRequire("6LmZn");

var $1HMnq = parcelRequire("1HMnq");
const $0edf1c1844452617$export$cb8b5a20ccbacd09 = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6LmZn.StyledBar), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1HMnq.StyledBar), {
        ...props
    });

});
parcelRegister("6LmZn", function(module, exports) {

$parcel$export(module.exports, "StyledBar", () => $5cc56b7f6dad8ad4$export$cb8b5a20ccbacd09);
/* styledBar-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aQrxl = parcelRequire("aQrxl");
const $5cc56b7f6dad8ad4$var$height = 3;
const $5cc56b7f6dad8ad4$var$padding = 1;
const $5cc56b7f6dad8ad4$var$width = 95; // %
const $5cc56b7f6dad8ad4$var$smallSizeSettings = {
    marginBottom: 4
};
const $5cc56b7f6dad8ad4$var$largeSizeSettings = {
    marginBottom: 12
};
function $5cc56b7f6dad8ad4$export$bb6eded75bc31192(breakpoint, positionBottom, showOnTop, multiplier = 1) {
    const setting = breakpoint === (0, $aQrxl.Breakpoint).SMALL ? $5cc56b7f6dad8ad4$var$smallSizeSettings : $5cc56b7f6dad8ad4$var$largeSizeSettings;
    const marginPositionBottom = (0, $aQrxl.responsiveSettings)[breakpoint].titleBox.verticalPadding;
    const marginBottom = setting.marginBottom * multiplier + (positionBottom ? marginPositionBottom : (0, $aQrxl.getTitleBoxHeight)(breakpoint));
    const spacing = `${marginBottom}px`;
    return showOnTop ? {
        top: spacing
    } : {
        bottom: spacing
    };
}
const $5cc56b7f6dad8ad4$var$styledBarStyles = null;
const $5cc56b7f6dad8ad4$var$styleChild = null;
const $5cc56b7f6dad8ad4$export$cb8b5a20ccbacd09 = (props)=>{
    const { progress: progress, breakpoint: breakpoint, positionBottom: positionBottom, showOnTop: showOnTop } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: "styledBar",
        role: "progressbar",
        "aria-valuenow": progress,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...$5cc56b7f6dad8ad4$export$bb6eded75bc31192(breakpoint, positionBottom, showOnTop)
        },
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _ca0qt94y _u5f3t94y _n3tdt94y _19bvt94y _2rko1l7b _kqswstnw _1bsb1lk2 _1ltv1ghs _bfhkatjl _4t3i14y2 _vchhusvi"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            style: {
                width: `${progress}%`
            },
            className: (0, $bwpsq.default)([
                "_2rko1l7b _bfhk1p0d _1e0c1ule _4t3i1osq"
            ])
        })
    });
};
$5cc56b7f6dad8ad4$export$cb8b5a20ccbacd09.displayName = 'StyledProgressBar';

});

parcelRegister("1HMnq", function(module, exports) {

$parcel$export(module.exports, "StyledBar", () => $1abb604f0e63fd48$export$cb8b5a20ccbacd09);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $iG3tK = parcelRequire("iG3tK");
const $1abb604f0e63fd48$export$cb8b5a20ccbacd09 = (props)=>{
    const { progress: progress, breakpoint: breakpoint, positionBottom: positionBottom, showOnTop: showOnTop } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "styledBar",
        role: "progressbar",
        "aria-valuenow": progress,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $iG3tK.styledBarStyles)({
            progress: progress,
            breakpoint: breakpoint,
            positionBottom: positionBottom,
            showOnTop: showOnTop
        })
    });
};

});
parcelRegister("iG3tK", function(module, exports) {

$parcel$export(module.exports, "styledBarStyles", () => $7262a9d407142979$export$c7c110ef29c6fcf1);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9Kxjq = parcelRequire("9Kxjq");

var $gC46K = parcelRequire("gC46K");


var $aQrxl = parcelRequire("aQrxl");
const $7262a9d407142979$var$height = 3;
const $7262a9d407142979$var$padding = 1;
const $7262a9d407142979$var$width = 95; // %
const $7262a9d407142979$var$left = (100 - $7262a9d407142979$var$width) / 2; // %
const $7262a9d407142979$var$smallSizeSettings = {
    marginBottom: 4
};
const $7262a9d407142979$var$largeSizeSettings = {
    marginBottom: 12
};
function $7262a9d407142979$export$bb6eded75bc31192(breakpoint, positionBottom, showOnTop, multiplier = 1) {
    const setting = breakpoint === (0, $aQrxl.Breakpoint).SMALL ? $7262a9d407142979$var$smallSizeSettings : $7262a9d407142979$var$largeSizeSettings;
    const marginPositionBottom = (0, $aQrxl.responsiveSettings)[breakpoint].titleBox.verticalPadding;
    const marginBottom = setting.marginBottom * multiplier + (positionBottom ? marginPositionBottom : (0, $aQrxl.getTitleBoxHeight)(breakpoint));
    return `
    ${showOnTop ? 'top' : 'bottom'}: ${marginBottom}px
  `;
}
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $7262a9d407142979$var$getStyledBarStylesBasedOnProps = ({ progress: progress, breakpoint: breakpoint, positionBottom: positionBottom, showOnTop: showOnTop })=>`
${0, $9Kxjq.borderRadius}
overflow: hidden;
position: absolute;
width: ${$7262a9d407142979$var$width}%;
left: ${$7262a9d407142979$var$left}%;
background-color: ${(0, $gC46K.rgba)((0, $829f609a65d26a98$export$29a4f05edc054374), 0.8)};
height: ${$7262a9d407142979$var$height + $7262a9d407142979$var$padding * 2}px;
padding: ${$7262a9d407142979$var$padding}px;
box-sizing: border-box;

::before {
  content: '';
  width: ${progress}%;
  height: 100%;
  background-color: #44546F;
  ${0, $9Kxjq.borderRadius}
  display: block;
}
${$7262a9d407142979$export$bb6eded75bc31192(breakpoint, positionBottom, showOnTop)}
`;
const $7262a9d407142979$export$c7c110ef29c6fcf1 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.css)($7262a9d407142979$var$getStyledBarStylesBasedOnProps(props));
};
$7262a9d407142979$export$c7c110ef29c6fcf1.displayName = 'StyledProgressBar';

});




parcelRegister("cXkSM", function(module, exports) {

$parcel$export(module.exports, "PlayButton", () => $a835087af5b47597$export$fbed5f62d839a0cd);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dOzZz = parcelRequire("dOzZz");

var $ith06 = parcelRequire("ith06");

var $b2nAX = parcelRequire("b2nAX");

var $6Fg9Q = parcelRequire("6Fg9Q");
const $a835087af5b47597$export$fbed5f62d839a0cd = ()=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $b2nAX.PlayButtonWrapper), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6Fg9Q.PlayButtonBackground), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ith06))), {
                color: "currentColor",
                label: "play",
                LEGACY_size: "large",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($dOzZz)))
            })
        ]
    });
};

});
parcelRegister("dOzZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0298730d194eb3bc$var$_react = $0298730d194eb3bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $0298730d194eb3bc$var$_videoPlay = $0298730d194eb3bc$var$_interopRequireDefault((parcelRequire("b7NAp")));
function $0298730d194eb3bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0298730d194eb3bc$var$VidPlayIcon = (props)=>/*#__PURE__*/ $0298730d194eb3bc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.595 19.522C7.162 20.364 6 19.702 6 18.04V5.963C6 4.3 7.158 3.635 8.595 4.479l11.083 6.51c.951.559.958 1.46 0 2.023z"/></svg>`
    }, props, {
        newIcon: $0298730d194eb3bc$var$_videoPlay.default
    }));
$0298730d194eb3bc$var$VidPlayIcon.displayName = 'VidPlayIcon';
var $0298730d194eb3bc$var$_default = module.exports.default = $0298730d194eb3bc$var$VidPlayIcon;

});
parcelRegister("b7NAp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92409a0bcef1d03143cf6035c99e88da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8196cfedfbf38b92$var$_react = $8196cfedfbf38b92$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8196cfedfbf38b92$var$_baseNew = $8196cfedfbf38b92$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8196cfedfbf38b92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8196cfedfbf38b92$var$VideoPlayIcon = (props)=>/*#__PURE__*/ $8196cfedfbf38b92$var$_react.default.createElement($8196cfedfbf38b92$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888zm2.24-.438a.5.5 0 0 0-.74.438v9.776a.5.5 0 0 0 .74.438l8.903-4.888a.5.5 0 0 0 0-.876z" clip-rule="evenodd"/>`
    }, props));
$8196cfedfbf38b92$var$VideoPlayIcon.displayName = 'VideoPlayIcon';
var $8196cfedfbf38b92$var$_default = module.exports.default = $8196cfedfbf38b92$var$VideoPlayIcon;

});


parcelRegister("ith06", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d2e3c8fcba4e62054ef71c09ada81e61>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d7281f62137141d3$var$_react = $d7281f62137141d3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d7281f62137141d3$var$_baseNew = $d7281f62137141d3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d7281f62137141d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlayOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d7281f62137141d3$var$VideoPlayOverlayIcon = (props)=>/*#__PURE__*/ $d7281f62137141d3$var$_react.default.createElement($d7281f62137141d3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888z" clip-rule="evenodd"/>`
    }, props));
$d7281f62137141d3$var$VideoPlayOverlayIcon.displayName = 'VideoPlayOverlayIcon';
var $d7281f62137141d3$var$_default = module.exports.default = $d7281f62137141d3$var$VideoPlayOverlayIcon;

});

parcelRegister("b2nAX", function(module, exports) {

$parcel$export(module.exports, "PlayButtonWrapper", () => $026dada3c9bd6195$export$4b5a99ec12fb6a16);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $ku1yD = parcelRequire("ku1yD");

var $idVh8 = parcelRequire("idVh8");
const $026dada3c9bd6195$export$4b5a99ec12fb6a16 = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ku1yD.PlayButtonWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $idVh8.PlayButtonWrapper), {
        ...props
    });

});
parcelRegister("ku1yD", function(module, exports) {

$parcel$export(module.exports, "PlayButtonWrapper", () => $db3831a331f6d944$export$4b5a99ec12fb6a16);
/* playButtonWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eWD2s = parcelRequire("eWD2s");
const $db3831a331f6d944$var$playButtonWrapperStyles = null;
const $db3831a331f6d944$export$4b5a99ec12fb6a16 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o _syaz5w2r _vr2wstnw",
            (0, $eWD2s.playButtonClassName)
        ]),
        children: props.children
    });
};

});

parcelRegister("idVh8", function(module, exports) {

$parcel$export(module.exports, "PlayButtonWrapper", () => $c4ddb9230faba531$export$4b5a99ec12fb6a16);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $eWD2s = parcelRequire("eWD2s");
const $c4ddb9230faba531$export$4b5a99ec12fb6a16 = (props)=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $eWD2s.playButtonWrapperStyles),
        className: (0, $eWD2s.playButtonClassName)
    }, props.children));
};

});


parcelRegister("6Fg9Q", function(module, exports) {

$parcel$export(module.exports, "PlayButtonBackground", () => $d53807cb6bb8b477$export$b9f4dfad351e8285);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $eWD2s = parcelRequire("eWD2s");
const $d53807cb6bb8b477$export$b9f4dfad351e8285 = ()=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: (0, $eWD2s.backgroundStyles),
        className: (0, $eWD2s.bkgClassName)
    });
};

});


parcelRegister("gRd69", function(module, exports) {

$parcel$export(module.exports, "TickBox", () => $9ba8d6e01ec82bd7$export$58be5bf2cd389559);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $hl2pN = parcelRequire("hl2pN");

var $iMMB8 = parcelRequire("iMMB8");
const $9ba8d6e01ec82bd7$export$58be5bf2cd389559 = ({ selected: selected })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iMMB8.TickBoxWrapper), {
        selected: selected,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hl2pN))), {
            color: "currentColor",
            label: "tick"
        })
    });

});
parcelRegister("hl2pN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9db35ecad695c835ed46bfa4bbde0dff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9f6456416d52b22$var$_react = $c9f6456416d52b22$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c9f6456416d52b22$var$_checkMark = $c9f6456416d52b22$var$_interopRequireDefault((parcelRequire("f22iM")));

var $c9f6456416d52b22$var$_check = $c9f6456416d52b22$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $c9f6456416d52b22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9f6456416d52b22$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $c9f6456416d52b22$var$_react.default.createElement($c9f6456416d52b22$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $c9f6456416d52b22$var$_check.default
    }, props));
$c9f6456416d52b22$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $c9f6456416d52b22$var$_default = module.exports.default = $c9f6456416d52b22$var$CheckMarkIcon;

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});

parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});



parcelRegister("iMMB8", function(module, exports) {

$parcel$export(module.exports, "TickBoxWrapper", () => $aee00ea225d39e76$export$65704ff0d0294857);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $6fNtu = parcelRequire("6fNtu");

var $8M6xJ = parcelRequire("8M6xJ");
const $aee00ea225d39e76$export$65704ff0d0294857 = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6fNtu.TickBoxWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8M6xJ.TickBoxWrapper), {
        ...props
    });
$aee00ea225d39e76$export$65704ff0d0294857.displayName = 'TickBoxWrapper';

});
parcelRegister("6fNtu", function(module, exports) {

$parcel$export(module.exports, "TickBoxWrapper", () => $43b2de9754eebe82$export$65704ff0d0294857);
/* tickBoxWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $hECXM = parcelRequire("hECXM");
const $43b2de9754eebe82$var$selectedStyles = null;
const $43b2de9754eebe82$var$oldWrapperStyes = null;
const $43b2de9754eebe82$var$wrapperStyles = null;
const $43b2de9754eebe82$export$65704ff0d0294857 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: "tickBoxWrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_11c82smr _2rkov47k _4cvr1h6o _6a6z1h6o _v564ybtr _1bsbpxbi _4t3ipxbi _kqswstnw _154i1tpr _1ltv1tpr _syaz3acm _1e0c11p5 _1b941ule",
            !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1bsbdlk8 _4t3idlk8 _1mcmdlk8",
            props.selected && "_bfhk8sto _syaz5w2r",
            (0, $hECXM.tickBoxClassName)
        ]),
        children: props.children
    });
};
$43b2de9754eebe82$export$65704ff0d0294857.displayName = 'TickBoxWrapper';

});

parcelRegister("8M6xJ", function(module, exports) {

$parcel$export(module.exports, "TickBoxWrapper", () => $61819c29eab45dca$export$65704ff0d0294857);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $hECXM = parcelRequire("hECXM");

var $gC46K = parcelRequire("gC46K");

function $61819c29eab45dca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $61819c29eab45dca$var$getSelectedStyles = (selected)=>selected ? `background-color: ${`var(--ds-icon-information, ${0, $829f609a65d26a98$export$215b7063051591f1})`};
      color: ${"var(--ds-icon-inverse, white)"};` : ``;
const $61819c29eab45dca$var$oldWrapperStyes = {
    name: "1k581ha",
    styles: "width:14px;height:14px;span{svg{height:14px;}}"
};
const $61819c29eab45dca$var$wrapperStyles = (selected)=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $gC46K.transition) && (0, $gC46K.transition)(), "font:var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px);position:absolute;top:var(--ds-space-075, 7px);left:var(--ds-space-075, 7px);border-radius:var(--ds-space-250, 20px);color:transparent;span{display:block;}display:grid;place-items:center;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $61819c29eab45dca$var$getSelectedStyles(selected));
$61819c29eab45dca$var$wrapperStyles.displayName = 'TickBoxWrapper';
const $61819c29eab45dca$export$65704ff0d0294857 = (props)=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "tickBoxWrapper",
        css: [
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            $61819c29eab45dca$var$wrapperStyles(props.selected),
            !(0, $VSDnB.fg)('platform-visual-refresh-icons') && $61819c29eab45dca$var$oldWrapperStyes
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $hECXM.tickBoxClassName)
    }, props.children);
};

});



parcelRegister("kQ7MY", function(module, exports) {

$parcel$export(module.exports, "Blanket", () => $3cd915a3c7152455$export$5b927fc1ef8c468b);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $imxuC = parcelRequire("imxuC");

var $dOJGF = parcelRequire("dOJGF");
const $3cd915a3c7152455$export$5b927fc1ef8c468b = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $imxuC.Blanket), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dOJGF.Blanket), {
        ...props
    });

});
parcelRegister("imxuC", function(module, exports) {

$parcel$export(module.exports, "Blanket", () => $55bc651cadc092b7$export$5b927fc1ef8c468b);
/* blanket-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $55bc651cadc092b7$export$5a1cb4139dc6683d = 'media-card-blanket';
const $55bc651cadc092b7$export$3141ecf58e7b3585 = `background-color: ${`var(--ds-blanket, ${(0, $829f609a65d26a98$export$d092757d7c64925c)})`};`;
const $55bc651cadc092b7$var$blanketStyles = null;
const $55bc651cadc092b7$var$fixedBlanketStyle = null;
const $55bc651cadc092b7$export$5b927fc1ef8c468b = (props)=>{
    const { isFixed: isFixed } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_v564ybtr _kqswstnw _1bsb1osq _4t3i1osq _c71l1osq _p12f1osq _1ltvidpf _154iidpf",
            isFixed && "_bfhka8ns",
            $55bc651cadc092b7$export$5a1cb4139dc6683d
        ]),
        "data-testid": "media-card-blanket"
    });
};
$55bc651cadc092b7$export$5b927fc1ef8c468b.displayName = 'Blanket';

});

parcelRegister("dOJGF", function(module, exports) {

$parcel$export(module.exports, "Blanket", () => $2d84ed6f73ff0c79$export$5b927fc1ef8c468b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $6SUdr = parcelRequire("6SUdr");
const $2d84ed6f73ff0c79$export$5b927fc1ef8c468b = (props)=>{
    const { isFixed: isFixed } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $6SUdr.blanketStyles)(isFixed),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6SUdr.blanketClassName),
        "data-testid": "media-card-blanket"
    });
};

});
parcelRegister("6SUdr", function(module, exports) {

$parcel$export(module.exports, "blanketClassName", () => $62a6d78daa08f783$export$5a1cb4139dc6683d);
$parcel$export(module.exports, "fixedBlanketStyles", () => $62a6d78daa08f783$export$3141ecf58e7b3585);
$parcel$export(module.exports, "blanketStyles", () => $62a6d78daa08f783$export$db1173ffa5e2194);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $gC46K = parcelRequire("gC46K");

const $62a6d78daa08f783$export$5a1cb4139dc6683d = 'media-card-blanket';
const $62a6d78daa08f783$export$3141ecf58e7b3585 = `background-color: ${`var(--ds-blanket, ${(0, $829f609a65d26a98$export$d092757d7c64925c)})`};`;
const $62a6d78daa08f783$export$db1173ffa5e2194 = (isFixed)=>/*#__PURE__*/ (0, $f8Sb3.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $gC46K.transition)(), "position:absolute;width:100%;height:100%;max-height:100%;max-width:100%;left:0;top:0;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    isFixed ? $62a6d78daa08f783$export$3141ecf58e7b3585 : '');
$62a6d78daa08f783$export$db1173ffa5e2194.displayName = 'Blanket';

});



parcelRegister("9VKme", function(module, exports) {

$parcel$export(module.exports, "ActionsBar", () => $c9fe88a47c36c36c$export$8c8e9293b68041de);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $9yaai = parcelRequire("9yaai");
var $kKs2E = parcelRequire("kKs2E");

var $eKaKS = parcelRequire("eKaKS");
class $c9fe88a47c36c36c$export$8c8e9293b68041de extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        const { isFixed: isFixed, filename: filename, actions: actions } = this.props;
        if (actions.length === 0) return null;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eKaKS.ActionsBarWrapper), {
            isFixed: isFixed,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKs2E.CardActionsView), {
                filename: filename,
                actions: actions,
                variant: (0, $9yaai.CardActionIconButtonVariant).filled
            })
        });
    }
}

});
parcelRegister("9yaai", function(module, exports) {

$parcel$export(module.exports, "CardActionIconButtonVariant", () => $166d1a28fcecce60$export$1092897f622d4253);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $9Kxjq = parcelRequire("9Kxjq");

var $gC46K = parcelRequire("gC46K");
var $166d1a28fcecce60$export$1092897f622d4253 = /*#__PURE__*/ function(CardActionIconButtonVariant) {
    CardActionIconButtonVariant["default"] = "default";
    CardActionIconButtonVariant["filled"] = "filled";
    return CardActionIconButtonVariant;
}({});
const $166d1a28fcecce60$var$getVariantStyles = (variant)=>{
    return variant === 'filled' ? `
    background-color: ${`var(--ds-surface-overlay, ${(0, $gC46K.rgba)((0, $829f609a65d26a98$export$29a4f05edc054374), 0.8)})`};

    &:hover {
      background-color: ${`var(--ds-surface-overlay-hovered, ${(0, $gC46K.rgba)((0, $829f609a65d26a98$export$29a4f05edc054374), 0.6)})`}
    }
  ` : `
    &:hover {
      background-color: ${"var(--ds-background-neutral-subtle-hovered, rgba(9, 30, 66, 0.06))"};
    }
  `;
};
const $166d1a28fcecce60$export$7554c3d9ed9d9659 = ({ variant: variant })=>/*#__PURE__*/ (0, $f8Sb3.css)("appearance:none;border:none;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9Kxjq.center), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9Kxjq.borderRadius), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9Kxjq.size)(26), {
        color: `var(--ds-icon, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        '&:hover': {
            cursor: 'pointer'
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $166d1a28fcecce60$var$getVariantStyles(variant));

});

parcelRegister("kKs2E", function(module, exports) {

$parcel$export(module.exports, "CardActionsView", () => $103558c2bb7f39f6$export$8b95be1301afd485);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6vwqM = parcelRequire("6vwqM");

var $iMuS0 = parcelRequire("iMuS0");
class $103558c2bb7f39f6$export$8b95be1301afd485 extends (0, $5uXOq.Component) {
    render() {
        const { actions: actions } = this.props;
        if (!actions.length) return null;
        const primaryAction = actions.find($103558c2bb7f39f6$var$actionWithIcon);
        const otherActions = actions.filter($103558c2bb7f39f6$var$actionNotEqualTo(primaryAction));
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                primaryAction ? this.renderActionIconButton(primaryAction, true) : null,
                this.renderOtherActionButtons(otherActions)
            ]
        });
    }
    renderActionIconButton(action, isPrimary) {
        const { triggerColor: triggerColor, filename: filename, variant: variant } = this.props;
        const { icon: icon, handler: handler, label: label, isDisabled: isDisabled, tooltip: tooltip } = action;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6vwqM.CardActionIconButton), {
            icon: icon,
            label: label,
            filename: filename,
            isPrimary: isPrimary,
            triggerColor: triggerColor,
            onClick: ()=>handler(),
            variant: variant,
            isDisabled: isDisabled,
            tooltip: tooltip
        });
    }
    renderOtherActionButtons(actions) {
        if (actions.length === 0) return null;
        else {
            const { triggerColor: triggerColor, onToggle: onToggle, variant: variant } = this.props;
            const firstActionWithIcon = actions.find($103558c2bb7f39f6$var$actionWithIcon);
            const otherActions = actions.filter($103558c2bb7f39f6$var$actionNotEqualTo(firstActionWithIcon));
            if (firstActionWithIcon && otherActions.length === 0) return this.renderActionIconButton(firstActionWithIcon, false);
            else return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iMuS0.CardActionsDropdownMenu), {
                actions: actions,
                triggerColor: triggerColor,
                onOpenChange: onToggle,
                triggerVariant: variant
            });
        }
    }
}
function $103558c2bb7f39f6$var$actionWithIcon(action) {
    return !!action.icon;
}
function $103558c2bb7f39f6$var$actionNotEqualTo(otherAction) {
    return (action)=>action !== otherAction;
}

});
parcelRegister("6vwqM", function(module, exports) {

$parcel$export(module.exports, "CardActionIconButton", () => $8b2dec12e503c281$export$8cc1a92de7a95c90);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $d5UjK = parcelRequire("d5UjK");

var $3bDjY = parcelRequire("3bDjY");

var $fJdkV = parcelRequire("fJdkV");
const $8b2dec12e503c281$export$8cc1a92de7a95c90 = ({ icon: icon, label: label, filename: filename, triggerColor: triggerColor, onClick: onClick, isPrimary: isPrimary, variant: variant, isDisabled: isDisabled, tooltip: tooltip })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // this is to prevent currently focused text to loose cursor on clicking card action
    // this does not prevent onclick behavior
    const onMouseDown = (event)=>{
        event.preventDefault();
    };
    const handleClick = (e)=>{
        const actionSubjectId = isPrimary ? 'mediaCardPrimaryActionButton' : 'mediaCardSecondaryActionButton';
        (0, $fJdkV.fireMediaCardEvent)({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: actionSubjectId,
            attributes: {
                label: label
            }
        }, createAnalyticsEvent);
        onClick?.(e);
    };
    const cardActionButton = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d5UjK.CardActionButton), {
        onClick: handleClick,
        onMouseDown: onMouseDown,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            color: triggerColor
        },
        label: filename ? `${filename} \u{2014} ${label}` : label,
        variant: variant,
        disabled: isDisabled,
        children: icon
    });
    return tooltip ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: tooltip,
        position: "bottom",
        tag: "span",
        children: cardActionButton
    }) : cardActionButton;
};

});
parcelRegister("d5UjK", function(module, exports) {

$parcel$export(module.exports, "CardActionButton", () => $35bee2056c2a2459$export$19effabad32bd757);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dYicc = parcelRequire("dYicc");
const $35bee2056c2a2459$export$19effabad32bd757 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dYicc.CardActionButton), {
        ...props,
        ref: ref
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dYicc.CardActionButton), {
        ...props,
        ref: ref
    }));

});
parcelRegister("dYicc", function(module, exports) {

$parcel$export(module.exports, "CardActionButton", () => $c4ad1413e94b359e$export$19effabad32bd757);
/* cardActionButton-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c4ad1413e94b359e$var$variantStyleMap = {
    filled: "_bfhk37p7 _irr3u1o1",
    default: "_irr3166n"
};
const $c4ad1413e94b359e$var$cardActionButtonStyles = null;
const $c4ad1413e94b359e$export$19effabad32bd757 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
        ...props,
        id: "cardActionButton",
        "data-testid": "media-card-primary-action",
        "aria-label": props.label,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...props.style,
            cursor: props.disabled ? 'not-allowed' : 'default'
        },
        onClick: props.onClick,
        onMouseDown: props.onMouseDown,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_19itglyw _2rko1sit _r06hglyw _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1ou6 _4t3i1ou6 _syazilmm _d0altlke",
            $c4ad1413e94b359e$var$variantStyleMap[props.variant ?? 'default']
        ]),
        children: props.children
    });
});

});



parcelRegister("iMuS0", function(module, exports) {

$parcel$export(module.exports, "CardActionsDropdownMenu", () => $167bffe142ec29d9$export$2b7a7909eccadfb9);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");
var $cb25w = parcelRequire("cb25w");

var $bJeNF = parcelRequire("bJeNF");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $fJdkV = parcelRequire("fJdkV");

var $d5UjK = parcelRequire("d5UjK");
const $167bffe142ec29d9$var$DropdownItemWithProps = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $6B7KL.default), {
        testId: "media-card-actions-menu-item",
        ...props
    });
const $167bffe142ec29d9$var$createDropdownItemWithAnalytics = (action, index)=>{
    const { label: label, handler: handler, isDisabled: isDisabled } = action;
    const DropdownItemWithAnalytics = (0, $cb25w.default)({
        onClick: (0, $fJdkV.createAndFireMediaCardEvent)({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'mediaCardDropDownMenuItem',
            attributes: {
                label: label
            }
        })
    })($167bffe142ec29d9$var$DropdownItemWithProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(DropdownItemWithAnalytics, {
        onClick: ()=>handler(),
        isDisabled: isDisabled,
        children: label
    }, index);
};
const $167bffe142ec29d9$export$2b7a7909eccadfb9 = ({ actions: actions, triggerColor: triggerColor, onOpenChange: onOpenChange, triggerVariant: triggerVariant })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (actions.length > 0) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $BLPHT.default), {
        testId: "media-card-actions-menu",
        onOpenChange: onOpenChange,
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: testId, onClick: onClick, ...providedProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $d5UjK.CardActionButton), {
                variant: triggerVariant,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    color: triggerColor
                },
                ref: triggerRef,
                onClick: (e)=>{
                    (0, $fJdkV.fireMediaCardEvent)({
                        eventType: 'ui',
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'mediaCardDropDownMenu',
                        attributes: {}
                    }, createAnalyticsEvent);
                    onClick?.(e);
                },
                ...providedProps,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: "more"
                })
            }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aRoVz.default), {
            children: actions.map($167bffe142ec29d9$var$createDropdownItemWithAnalytics)
        })
    });
    else return null;
};

});


parcelRegister("eKaKS", function(module, exports) {

$parcel$export(module.exports, "ActionsBarWrapper", () => $704d26fcf9db843a$export$e9414cbfa812f398);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $ekT17 = parcelRequire("ekT17");

var $46rax = parcelRequire("46rax");
const $704d26fcf9db843a$export$e9414cbfa812f398 = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ekT17.ActionsBarWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $46rax.ActionsBarWrapper), {
        ...props
    });

});
parcelRegister("ekT17", function(module, exports) {

$parcel$export(module.exports, "ActionsBarWrapper", () => $a8fd9f0bfafc07de$export$e9414cbfa812f398);
/* actionsBarWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jUG7R = parcelRequire("jUG7R");
const $a8fd9f0bfafc07de$var$wrapperStyles = null;
const $a8fd9f0bfafc07de$var$fixedActionBarStyle = null;
const $a8fd9f0bfafc07de$export$e9414cbfa812f398 = (props)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: "actionsBarWrapper",
        "data-testId": "actionsBarWrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_v564ybtr _2lx2vrvc _1n261q9c _zulpu2gc _kqswstnw _154iidpf _1xi2idpf _1e0c1txw _1bahusic _ca0qu2gc _n3tdu2gc _u5f3u2gc _19bvu2gc _tzy4idpf",
            props.isFixed && "_tzy4kb7n",
            (0, $jUG7R.actionsBarClassName)
        ]),
        onClick: (event)=>{
            event.stopPropagation();
            event.preventDefault();
        },
        children: props.children
    });
};
$a8fd9f0bfafc07de$export$e9414cbfa812f398.displayName = 'ActionsBarWrapper';

});
parcelRegister("jUG7R", function(module, exports) {

$parcel$export(module.exports, "actionsBarClassName", () => $55bcf6bc0bfa81de$export$a7a5a7c9a03af11);
$parcel$export(module.exports, "fixedActionBarStyles", () => $55bcf6bc0bfa81de$export$11387bc0e0bf1d5a);
$parcel$export(module.exports, "wrapperStyles", () => $55bcf6bc0bfa81de$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $gC46K = parcelRequire("gC46K");
const $55bcf6bc0bfa81de$export$a7a5a7c9a03af11 = 'media-card-actions-bar';
const $55bcf6bc0bfa81de$export$11387bc0e0bf1d5a = `opacity: 1;`;
const $55bcf6bc0bfa81de$export$491e6397d7c1480b = (isFixed)=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $f8Sb3.css)(isFixed ? $55bcf6bc0bfa81de$export$11387bc0e0bf1d5a : 'opacity: 0;', (0, $gC46K.transition)(), "position:absolute;top:0;right:0;display:flex;flex-flow:row nowrap;justify-content:right;padding:var(--ds-space-100, 8px);gap:var(--ds-space-100, 8px);");
$55bcf6bc0bfa81de$export$491e6397d7c1480b.displayName = 'ActionsBarWrapper';

});


parcelRegister("46rax", function(module, exports) {

$parcel$export(module.exports, "ActionsBarWrapper", () => $dea689116cf0ae93$export$e9414cbfa812f398);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $jUG7R = parcelRequire("jUG7R");
const $dea689116cf0ae93$export$e9414cbfa812f398 = (props)=>{
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "actionsBarWrapper",
        "data-testId": "actionsBarWrapper",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $jUG7R.wrapperStyles)(props.isFixed),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $jUG7R.actionsBarClassName),
        onClick: (event)=>{
            event.stopPropagation();
            event.preventDefault();
        }
    }, props.children));
};

});



parcelRegister("2aY4r", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $7a4bc238a66ec21a$export$be58b4326e23250f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $enTy2 = parcelRequire("enTy2");

var $gPGVw = parcelRequire("gPGVw");
const $7a4bc238a66ec21a$export$be58b4326e23250f = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $enTy2.IconWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gPGVw.IconWrapper), {
        ...props
    });

});
parcelRegister("enTy2", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $af21409376904ab6$export$be58b4326e23250f);
/* iconWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aQrxl = parcelRequire("aQrxl");
function $af21409376904ab6$export$292aa76b104692f8(hasTitleBox, breakpoint) {
    // there is no titlebox
    if (!hasTitleBox) return `0px`;
    // calculate height of the titlebox
    const marginBottom = (0, $aQrxl.getTitleBoxHeight)(breakpoint);
    return `${marginBottom}px`;
}
const $af21409376904ab6$var$iconWrapperStyles = null;
const $af21409376904ab6$export$be58b4326e23250f = (props)=>{
    const { breakpoint: breakpoint, hasTitleBox: hasTitleBox } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: "iconWrapper",
        style: {
            height: `calc(100% - ${$af21409376904ab6$export$292aa76b104692f8(hasTitleBox, breakpoint)})`
        },
        className: (0, $bwpsq.default)([
            "_kqswstnw _1bsb1osq _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"
        ]),
        children: props.children
    });
};
$af21409376904ab6$export$be58b4326e23250f.displayName = 'MediaIconWrapper';

});

parcelRegister("gPGVw", function(module, exports) {

$parcel$export(module.exports, "IconWrapper", () => $1f5d49a29f90fea1$export$be58b4326e23250f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5oha1 = parcelRequire("5oha1");
const $1f5d49a29f90fea1$export$be58b4326e23250f = (props)=>{
    const { breakpoint: breakpoint, hasTitleBox: hasTitleBox } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "iconWrapper",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $5oha1.iconWrapperStyles)({
            breakpoint: breakpoint,
            hasTitleBox: hasTitleBox
        })
    }, props.children);
};

});
parcelRegister("5oha1", function(module, exports) {

$parcel$export(module.exports, "iconWrapperStyles", () => $9ea173e6a7842b4d$export$7bb30bfb2c35845e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $aQrxl = parcelRequire("aQrxl");
function $9ea173e6a7842b4d$export$292aa76b104692f8(hasTitleBox, breakpoint) {
    // there is no titlebox
    if (!hasTitleBox) return `0px`;
    // calculate height of the titlebox
    const marginBottom = (0, $aQrxl.getTitleBoxHeight)(breakpoint);
    return `${marginBottom}px`;
}
const $9ea173e6a7842b4d$export$7bb30bfb2c35845e = ({ hasTitleBox: hasTitleBox, breakpoint: breakpoint })=>/*#__PURE__*/ (0, $f8Sb3.css)({
        position: 'absolute',
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `calc(100% - ${$9ea173e6a7842b4d$export$292aa76b104692f8(hasTitleBox, breakpoint)})`,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    });
$9ea173e6a7842b4d$export$7bb30bfb2c35845e.displayName = 'MediaIconWrapper';

});



parcelRegister("acX2Z", function(module, exports) {

$parcel$export(module.exports, "CreatingPreview", () => $52152528608e193b$export$4a80244213cb4afc);
$parcel$export(module.exports, "PreviewUnavailable", () => $52152528608e193b$export$35337070c6dafccf);
$parcel$export(module.exports, "FailedToLoad", () => $52152528608e193b$export$a712c963efa9c728);
$parcel$export(module.exports, "FailedToUpload", () => $52152528608e193b$export$f6b7f98fc8b4c6c7);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $7xBQC = parcelRequire("7xBQC");

var $fUEF9 = parcelRequire("fUEF9");

var $ousew = parcelRequire("ousew");
const $52152528608e193b$export$49a5d8503f8a110a = ({ messageDescriptor: messageDescriptor, animated: animated = false })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7xBQC.IconMessageWrapper), {
        animated: animated,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...messageDescriptor
            })
        })
    });
};
const $52152528608e193b$export$4a80244213cb4afc = ({ disableAnimation: disableAnimation })=>/*#__PURE__*/ (0, $2OMIu.jsx)($52152528608e193b$export$49a5d8503f8a110a, {
        messageDescriptor: (0, $fUEF9.messages).creating_preview,
        animated: !disableAnimation
    });
const $52152528608e193b$export$35337070c6dafccf = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($52152528608e193b$export$49a5d8503f8a110a, {
        ...props,
        messageDescriptor: (0, $fUEF9.messages).preview_unavailable
    });
const $52152528608e193b$export$a712c963efa9c728 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($52152528608e193b$export$49a5d8503f8a110a, {
        ...props,
        messageDescriptor: (0, $fUEF9.messages).failed_to_load
    });
const $52152528608e193b$export$f6b7f98fc8b4c6c7 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)($52152528608e193b$export$49a5d8503f8a110a, {
        ...props,
        messageDescriptor: (0, $fUEF9.messages).failed_to_upload
    });

});
parcelRegister("7xBQC", function(module, exports) {

$parcel$export(module.exports, "IconMessageWrapper", () => $870c039baa7f03d3$export$e33129280ab99883);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $1nsYG = parcelRequire("1nsYG");

var $eD7oJ = parcelRequire("eD7oJ");
const $870c039baa7f03d3$export$e33129280ab99883 = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1nsYG.IconMessageWrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eD7oJ.IconMessageWrapper), {
        ...props
    });

});
parcelRegister("1nsYG", function(module, exports) {

$parcel$export(module.exports, "IconMessageWrapper", () => $1e99037a7d162ef6$export$e33129280ab99883);
/* iconMessageWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $1e99037a7d162ef6$var$breatheAnimation = null;
const $1e99037a7d162ef6$var$animatedStyles = null;
const $1e99037a7d162ef6$var$baseStyles = null;
const $1e99037a7d162ef6$export$e33129280ab99883 = (props)=>{
    const { animated: animated } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: "iconMessageWrapper",
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1rjc1b66 _18zru2gc _tzy4kb7n _k48p1wq8 _syaz1e9r _y3gn1h6o _otyr1d21",
            animated && "",
            animated && "_j7hqq7op _5sag1nwe _1pgl1ytf _tip812c5"
        ]),
        children: props.children
    });
};

});

parcelRegister("eD7oJ", function(module, exports) {

$parcel$export(module.exports, "IconMessageWrapper", () => $27a0b8bc658d2227$export$e33129280ab99883);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");
function $27a0b8bc658d2227$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $27a0b8bc658d2227$var$breatheAnimation = (0, $f8Sb3.keyframes)({
    '0%': {
        opacity: 1
    },
    '50%': {
        opacity: 0.3
    },
    '100%': {
        opacity: 1
    }
});
const $27a0b8bc658d2227$var$animatedStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    animationName: $27a0b8bc658d2227$var$breatheAnimation,
    animationDuration: '3.5s',
    animationTimingFunction: 'ease-in-out',
    animationIterationCount: 'infinite'
});
const $27a0b8bc658d2227$var$baseStyles = {
    name: "dl0jwy",
    styles: "overflow:hidden;opacity:1;font-weight:var(--ds-font-weight-medium, 500);color:var(--ds-text-subtlest, #7A869A);text-align:center;margin-bottom:-1em;padding-block:var(--ds-space-050, 4px);padding-inline:var(--ds-space-100, 8px)"
};
const $27a0b8bc658d2227$export$e33129280ab99883 = (props)=>{
    const { animated: animated } = props;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "iconMessageWrapper",
        css: [
            $27a0b8bc658d2227$var$baseStyles,
            animated && $27a0b8bc658d2227$var$animatedStyles
        ]
    }, props.children);
};

});



parcelRegister("4vtR5", function(module, exports) {

$parcel$export(module.exports, "ImageContainer", () => $47433d92621feeff$export$94026ee33dbabc26);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dEW7p = parcelRequire("dEW7p");
const $47433d92621feeff$export$94026ee33dbabc26 = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dEW7p.ImageContainer), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dEW7p.ImageContainer), {
        ...props
    });

});
parcelRegister("dEW7p", function(module, exports) {

$parcel$export(module.exports, "ImageContainer", () => $fa728031d7bf1bc0$export$94026ee33dbabc26);
/* imageContainer-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $fa728031d7bf1bc0$var$imageContainerStyles = null;
const $fa728031d7bf1bc0$var$imageContainerCenterStyles = null;
const $fa728031d7bf1bc0$export$94026ee33dbabc26 = ({ children: children, mediaName: mediaName, status: status, progress: progress, selected: selected, source: source, centerElements: centerElements })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": (0, $025bde419ff72534$export$7a6526d4be3b7eb3),
        /**
 * This wrapper MUST add the classname in order to allow the editor to prevent bubbling up the click event.
 * See the method isInteractiveElement in source platform/packages/editor/renderer/src/ui/Renderer/click-to-edit.ts
 * Also, many other consumer tests rely on this selector.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rko1sit _1e0c1txw _kqswh2mm _p12f1osq _1bsb1osq _4t3i1osq _c71l1osq",
            centerElements && "_2lx21bp4 _1bah1h6o _4cvr1h6o",
            (0, $025bde419ff72534$export$7a6526d4be3b7eb3)
        ]),
        "data-test-media-name": mediaName,
        "data-test-status": status,
        "data-test-progress": progress,
        "data-test-selected": selected,
        "data-test-source": source,
        children: children
    });

});
const $025bde419ff72534$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $025bde419ff72534$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';



parcelRegister("cu1jt", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $94c2b2d945c92fa0$export$e6dfd72ab29f8598);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $pwQN7 = parcelRequire("pwQN7");

var $fFsah = parcelRequire("fFsah");
const $94c2b2d945c92fa0$export$e6dfd72ab29f8598 = (props)=>(0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $pwQN7.Wrapper), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fFsah.Wrapper), {
        ...props
    });

});
parcelRegister("pwQN7", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $6425ff3bed1c4b92$export$e6dfd72ab29f8598);
/* wrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $lr1Nm = parcelRequire("lr1Nm");

var $kwmmf = parcelRequire("kwmmf");

var $a52gQ = parcelRequire("a52gQ");
const $6425ff3bed1c4b92$var$LOCAL_WIDTH_VARIABLE = '--media-wrapper-width';
const $6425ff3bed1c4b92$var$LOCAL_HEIGHT_VARIABLE = '--media-wrapper-height';
const $6425ff3bed1c4b92$var$wrapperStyles = null;
const $6425ff3bed1c4b92$var$backgroundStyle = null;
const $6425ff3bed1c4b92$var$cursorStyleMap = {
    pointer: "_80omtlke",
    wait: "_80omv00u"
};
const $6425ff3bed1c4b92$var$shadowStyleMap = {
    withOverlay: "_16qsx49n",
    selected: "_16qs666x",
    selectedWithOverlay: "_16qs1sw4"
};
const $6425ff3bed1c4b92$var$getShadowKey = (disableOverlay, selected)=>{
    if (!disableOverlay && selected) return 'selectedWithOverlay';
    if (!disableOverlay) return 'withOverlay';
    if (selected) return 'selected';
    return '';
};
const $6425ff3bed1c4b92$var$hideNativeBrowserTextSelectionStyles = null;
const $6425ff3bed1c4b92$var$clickableButtonPlayButtonStyles = null;
const $6425ff3bed1c4b92$var$selectableTickboxStyle = null;
const $6425ff3bed1c4b92$var$tooltipStyle = null;
const $6425ff3bed1c4b92$var$getResponsiveStyles = (breakpoint)=>{
    // dynamically setting the properties to avoid ratcheting build errors. These need to be removed however for the compiled transformation.
    return breakpoint === 'small' ? {
        ['fontSize']: '11px',
        ['lineHeight']: '14px'
    } : {
        ['fontSize']: '14px',
        ['lineHeight']: '22px'
    };
};
const $6425ff3bed1c4b92$export$e6dfd72ab29f8598 = (props)=>{
    const { testId: testId, dimensions: dimensions, appearance: appearance, onClick: onClick, onMouseEnter: onMouseEnter, innerRef: innerRef, breakpoint: breakpoint, mediaCardCursor: mediaCardCursor, disableOverlay: disableOverlay, selected: selected, displayBackground: displayBackground, isPlayButtonClickable: isPlayButtonClickable, isTickBoxSelectable: isTickBoxSelectable, shouldDisplayTooltip: shouldDisplayTooltip } = props;
    const defaultImageCardDimensions = (0, $kwmmf.getDefaultCardDimensions)(appearance);
    const width = (0, $a52gQ.getCSSUnitValue)(dimensions?.width || defaultImageCardDimensions.width);
    const height = (0, $a52gQ.getCSSUnitValue)(dimensions?.height || defaultImageCardDimensions.height);
    const wrapperShadowKey = $6425ff3bed1c4b92$var$getShadowKey(disableOverlay, selected);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        id: "newFileExperienceWrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_2rko1l7b _vchhusvi _kqswh2mm _ect41gqc _p12f1osq _c71l1osq _1bsb1qmm _4t3ine4n _1hlmvd8c _1rquusvi _eg54a8ns _mts3kb7n _1ntskb7n",
            displayBackground && "_bfhk1s4m",
            mediaCardCursor && $6425ff3bed1c4b92$var$cursorStyleMap[mediaCardCursor],
            wrapperShadowKey && $6425ff3bed1c4b92$var$shadowStyleMap[wrapperShadowKey],
            selected && "_1p1y18uv _1rk818uv _14r118uv _1np218uv",
            isPlayButtonClickable && "_1y898vuz _19zy8vuz",
            isTickBoxSelectable && "_1yf91j9a _1xp5kufk",
            shouldDisplayTooltip && "_9m3z1osq _10pb1osq",
            (0, $6d9332e5e7a86517$export$c5ba918dbb0b00f3)
        ]),
        "data-testid": testId,
        style: {
            [$6425ff3bed1c4b92$var$LOCAL_WIDTH_VARIABLE]: width,
            [$6425ff3bed1c4b92$var$LOCAL_HEIGHT_VARIABLE]: height,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...$6425ff3bed1c4b92$var$getResponsiveStyles(breakpoint)
        },
        ref: innerRef,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        ...(0, $lr1Nm.VcMediaWrapperProps),
        children: props.children
    });
};
$6425ff3bed1c4b92$export$e6dfd72ab29f8598.displayName = 'NewFileExperienceWrapper';

});
const $6d9332e5e7a86517$export$c5ba918dbb0b00f3 = 'new-file-experience-wrapper';


parcelRegister("fFsah", function(module, exports) {

$parcel$export(module.exports, "Wrapper", () => $33a3445e248d6e24$export$e6dfd72ab29f8598);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");


var $a7eRZ = parcelRequire("a7eRZ");

var $lr1Nm = parcelRequire("lr1Nm");
const $33a3445e248d6e24$export$e6dfd72ab29f8598 = (props)=>{
    const { testId: testId, dimensions: dimensions, appearance: appearance, onClick: onClick, onMouseEnter: onMouseEnter, innerRef: innerRef, breakpoint: breakpoint, mediaCardCursor: mediaCardCursor, disableOverlay: disableOverlay, selected: selected, displayBackground: displayBackground, isPlayButtonClickable: isPlayButtonClickable, isTickBoxSelectable: isTickBoxSelectable, shouldDisplayTooltip: shouldDisplayTooltip } = props;
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "newFileExperienceWrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $6d9332e5e7a86517$export$c5ba918dbb0b00f3),
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $a7eRZ.wrapperStyles)({
            breakpoint: breakpoint,
            dimensions: dimensions,
            appearance: appearance,
            disableOverlay: disableOverlay,
            displayBackground: displayBackground,
            selected: selected,
            isPlayButtonClickable: isPlayButtonClickable,
            isTickBoxSelectable: isTickBoxSelectable,
            shouldDisplayTooltip: shouldDisplayTooltip,
            mediaCardCursor: mediaCardCursor
        }),
        ref: innerRef,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        ...(0, $lr1Nm.VcMediaWrapperProps)
    }, props.children));
};

});
parcelRegister("a7eRZ", function(module, exports) {

$parcel$export(module.exports, "wrapperStyles", () => $cb66ae08516836c3$export$491e6397d7c1480b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $9Kxjq = parcelRequire("9Kxjq");


var $5yojI = parcelRequire("5yojI");

var $gC46K = parcelRequire("gC46K");

var $6SUdr = parcelRequire("6SUdr");

var $jUG7R = parcelRequire("jUG7R");
const $cb66ae08516836c3$export$491e6397d7c1480b = ({ breakpoint: breakpoint, dimensions: dimensions, appearance: appearance, disableOverlay: disableOverlay, displayBackground: displayBackground, selected: selected, isPlayButtonClickable: isPlayButtonClickable, isTickBoxSelectable: isTickBoxSelectable, shouldDisplayTooltip: shouldDisplayTooltip, mediaCardCursor: mediaCardCursor })=>/*#__PURE__*/ (0, $f8Sb3.css)((0, $gC46K.transition)(), " box-sizing:border-box;*{box-sizing:border-box;}position:relative;font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);", (0, $gC46K.getWrapperDimensions)(dimensions, appearance), " ", displayBackground && `background: ${`var(--ds-background-neutral, ${0, $829f609a65d26a98$export$9fdfb749e33cdf97})`};`, " ", (0, $9Kxjq.borderRadius), " ", (0, $gC46K.getCursorStyle)(mediaCardCursor), " ", (0, $gC46K.getWrapperShadow)(disableOverlay, selected), " ", (0, $gC46K.generateResponsiveStyles)(breakpoint), ";", selected ? (0, $5yojI.hideNativeBrowserTextSelectionStyles) : '', (0, $gC46K.getClickablePlayButtonStyles)(isPlayButtonClickable), " ", (0, $gC46K.getSelectableTickBoxStyles)(isTickBoxSelectable), " &:hover .", (0, $6SUdr.blanketClassName), "{", (0, $6SUdr.fixedBlanketStyles), ";}&:hover .", (0, $jUG7R.actionsBarClassName), ",&:focus-within .", (0, $jUG7R.actionsBarClassName), "{", (0, $jUG7R.fixedActionBarStyles), ";}", shouldDisplayTooltip && `> div { width: 100%; height: 100%; }`, " button:focus+&{outline:solid 2px ", `var(--ds-border-focused, ${(0, $829f609a65d26a98$export$ecfc1dff386a3e7a)})`, ";}");
$cb66ae08516836c3$export$491e6397d7c1480b.displayName = 'NewFileExperienceWrapper';

});
parcelRegister("5yojI", function(module, exports) {

$parcel$export(module.exports, "getSelectionStyles", () => $e0952f45925e7685$export$fb186b651805ffe4);
$parcel$export(module.exports, "hideNativeBrowserTextSelectionStyles", () => $e0952f45925e7685$export$a716852a0c5e54d5);

var $iHYdz = parcelRequire("iHYdz");

var $bzmFE = parcelRequire("bzmFE");
const $e0952f45925e7685$export$fb186b651805ffe4 = (selectionStyles)=>selectionStyles.map((selectionStyle)=>$e0952f45925e7685$var$getSelectionStyle(selectionStyle)).concat($e0952f45925e7685$export$a716852a0c5e54d5).join('\n');
const $e0952f45925e7685$export$a716852a0c5e54d5 = `
  ::selection,*::selection {
    background-color: transparent;
  }
  ::-moz-selection,*::-moz-selection {
    background-color: transparent;
  }
`;
const $e0952f45925e7685$var$getSelectionStyle = (style)=>{
    switch(style){
        case (0, $bzmFE.SelectionStyle).Border:
            return `
        border: ${0, $iHYdz.akEditorSelectedBorder};

        // Fixes ED-15246: Trello card is visible through a border of a table border
        &::after {
          height: 100%;
          content: '\\00a0';
          background: ${0, $iHYdz.akEditorSelectedBorderColor};
          position: absolute;
          right: -1px;
          top: 0;
          bottom: 0;
          width: 1px;
          border: none;
          display: inline-block;
        }
      `;
        case (0, $bzmFE.SelectionStyle).BoxShadow:
            return `
        box-shadow: ${0, $iHYdz.akEditorSelectedBoxShadow};
        border-color: transparent;
        `;
        case (0, $bzmFE.SelectionStyle).Background:
            return `background-color: ${"var(--ds-background-selected, #E9F2FF)"};`;
        case (0, $bzmFE.SelectionStyle).Blanket:
            return `
        position: relative;

        // Fixes ED-9263, where emoji or inline card in panel makes selection go outside the panel
        // in Safari. Looks like it's caused by user-select: all in the emoji element
        -webkit-user-select: text;

        ::before {
          position: absolute;
          content: '';
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          pointer-events: none;
          z-index: ${0, $iHYdz.akEditorSmallZIndex};
          background-color: ${"var(--ds-blanket-selected, #388BFF14)"}
        }`;
        default:
            return '';
    }
};

});
parcelRegister("bzmFE", function(module, exports) {

$parcel$export(module.exports, "SelectionStyle", () => $2bcf46ee398650df$export$80010201b36a8290);
/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */ var $2bcf46ee398650df$export$80010201b36a8290 = /*#__PURE__*/ function(SelectionStyle) {
    SelectionStyle[SelectionStyle["Border"] = 0] = "Border";
    SelectionStyle[SelectionStyle["BoxShadow"] = 1] = "BoxShadow";
    SelectionStyle[SelectionStyle["Background"] = 2] = "Background";
    SelectionStyle[SelectionStyle["Blanket"] = 3] = "Blanket";
    return SelectionStyle;
}({});

});





parcelRegister("eRJkE", function(module, exports) {

$parcel$export(module.exports, "useBreakpoint", () => $ac0298a3deb67ec5$export$199d6754bdf4e1e3);

var $5uXOq = parcelRequire("5uXOq");

var $gC46K = parcelRequire("gC46K");

var $kwmmf = parcelRequire("kwmmf");
var $i9jF7 = parcelRequire("i9jF7");
var $fTh39 = parcelRequire("fTh39");
const $ac0298a3deb67ec5$export$199d6754bdf4e1e3 = (dimensionWidth = 0, divRef)=>{
    const breakpoint = (0, $5uXOq.useMemo)(()=>{
        let widthToCalculate;
        if (dimensionWidth) {
            if ((0, $fTh39.isValidPercentageUnit)(dimensionWidth) && divRef.current) {
                const width = (0, $i9jF7.getElementDimension)(divRef.current, 'width');
                widthToCalculate = width || (0, $kwmmf.defaultImageCardDimensions).width;
            } else widthToCalculate = dimensionWidth;
        } else widthToCalculate = (0, $kwmmf.defaultImageCardDimensions).width;
        return (0, $gC46K.calcBreakpointSize)(parseInt(`${widthToCalculate}`, 10));
    }, [
        dimensionWidth,
        divRef
    ]);
    return breakpoint;
};

});
parcelRegister("i9jF7", function(module, exports) {

$parcel$export(module.exports, "getElementDimension", () => $0182b985f70fe4c2$export$5ceade75ca11ae14);
const $0182b985f70fe4c2$export$5ceade75ca11ae14 = (element, dimension)=>{
    const dimensionValue = element.getBoundingClientRect()[dimension];
    return Math.round(dimensionValue);
};

});

parcelRegister("fTh39", function(module, exports) {

$parcel$export(module.exports, "isValidPercentageUnit", () => $fea106ada9db6a59$export$c30ed4dee1ebdfbf);
// Utility used to know if the integrator is using percentage values
const $fea106ada9db6a59$export$c30ed4dee1ebdfbf = (value)=>{
    const valueString = `${value}`;
    return valueString[valueString.length - 1] === '%' && !isNaN(+valueString.slice(0, -1));
};

});


parcelRegister("cR8Mn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b10988cba6a47774$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");
var $koVbs = parcelRequire("koVbs");

var $fUEF9 = parcelRequire("fUEF9");

var $3Lty3 = parcelRequire("3Lty3");

var $jldZL = parcelRequire("jldZL");
const $b10988cba6a47774$var$OpenMediaViewerButton = ({ fileName: fileName, innerRef: innerRef, ...props })=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            ref: innerRef,
            ...props,
            children: intl.formatMessage((0, $fUEF9.messages).open_file_in_viewer, {
                name: fileName
            })
        })
    });
};
const $b10988cba6a47774$var$OpenMediaViewerButtonWrapper = (props)=>{
    return props.intl ? /*#__PURE__*/ (0, $2OMIu.jsx)($b10988cba6a47774$var$OpenMediaViewerButton, {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: "en",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($b10988cba6a47774$var$OpenMediaViewerButton, {
            ...props
        })
    });
};
var $b10988cba6a47774$export$2e2bcd8739ae039 = (0, $8RXs9.default)($b10988cba6a47774$var$OpenMediaViewerButtonWrapper, {
    enforceContext: false
});

});

parcelRegister("5zeO2", function(module, exports) {

$parcel$export(module.exports, "SvgView", () => $fe737320739e4c21$export$cf98b60e5f1e2515);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $iCXPt = parcelRequire("iCXPt");

var $hKWXR = parcelRequire("hKWXR");

var $2hxaD = parcelRequire("2hxaD");
const $fe737320739e4c21$export$cf98b60e5f1e2515 = (props)=>{
    return (0, $VSDnB.fg)('platform_media_card_image_render') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2hxaD.SvgView), {
        ...props
    }) : (0, $VSDnB.fg)('platform_media_compiled') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iCXPt.SvgView), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hKWXR.SvgView), {
        ...props
    });
};

});
parcelRegister("iCXPt", function(module, exports) {

$parcel$export(module.exports, "SvgView", () => $6186f57902d624d1$export$cf98b60e5f1e2515);
/* svgImage-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $avBrk = parcelRequire("avBrk");

var $6otam = parcelRequire("6otam");

var $8ygnw = parcelRequire("8ygnw");
var $iAd5C = parcelRequire("iAd5C");
const $6186f57902d624d1$var$getErrorReason = (svgReason)=>{
    switch(svgReason){
        case 'img-error':
            return 'svg-img-error';
        case 'binary-fetch':
            return 'svg-binary-fetch';
        case 'blob-to-datauri':
            return 'svg-blob-to-datauri';
        default:
            return 'svg-unknown-error';
    }
};
const $6186f57902d624d1$var$svgRendererStyles = null;
const $6186f57902d624d1$var$svgRendererMaxDimensionStyles = null;
const $6186f57902d624d1$export$cf98b60e5f1e2515 = ({ identifier: identifier, resizeMode: resizeMode, onLoad: onLoad, onError: onError, wrapperRef: wrapperRef, alt: alt })=>{
    const [didSvgRender, setDidSvgRender] = (0, $5uXOq.useState)(false);
    const [svgDimensions, setSvgDimensions] = (0, $5uXOq.useState)({});
    const imgRef = (0, $5uXOq.useRef)(null);
    const calculateDimensions = (0, $5uXOq.useCallback)((targetImgElem)=>{
        if (!wrapperRef.current || !targetImgElem) return;
        setSvgDimensions((0, $6otam.calculateSvgDimensions)(targetImgElem, wrapperRef.current, resizeMode));
    }, [
        resizeMode,
        wrapperRef
    ]);
    const onSvgLoad = (evt)=>{
        calculateDimensions(evt.currentTarget);
        setDidSvgRender(true);
        onLoad?.();
    };
    const onSvgError = (err)=>{
        const error = new (0, $avBrk.MediaCardError)($6186f57902d624d1$var$getErrorReason(err.primaryReason), err.secondaryError);
        onError?.(error);
    };
    (0, $5uXOq.useEffect)(()=>{
        if (imgRef.current) calculateDimensions(imgRef.current);
    }, [
        imgRef,
        calculateDimensions
    ]);
    const { svgUrl: svgUrl, source: source } = (0, $iAd5C.useResolveSvg)(identifier, onSvgError);
    const { width: width, height: height } = svgDimensions;
    return svgUrl && source ? /*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        "data-testid": 'media-card-svg',
        "data-fileid": identifier.id,
        "data-filecollection": identifier.collectionName,
        "data-source": source,
        src: svgUrl,
        alt: alt,
        style: {
            visibility: didSvgRender ? 'visible' : 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...svgDimensions
        },
        onLoad: onSvgLoad,
        onError: ()=>{
            onSvgError(new (0, $8ygnw.MediaSVGError)('img-error'));
        },
        ref: imgRef,
        className: (0, $bwpsq.default)([
            "_5ral1f51 _bfhku67f",
            !width && !height && "_p12f1osq _c71l1osq"
        ])
    }) : null;
};

});
parcelRegister("6otam", function(module, exports) {

$parcel$export(module.exports, "calculateSvgDimensions", () => $4e2cd24b2a9135ca$export$56f32e61c4316384);
const $4e2cd24b2a9135ca$export$56f32e61c4316384 = (imgElement, parentElement, resizeMode)=>{
    const { naturalWidth: naturalWidth, width: width, naturalHeight: naturalHeight, height: height } = imgElement;
    // Firefox & Safari can't always read the "natural" dimensions correctly.
    // When these are undefined or zero, we replace them with the rendered values
    const imgWidth = naturalWidth || width;
    const imgHeight = naturalHeight || height;
    const { width: parentWidth, height: parentHeight } = parentElement.getBoundingClientRect();
    if (resizeMode === 'fit' || resizeMode === 'full-fit') return {
        maxWidth: `min(100%, ${imgWidth}px)`,
        maxHeight: `min(100%, ${imgHeight}px)`
    };
    const imgRatio = imgWidth / imgHeight;
    const cardRatio = parentWidth / parentHeight;
    const isImageLandscapier = imgRatio > cardRatio;
    if (resizeMode === 'stretchy-fit') {
        if (isImageLandscapier) return {
            width: '100%',
            maxHeight: '100%'
        };
        else return {
            height: '100%',
            maxWidth: '100%'
        };
    }
    if (resizeMode === 'crop') {
        if (isImageLandscapier) return {
            height: imgHeight,
            maxHeight: '100%'
        };
        else return {
            width: imgWidth,
            maxWidth: '100%'
        };
    }
    return {};
};

});

parcelRegister("8ygnw", function(module, exports) {

$parcel$export(module.exports, "MediaSVGError", () => $938abda235f4af09$export$c4ae8d1d12c193a7);
$parcel$export(module.exports, "createUnexpectedErrorCallback", () => $938abda235f4af09$export$ba08301c71bd9cf6);
class $938abda235f4af09$export$c4ae8d1d12c193a7 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
const $938abda235f4af09$export$ba08301c71bd9cf6 = (onError)=>(e)=>{
        onError?.(new $938abda235f4af09$export$c4ae8d1d12c193a7('unexpected', e));
    };

});

parcelRegister("iAd5C", function(module, exports) {

$parcel$export(module.exports, "useResolveSvg", () => $ddb4927d200ecf8f$export$d127d14f68c2bbcf);

var $5uXOq = parcelRequire("5uXOq");

var $24tOd = parcelRequire("24tOd");
var $cEHh7 = parcelRequire("cEHh7");

var $egH7V = parcelRequire("egH7V");

var $88hGE = parcelRequire("88hGE");

var $8ygnw = parcelRequire("8ygnw");
// We need to convert the blob into Base64 for security reasons: https://asecurityteam.atlassian.net/browse/VULN-1495952
// Make sure to update the test helper mockFileReader if this is changed
function $ddb4927d200ecf8f$var$blobToBase64(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onloadend = ()=>resolve(// reader.readAsDataURL makes reader.result a string
            // https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            reader.result);
        reader.onerror = (e)=>reject(new (0, $8ygnw.MediaSVGError)('blob-to-datauri', e instanceof Error ? e : undefined));
        reader.readAsDataURL(blob);
    });
}
const $ddb4927d200ecf8f$var$getLocalSvg = async (preview)=>{
    const { value: value } = await preview;
    if (typeof value === 'string') return value;
    return $ddb4927d200ecf8f$var$blobToBase64(value);
};
const $ddb4927d200ecf8f$var$getRemoteSvg = async ({ id: id, collectionName: collectionName }, mediaClient)=>{
    const blob = await mediaClient.mediaStore.getFileBinary(id, collectionName).catch((e)=>{
        throw new (0, $8ygnw.MediaSVGError)('binary-fetch', e instanceof Error ? e : undefined);
    });
    return await $ddb4927d200ecf8f$var$blobToBase64(blob);
};
const $ddb4927d200ecf8f$export$d127d14f68c2bbcf = (identifier, onError)=>{
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const { id: id, collectionName: collectionName } = identifier;
    const { id: prevId } = (0, $88hGE.usePrevious)(identifier) || identifier;
    const { fileState: fileState } = (0, $24tOd.useFileState)(id, {
        collectionName: collectionName
    });
    const [svgUrl, setSvgUrl] = (0, $5uXOq.useState)(undefined);
    const [source, setSource] = (0, $5uXOq.useState)(undefined);
    const onErrorRef = (0, $egH7V.useCurrentValueRef)(onError);
    (0, $5uXOq.useEffect)(()=>{
        if (id !== prevId) setSvgUrl(undefined);
    }, [
        id,
        prevId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (svgUrl || !fileState || fileState.status === 'error' || fileState?.mimeType !== 'image/svg+xml') return;
        const { preview: preview } = fileState;
        if (preview) $ddb4927d200ecf8f$var$getLocalSvg(preview).then((content)=>{
            setSvgUrl(content);
            setSource('local');
        }).catch(onErrorRef.current);
        else $ddb4927d200ecf8f$var$getRemoteSvg(identifier, mediaClient).then((content)=>{
            setSvgUrl(content);
            setSource('remote');
        }).catch(onErrorRef.current);
    }, [
        identifier,
        fileState,
        mediaClient,
        onErrorRef,
        svgUrl
    ]);
    return {
        svgUrl: svgUrl,
        source: source
    };
};

});
parcelRegister("24tOd", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $768d10f5fd62ab89$export$90ff537b0999afb);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");

var $k4CmR = parcelRequire("k4CmR");
function $768d10f5fd62ab89$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const fileState = (0, $k4CmR.useMediaStore)((state)=>state.files[id]);
    (0, $5uXOq.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("k4CmR", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $a907ffa2ecfaf54d$export$8a9cc8c330400af8);

var $6esDR = parcelRequire("6esDR");

var $cEHh7 = parcelRequire("cEHh7");
const $a907ffa2ecfaf54d$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $6esDR.useStore)(store, selector, equals);
function $a907ffa2ecfaf54d$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $a907ffa2ecfaf54d$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("6esDR", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $489a4492a45245b1$export$6ccbb43953eebf8);

var $ee7sp = parcelRequire("ee7sp");

var $5uXOq = parcelRequire("5uXOq");

var $lNQti = parcelRequire("lNQti");
var $489a4492a45245b1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $489a4492a45245b1$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)));
const { useSyncExternalStoreWithSelector: $489a4492a45245b1$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($lNQti)));
let $489a4492a45245b1$var$didWarnAboutEqualityFn = false;
const $489a4492a45245b1$var$identity = (arg)=>arg;
function $489a4492a45245b1$export$6ccbb43953eebf8(api, selector = $489a4492a45245b1$var$identity, equalityFn) {
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$489a4492a45245b1$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $489a4492a45245b1$var$didWarnAboutEqualityFn = true;
    }
    const slice = $489a4492a45245b1$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $489a4492a45245b1$var$useDebugValue(slice);
    return slice;
}
const $489a4492a45245b1$var$createImpl = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $ee7sp.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$489a4492a45245b1$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $489a4492a45245b1$export$185802fd694ee1f5 = (createState)=>createState ? $489a4492a45245b1$var$createImpl(createState) : $489a4492a45245b1$var$createImpl;
var $489a4492a45245b1$export$2e2bcd8739ae039 = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $489a4492a45245b1$export$185802fd694ee1f5(createState);
};

});
parcelRegister("lNQti", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hUiTL"));

});
parcelRegister("hUiTL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d096537a1780f6c5$export$bf730a2d8bf68b42, (v) => $d096537a1780f6c5$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d096537a1780f6c5$export$bf730a2d8bf68b42;
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $goz36 = parcelRequire("goz36");
function $d096537a1780f6c5$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d096537a1780f6c5$var$q = "function" === typeof Object.is ? Object.is : $d096537a1780f6c5$var$p, $d096537a1780f6c5$var$r = $goz36.useSyncExternalStore, $d096537a1780f6c5$var$t = $5uXOq.useRef, $d096537a1780f6c5$var$u = $5uXOq.useEffect, $d096537a1780f6c5$var$v = $5uXOq.useMemo, $d096537a1780f6c5$var$w = $5uXOq.useDebugValue;
$d096537a1780f6c5$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $d096537a1780f6c5$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $d096537a1780f6c5$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($d096537a1780f6c5$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $d096537a1780f6c5$var$r(a, c[0], c[1]);
    $d096537a1780f6c5$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $d096537a1780f6c5$var$w(d);
    return d;
};

});
parcelRegister("goz36", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jcmQl"));

});
parcelRegister("jcmQl", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16, (v) => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dfa0db7ec3fca60b$export$306c0aa65ff9ec16;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $dfa0db7ec3fca60b$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $dfa0db7ec3fca60b$var$k = "function" === typeof Object.is ? Object.is : $dfa0db7ec3fca60b$var$h, $dfa0db7ec3fca60b$var$l = $5uXOq.useState, $dfa0db7ec3fca60b$var$m = $5uXOq.useEffect, $dfa0db7ec3fca60b$var$n = $5uXOq.useLayoutEffect, $dfa0db7ec3fca60b$var$p = $5uXOq.useDebugValue;
function $dfa0db7ec3fca60b$var$q(a, b) {
    var d = b(), f = $dfa0db7ec3fca60b$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $dfa0db7ec3fca60b$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $dfa0db7ec3fca60b$var$m(function() {
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $dfa0db7ec3fca60b$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $dfa0db7ec3fca60b$var$p(d);
    return d;
}
function $dfa0db7ec3fca60b$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$dfa0db7ec3fca60b$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $dfa0db7ec3fca60b$var$t(a, b) {
    return b();
}
var $dfa0db7ec3fca60b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dfa0db7ec3fca60b$var$t : $dfa0db7ec3fca60b$var$q;
$dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = void 0 !== $5uXOq.useSyncExternalStore ? $5uXOq.useSyncExternalStore : $dfa0db7ec3fca60b$var$u;

});







parcelRegister("egH7V", function(module, exports) {

$parcel$export(module.exports, "useCurrentValueRef", () => $60a65ac59efffaa9$export$b3e10e1f0fbb71db);

var $5uXOq = parcelRequire("5uXOq");
function $60a65ac59efffaa9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}

});

parcelRegister("88hGE", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $1379ec3c074cc710$export$5cae361ad82dce8b);

var $5uXOq = parcelRequire("5uXOq");
function $1379ec3c074cc710$export$5cae361ad82dce8b(value) {
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});



parcelRegister("hKWXR", function(module, exports) {

$parcel$export(module.exports, "SvgView", () => $672d1ee237fe56e5$export$cf98b60e5f1e2515);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $avBrk = parcelRequire("avBrk");

var $6otam = parcelRequire("6otam");

var $8ygnw = parcelRequire("8ygnw");
var $iAd5C = parcelRequire("iAd5C");
function $672d1ee237fe56e5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $672d1ee237fe56e5$var$getErrorReason = (svgReason)=>{
    switch(svgReason){
        case 'img-error':
            return 'svg-img-error';
        case 'binary-fetch':
            return 'svg-binary-fetch';
        case 'blob-to-datauri':
            return 'svg-blob-to-datauri';
        default:
            return 'svg-unknown-error';
    }
};
const $672d1ee237fe56e5$var$svgRendererStyles = {
    name: "19l0qnz",
    styles: "object-fit:contain;background-color:white"
};
const $672d1ee237fe56e5$var$svgRendererMaxDimensionStyles = {
    name: "vb5fe1",
    styles: "max-width:100%;max-height:100%"
};
const $672d1ee237fe56e5$export$cf98b60e5f1e2515 = ({ identifier: identifier, resizeMode: resizeMode, onLoad: onLoad, onError: onError, wrapperRef: wrapperRef, alt: alt })=>{
    const [didSvgRender, setDidSvgRender] = (0, $5uXOq.useState)(false);
    const [svgDimensions, setSvgDimensions] = (0, $5uXOq.useState)({});
    const imgRef = (0, $5uXOq.useRef)(null);
    const calculateDimensions = (0, $5uXOq.useCallback)((targetImgElem)=>{
        if (!wrapperRef.current || !targetImgElem) return;
        setSvgDimensions((0, $6otam.calculateSvgDimensions)(targetImgElem, wrapperRef.current, resizeMode));
    }, [
        resizeMode,
        wrapperRef
    ]);
    const onSvgLoad = (evt)=>{
        calculateDimensions(evt.currentTarget);
        setDidSvgRender(true);
        onLoad?.();
    };
    const onSvgError = (err)=>{
        const error = new (0, $avBrk.MediaCardError)($672d1ee237fe56e5$var$getErrorReason(err.primaryReason), err.secondaryError);
        onError?.(error);
    };
    (0, $5uXOq.useEffect)(()=>{
        if (imgRef.current) calculateDimensions(imgRef.current);
    }, [
        imgRef,
        calculateDimensions
    ]);
    const { svgUrl: svgUrl, source: source } = (0, $iAd5C.useResolveSvg)(identifier, onSvgError);
    const { width: width, height: height } = svgDimensions;
    return svgUrl && source ? /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        "data-testid": 'media-card-svg',
        "data-fileid": identifier.id,
        "data-filecollection": identifier.collectionName,
        "data-source": source,
        src: svgUrl,
        alt: alt,
        css: [
            $672d1ee237fe56e5$var$svgRendererStyles,
            !width && !height && $672d1ee237fe56e5$var$svgRendererMaxDimensionStyles
        ],
        style: {
            visibility: didSvgRender ? 'visible' : 'hidden',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...svgDimensions
        },
        onLoad: onSvgLoad,
        onError: ()=>{
            onSvgError(new (0, $8ygnw.MediaSVGError)('img-error'));
        },
        ref: imgRef
    }) : null;
};

});

parcelRegister("2hxaD", function(module, exports) {

$parcel$export(module.exports, "SvgView", () => $2f404e7842a195c0$export$cf98b60e5f1e2515);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $5uXOq = parcelRequire("5uXOq");

var $avBrk = parcelRequire("avBrk");

var $8ygnw = parcelRequire("8ygnw");
var $iAd5C = parcelRequire("iAd5C");

var $8jUB8 = parcelRequire("8jUB8");
const $2f404e7842a195c0$var$getErrorReason = (svgReason)=>{
    switch(svgReason){
        case 'img-error':
            return 'svg-img-error';
        case 'binary-fetch':
            return 'svg-binary-fetch';
        case 'blob-to-datauri':
            return 'svg-blob-to-datauri';
        default:
            return 'svg-unknown-error';
    }
};
const $2f404e7842a195c0$export$cf98b60e5f1e2515 = ({ identifier: identifier, resizeMode: resizeMode, onLoad: onLoad, onError: onError, wrapperRef: wrapperRef, alt: alt })=>{
    const onSvgError = (err)=>{
        const error = new (0, $avBrk.MediaCardError)($2f404e7842a195c0$var$getErrorReason(err.primaryReason), err.secondaryError);
        onError?.(error);
    };
    const { svgUrl: svgUrl, source: source } = (0, $iAd5C.useResolveSvg)(identifier, onSvgError);
    const cardPreview = (0, $5uXOq.useMemo)(()=>svgUrl && source ? {
            dataURI: svgUrl,
            source: source
        } : undefined, [
        svgUrl,
        source
    ]);
    return cardPreview ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $8jUB8.ImageRenderer), {
        testId: "media-card-svg",
        identifier: identifier,
        cardPreview: cardPreview,
        alt: alt,
        resizeMode: resizeMode,
        onImageLoad: onLoad,
        onImageError: ()=>{
            onSvgError(new (0, $8ygnw.MediaSVGError)('img-error'));
        },
        wrapperRef: wrapperRef,
        mediaType: "image",
        useWhiteBackground: true
    }) : null;
};

});



parcelRegister("9yjd0", function(module, exports) {

$parcel$export(module.exports, "performanceNow", () => $08ad11c606c56749$export$fb4230f160368c88);
const $08ad11c606c56749$export$fb4230f160368c88 = ()=>performance.now();

});


parcelRegister("cqXs3", function(module, exports) {

$parcel$export(module.exports, "FileCard", () => $a13bc202c484b735$export$593fd10f7e6c6505);

var $2OMIu = parcelRequire("2OMIu");

var $2NMNM = parcelRequire("2NMNM");

var $bfb59 = parcelRequire("bfb59");
var $cUAFJ = parcelRequire("cUAFJ");
var $1Pp1U = parcelRequire("1Pp1U");
var $7E56q = parcelRequire("7E56q");
var $gFZHi = parcelRequire("gFZHi");

var $24tOd = parcelRequire("24tOd");
var $cEHh7 = parcelRequire("cEHh7");

var $27T0s = parcelRequire("27T0s");
var $8GKRF = parcelRequire("8GKRF");
var $jzW7G = parcelRequire("jzW7G");

var $6ZIFT = parcelRequire("6ZIFT");

var $5uXOq = parcelRequire("5uXOq");

var $3Du7S = parcelRequire("3Du7S");

var $avBrk = parcelRequire("avBrk");

var $apIKb = parcelRequire("apIKb");

var $c3l1i = parcelRequire("c3l1i");

var $1HkJZ = parcelRequire("1HkJZ");

var $hOlel = parcelRequire("hOlel");

var $cSJ4P = parcelRequire("cSJ4P");

var $kNDBv = parcelRequire("kNDBv");

var $dnnKy = parcelRequire("dnnKy");

var $klfbI = parcelRequire("klfbI");

var $hSY3r = parcelRequire("hSY3r");

var $kwmmf = parcelRequire("kwmmf");

var $dyIlI = parcelRequire("dyIlI");

var $ajqQB = parcelRequire("ajqQB");

var $6xnfM = parcelRequire("6xnfM");

var $10b0h = parcelRequire("10b0h");

var $hn1fT = parcelRequire("hn1fT");

var $9yjd0 = parcelRequire("9yjd0");

var $4qUCy = parcelRequire("4qUCy");

var $koVbs = parcelRequire("koVbs");

var $1k7cJ = parcelRequire("1k7cJ");

var $VSDnB = parcelRequire("VSDnB");

var $tcn7E = parcelRequire("tcn7E");
const $a13bc202c484b735$var$traceContextRetriever = ()=>{
    const trace = (0, $tcn7E.getActiveTrace)();
    if (trace && (0, $VSDnB.fg)('platform-filecard-ufo-trace')) return {
        traceId: trace?.traceId,
        spanId: trace?.spanId
    };
    else return {
        traceId: (0, $27T0s.getRandomHex)(8)
    };
};
const $a13bc202c484b735$export$593fd10f7e6c6505 = ({ appearance: appearance = 'auto', resizeMode: resizeMode = 'crop', isLazy: isLazy = true, disableOverlay: disableOverlay = false, featureFlags: // Media Feature Flag defaults are defined in @atlaskit/media-common
featureFlags = {}, identifier: identifier, ssr: ssr, dimensions: dimensions, originalDimensions: originalDimensions, contextId: contextId, alt: alt, actions: actions, shouldEnableDownloadButton: shouldEnableDownloadButton, useInlinePlayer: useInlinePlayer, shouldOpenMediaViewer: shouldOpenMediaViewer, onFullscreenChange: onFullscreenChange, selectable: selectable, selected: selected, testId: testId, titleBoxBgColor: titleBoxBgColor, titleBoxIcon: titleBoxIcon, shouldHideTooltip: shouldHideTooltip, mediaViewerItems: mediaViewerItems, onClick: onClick, onMouseEnter: onMouseEnter, videoControlsWrapperRef: videoControlsWrapperRef, viewerOptions: viewerOptions, includeHashForDuplicateFiles: includeHashForDuplicateFiles })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isAbuseModalOpen, setIsAbuseModalOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    //----------------------------------------------------------------//
    //------------ State, Refs & Initial Values ----------------------//
    //----------------------------------------------------------------//
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const [cardElement, setCardElement] = (0, $5uXOq.useState)(null);
    const cardDimensions = dimensions || (0, $kwmmf.getDefaultCardDimensions)(appearance);
    // Calculate the preview dimensions if card dimensions are "percentage" based
    const previewDimensions = (0, $5uXOq.useMemo)(()=>// resolving dimensions is eventually an expensive operation if the dimensions are a percentage
        // thus needs to be memoized
        (0, $1HkJZ.resolveCardPreviewDimensions)({
            dimensions: cardDimensions,
            element: cardElement
        }), [
        cardDimensions,
        cardElement
    ]);
    const [isCardVisible, setIsCardVisible] = (0, $5uXOq.useState)(!isLazy);
    const { fileState: fileState } = (0, $24tOd.useFileState)(identifier.id, {
        skipRemote: !isCardVisible,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey,
        includeHashForDuplicateFiles: includeHashForDuplicateFiles
    });
    const prevFileState = (0, $klfbI.usePrevious)(fileState && (0, $1Pp1U.isErrorFileState)(fileState) ? undefined : fileState);
    const fileStateValue = (0, $5uXOq.useMemo)(()=>{
        if (fileState && !(0, $1Pp1U.isErrorFileState)(fileState)) return fileState;
        return prevFileState;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        fileState
    ]);
    const dateOverrides = (0, $5uXOq.useContext)((0, $4qUCy.DateOverrideContext));
    const overridenDate = dateOverrides?.[identifier.id];
    //----------------------------------------------------------------//
    //------------ State, Refs & Initial Values ----------------------//
    //----------------------------------------------------------------//
    const internalOccurrenceKey = (0, $5uXOq.useMemo)(()=>(0, $c3l1i.generateUniqueId)(), []);
    const timeElapsedTillCommenced = (0, $5uXOq.useMemo)(()=>(0, $9yjd0.performanceNow)(), []);
    const fileStateFlagsRef = (0, $5uXOq.useRef)({
        wasStatusUploading: false,
        wasStatusProcessing: false
    });
    const mediaViewerButtonRef = (0, $5uXOq.useRef)(null);
    // Generate unique traceId for file
    const traceContext = (0, $5uXOq.useMemo)($a13bc202c484b735$var$traceContextRetriever, []);
    const [status, setStatus] = (0, $5uXOq.useState)('loading');
    const [isPlayingFile, setIsPlayingFile] = (0, $5uXOq.useState)(false);
    const [shouldAutoplay, setShouldAutoplay] = (0, $5uXOq.useState)(false);
    const [previewDidRender, setPreviewDidRender] = (0, $5uXOq.useState)(false);
    const mediaBlobUrlAttrs = (0, $5uXOq.useMemo)(()=>{
        const { id: id, collectionName: collection } = identifier;
        const { mimeType: mimeType, name: name, size: size } = (0, $cSJ4P.getFileDetails)(identifier, fileStateValue);
        return contextId ? {
            id: id,
            collection: collection,
            contextId: contextId,
            mimeType: mimeType,
            name: name,
            size: size,
            ...originalDimensions || previewDimensions,
            alt: alt
        } : undefined;
    }, [
        alt,
        previewDimensions,
        contextId,
        fileStateValue,
        identifier,
        originalDimensions
    ]);
    const { preview: preview, status: previewStatus, error: previewError, nonCriticalError: nonCriticalError, ssrReliability: ssrReliability, onImageError: onImageErrorBase, onImageLoad: onImageLoadBase, getSsrScriptProps: getSsrScriptProps, copyNodeRef: copyNodeRef } = (0, $10b0h.useFilePreview)({
        mediaBlobUrlAttrs: mediaBlobUrlAttrs,
        resizeMode: (0, $cUAFJ.imageResizeModeToFileImageMode)(resizeMode),
        identifier: identifier,
        ssr: ssr,
        dimensions: previewDimensions,
        traceContext: traceContext,
        skipRemote: !isCardVisible,
        source: 'mediaCard'
    });
    const shouldSendPerformanceEventRef = (0, $5uXOq.useRef)((0, $kNDBv.shouldPerformanceBeSampled)());
    const [error, setError] = (0, $5uXOq.useState)();
    // CXP-2723 TODO: TEMPORARY VARIABLES
    const finalError = error || (previewError && previewError.primaryReason !== 'failed-processing' && fileStateValue?.mimeType !== 'image/svg+xml' ? previewError : undefined);
    const finalStatus = finalError ? 'error' : status === 'failed-processing' && fileStateValue?.mimeType === 'image/svg+xml' ? 'loading-preview' : status;
    const [mediaViewerSelectedItem, setMediaViewerSelectedItem] = (0, $5uXOq.useState)(null);
    const uploadProgressRef = (0, $5uXOq.useRef)();
    const metadata = (0, $5uXOq.useMemo)(()=>{
        const getProcessingStatusFromFileState = (status)=>{
            switch(status){
                case 'processed':
                    return 'succeeded';
                case 'processing':
                    return 'running';
                case 'failed-processing':
                    return 'failed';
            }
        };
        if (fileStateValue) return {
            id: fileStateValue.id,
            name: fileStateValue.name,
            size: fileStateValue.size,
            mimeType: fileStateValue.mimeType,
            createdAt: fileStateValue.createdAt,
            mediaType: fileStateValue.mediaType,
            processingStatus: getProcessingStatusFromFileState(fileStateValue.status)
        };
        else return {
            id: identifier.id
        };
    }, [
        fileStateValue,
        identifier.id
    ]);
    const fileAttributes = (0, $5uXOq.useMemo)(()=>{
        return {
            fileMediatype: metadata.mediaType,
            fileMimetype: metadata.mimeType,
            fileId: metadata.id,
            fileSize: metadata.size,
            fileStatus: fileStateValue?.status
        };
    }, [
        fileStateValue?.status,
        metadata.id,
        metadata.mediaType,
        metadata.mimeType,
        metadata.size
    ]);
    const downloadFn = (0, $5uXOq.useCallback)(async ()=>{
        try {
            await mediaClient.file.downloadBinary(identifier.id, metadata.name, identifier.collectionName, traceContext);
            (0, $dyIlI.fireDownloadSucceededEvent)(createAnalyticsEvent, fileAttributes, traceContext, fileStateValue?.metadataTraceContext);
        } catch (e) {
            const error = new (0, $avBrk.MediaCardError)('download', e);
            (0, $dyIlI.fireDownloadFailedEvent)(createAnalyticsEvent, fileAttributes, error, traceContext, fileStateValue?.metadataTraceContext);
        }
    }, [
        createAnalyticsEvent,
        fileAttributes,
        fileStateValue?.metadataTraceContext,
        identifier.collectionName,
        identifier.id,
        mediaClient.file,
        metadata.name,
        traceContext
    ]);
    const computedActions = (0, $5uXOq.useMemo)(()=>{
        if (finalStatus === 'failed-processing' || shouldEnableDownloadButton) {
            const handler = async ()=>{
                if (!!fileStateValue?.abuseClassification) setIsAbuseModalOpen(true);
                else await downloadFn();
            };
            const downloadAction = (0, $hn1fT.createDownloadAction)({
                handler: handler,
                isDisabled: mediaClient.config.enforceDataSecurityPolicy
            }, formatMessage);
            return [
                downloadAction,
                ...actions ?? []
            ];
        } else return actions;
    }, [
        actions,
        mediaClient.config.enforceDataSecurityPolicy,
        shouldEnableDownloadButton,
        finalStatus,
        formatMessage,
        fileStateValue?.abuseClassification,
        downloadFn
    ]);
    //----------------------------------------------------------------//
    //---------------------- Analytics  ------------------------------//
    //----------------------------------------------------------------//
    const fireOperationalEventRef = (0, $dnnKy.useCurrentValueRef)(()=>{
        const timeElapsedTillEvent = (0, $9yjd0.performanceNow)();
        const durationSinceCommenced = timeElapsedTillEvent - timeElapsedTillCommenced;
        const performanceAttributes = {
            overall: {
                durationSincePageStart: timeElapsedTillEvent,
                durationSinceCommenced: durationSinceCommenced
            }
        };
        createAnalyticsEvent && (0, $dyIlI.fireOperationalEvent)(createAnalyticsEvent, finalStatus, fileAttributes, performanceAttributes, ssrReliability, finalError, traceContext, fileStateValue?.metadataTraceContext);
        shouldSendPerformanceEventRef.current && (0, $kNDBv.completeUfoExperience)(internalOccurrenceKey, finalStatus, fileAttributes, fileStateFlagsRef.current, ssrReliability, finalError);
    });
    const fireNonCriticalErrorEventRef = (0, $dnnKy.useCurrentValueRef)((error)=>{
        createAnalyticsEvent && (0, $dyIlI.fireNonCriticalErrorEvent)(createAnalyticsEvent, finalStatus, fileAttributes, ssrReliability, error, traceContext, fileStateValue?.metadataTraceContext);
    });
    (0, $5uXOq.useEffect)(()=>{
        if (nonCriticalError) fireNonCriticalErrorEventRef.current(nonCriticalError);
    }, [
        nonCriticalError,
        fireNonCriticalErrorEventRef
    ]);
    const startUfoExperienceRef = (0, $dnnKy.useCurrentValueRef)(()=>{
        if (shouldSendPerformanceEventRef.current) (0, $kNDBv.startUfoExperience)(internalOccurrenceKey);
    });
    const fireAbortedEventRef = (0, $dnnKy.useCurrentValueRef)(()=>{
        // UFO won't abort if it's already in a final state (succeeded, failed, aborted, etc)
        if (shouldSendPerformanceEventRef.current) (0, $kNDBv.abortUfoExperience)(internalOccurrenceKey, {
            fileAttributes: fileAttributes,
            fileStateFlags: fileStateFlagsRef?.current,
            ssrReliability: ssrReliability
        });
    });
    //----------------------------------------------------------------//
    //--------------------- Focus on Close Viewer  -------------------//
    //----------------------------------------------------------------//
    const wasViewerPreviouslyOpen = (0, $klfbI.usePrevious)(mediaViewerSelectedItem);
    (0, $5uXOq.useEffect)(()=>{
        if (wasViewerPreviouslyOpen && !mediaViewerSelectedItem) mediaViewerButtonRef.current?.focus();
    }, [
        wasViewerPreviouslyOpen,
        mediaViewerSelectedItem
    ]);
    //----------------------------------------------------------------//
    //---------------------- Callbacks & Handlers  -------------------//
    //----------------------------------------------------------------//
    const onSvgError = (error)=>{
        setError(error);
        setStatus('error');
    };
    const onImageError = (newCardPreview)=>{
        if (metadata.mimeType === 'image/svg+xml') return;
        onImageErrorBase(newCardPreview);
    };
    const onSvgLoad = ()=>{
        setPreviewDidRender(true);
    };
    const onImageLoad = (newCardPreview)=>{
        if (metadata.mimeType === 'image/svg+xml') return;
        onImageLoadBase(newCardPreview);
        setPreviewDidRender(true);
    };
    const onCardClick = (event, analyticsEvent)=>{
        if (onClick) {
            const cardEvent = {
                event: event,
                mediaItemDetails: metadata
            };
            onClick(cardEvent, analyticsEvent);
        }
    };
    const onCardViewClick = (event, analyticsEvent)=>{
        onCardClick(event, analyticsEvent);
        if (!metadata) return;
        const isVideo = metadata.mediaType === 'video';
        const isBrowserSupported = metadata.mimeType && (0, $8GKRF.isMimeTypeSupportedByBrowser)(metadata.mimeType);
        // TODO: this should be handled by Inline Player
        const isPlayable = !!fileState && (fileState.status === 'processed' || isBrowserSupported && [
            'processing',
            'uploading'
        ].includes(fileState.status));
        if (useInlinePlayer && isVideo && isPlayable && finalStatus !== 'error') {
            setIsPlayingFile(true);
            setShouldAutoplay(true);
        } else if (shouldOpenMediaViewer) setMediaViewerSelectedItem({
            id: identifier.id,
            mediaItemType: 'file',
            collectionName: identifier.collectionName,
            occurrenceKey: identifier.occurrenceKey
        });
    };
    //----------------------------------------------------------------//
    //----------------- update status flags --------------------------//
    //----------------------------------------------------------------//
    (0, $5uXOq.useEffect)(()=>{
        if (fileStateValue?.status === 'processing') fileStateFlagsRef.current.wasStatusProcessing = true;
        else if (fileStateValue?.status === 'uploading') fileStateFlagsRef.current.wasStatusUploading = true;
    }, [
        fileStateValue?.status
    ]);
    //----------------------------------------------------------------//
    //---------------- fetch and resolve card preview ----------------//
    //----------------------------------------------------------------//
    const prevStatus = (0, $klfbI.usePrevious)(finalStatus);
    const prevIsCardVisible = (0, $klfbI.usePrevious)(isCardVisible);
    (0, $5uXOq.useEffect)(()=>{
        if (prevStatus !== undefined && finalStatus !== prevStatus) fireOperationalEventRef.current();
    }, [
        fireOperationalEventRef,
        prevStatus,
        finalStatus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const turnedVisible = !prevIsCardVisible && isCardVisible;
        if (turnedVisible) startUfoExperienceRef.current();
    }, [
        startUfoExperienceRef,
        isCardVisible,
        prevIsCardVisible
    ]);
    //----------------------------------------------------------------//
    //----------------- set isPlayingFile state ----------------------//
    //----------------------------------------------------------------//
    (0, $5uXOq.useEffect)(()=>{
        const isVideo = fileAttributes.fileMediatype === 'video';
        const { mimeType: mimeType } = (0, $cSJ4P.getFileDetails)(identifier, fileStateValue);
        const isVideoPlayable = mimeType && (0, $jzW7G.isVideoMimeTypeSupportedByBrowser)(mimeType) || fileStateValue && (0, $1Pp1U.isProcessedFileState)(fileStateValue);
        if (/**
			 * We need to check that the card is visible before switching to inline player
			 * in order to avoid race conditions of the ViewportDector being unmounted before
			 * it is able to set isCardVisible to true.
			 */ isCardVisible && isVideo && !isPlayingFile && disableOverlay && useInlinePlayer && isVideoPlayable && fileStateValue?.status !== 'failed-processing' && finalStatus !== 'error') setIsPlayingFile(true);
    }, [
        isCardVisible,
        disableOverlay,
        fileAttributes.fileMediatype,
        fileStateValue,
        identifier,
        isPlayingFile,
        finalStatus,
        useInlinePlayer
    ]);
    //----------------------------------------------------------------//
    //----------------- abort UFO experience -------------------------//
    //----------------------------------------------------------------//
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            // eslint-disable-next-line react-hooks/exhaustive-deps
            fireAbortedEventRef.current();
        };
    }, [
        fireAbortedEventRef
    ]);
    //----------------------------------------------------------------//
    // Update Status
    //----------------------------------------------------------------//
    const updateFileStateRef = (0, $dnnKy.useCurrentValueRef)(()=>{
        // This effect has race condition with Complete effect. We share the same check to ovid status overrides
        // do not update the card status if the status is final
        if ([
            'complete',
            'error',
            'failed-processing'
        ].includes(finalStatus)) return;
        if (previewDidRender && // We should't complete if status is uploading
        [
            'loading-preview',
            'processing'
        ].includes(finalStatus)) setStatus('complete');
        else if (fileState) {
            if (fileState.status !== 'error') {
                let newStatus;
                switch(fileState.status){
                    case 'uploading':
                    case 'failed-processing':
                    case 'processing':
                        newStatus = fileState.status;
                        break;
                    case 'processed':
                        // Set complete if processing is done and there is no preview
                        if (!preview && previewStatus === 'complete') {
                            newStatus = 'complete';
                            break;
                        }
                        newStatus = 'loading-preview';
                        break;
                    default:
                        newStatus = 'loading';
                }
                const newProgress = newStatus === 'uploading' && fileState.status === 'uploading' ? fileState.progress : 1;
                setStatus(newStatus);
                uploadProgressRef.current = newProgress;
            } else {
                const e = (0, $gFZHi.toCommonMediaClientError)(fileState);
                const errorReason = finalStatus === 'uploading' ? 'upload' : 'metadata-fetch';
                setError(new (0, $avBrk.MediaCardError)(errorReason, e));
                setStatus('error');
            }
        }
    });
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        setCardElement,
        copyNodeRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        updateFileStateRef.current();
    }, [
        fileState,
        preview,
        previewStatus,
        updateFileStateRef,
        previewDidRender,
        finalStatus
    ]);
    //----------------------------------------------------------------//
    // Shared Card View & SVG View resources
    //----------------------------------------------------------------//
    const mediaCardCursor = (0, $hOlel.getMediaCardCursor)(!!useInlinePlayer, !!shouldOpenMediaViewer, finalStatus === 'error' || finalStatus === 'failed-processing', !!preview, metadata.mediaType);
    const onImageMouseEnter = (event)=>{
        onMouseEnter?.({
            event: event,
            mediaItemDetails: metadata
        });
    };
    //----------------------------------------------------------------//
    //---------------------- Render Card Function --------------------//
    //----------------------------------------------------------------//
    const renderCard = (withCallbacks = true, cardStatusOverride, izLazyOverride)=>{
        const { mediaItemType: mediaItemType } = identifier;
        const isLazyWithOverride = izLazyOverride === undefined ? isLazy : izLazyOverride;
        // We should natively lazy load an SSR preview when card is not visible,
        // otherwise we'll fire the metadata fetch from outside the viewport
        // Side note: We should not lazy load if the cardPreview is available from local cache,
        // in order to avoid flickers during re-mount of the component
        // CXP-2723 TODO: Create test cases for the above scenarios
        const nativeLazyLoad = isLazyWithOverride && !isCardVisible && preview && (0, $apIKb.isSSRPreview)(preview);
        // Force Media Image to always display img for SSR
        const forceSyncDisplay = !!ssr;
        const card = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ajqQB.CardView), {
            identifier: identifier,
            status: cardStatusOverride || finalStatus,
            error: finalError,
            mediaItemType: mediaItemType,
            metadata: metadata,
            cardPreview: preview,
            alt: alt,
            resizeMode: resizeMode,
            dimensions: cardDimensions,
            actions: computedActions,
            selectable: selectable,
            selected: selected,
            shouldOpenMediaViewer: shouldOpenMediaViewer,
            openMediaViewerButtonRef: mediaViewerButtonRef,
            onClick: withCallbacks ? onCardViewClick : undefined,
            onMouseEnter: withCallbacks ? onImageMouseEnter : undefined,
            disableOverlay: disableOverlay,
            progress: uploadProgressRef.current,
            onDisplayImage: withCallbacks ? ()=>{
                const payloadPart = {
                    fileId: identifier.id,
                    isUserCollection: identifier.collectionName === (0, $7E56q.RECENTS_COLLECTION)
                };
                (0, $bfb59.globalMediaEventEmitter).emit('media-viewed', {
                    viewingLevel: 'minimal',
                    ...payloadPart
                });
            } : undefined,
            innerRef: mergedRef,
            testId: testId,
            titleBoxBgColor: titleBoxBgColor,
            titleBoxIcon: titleBoxIcon,
            onImageError: withCallbacks ? onImageError : undefined,
            onImageLoad: withCallbacks ? onImageLoad : undefined,
            onSvgError: onSvgError,
            onSvgLoad: onSvgLoad,
            nativeLazyLoad: nativeLazyLoad,
            forceSyncDisplay: forceSyncDisplay,
            mediaCardCursor: mediaCardCursor,
            shouldHideTooltip: shouldHideTooltip,
            overriddenCreationDate: overridenDate
        });
        return isLazyWithOverride ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hSY3r.ViewportDetector), {
            cardEl: cardElement,
            onVisible: ()=>{
                setIsCardVisible(true);
            },
            children: card
        }) : card;
    };
    //----------------------------------------------------------------//
    //-------------------------- RENDER ------------------------------//
    //----------------------------------------------------------------//
    const inlinePlayerFallback = isPlayingFile ? renderCard(false, 'loading', false) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {});
    const collectionName = identifier.collectionName || '';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            !!fileStateValue?.abuseClassification && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1k7cJ.AbuseModal), {
                isOpen: isAbuseModalOpen,
                onConfirm: downloadFn,
                onClose: ()=>setIsAbuseModalOpen(false)
            }),
            isPlayingFile ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
                fallback: inlinePlayerFallback,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6xnfM.InlinePlayerLazy), {
                    dimensions: cardDimensions,
                    originalDimensions: originalDimensions,
                    identifier: identifier,
                    autoplay: !!shouldAutoplay,
                    onFullscreenChange: onFullscreenChange,
                    onError: (e)=>{
                        setError(new (0, $avBrk.MediaCardError)('error-file-state', e));
                        setStatus('error');
                        setIsPlayingFile(false);
                    },
                    onClick: onCardClick,
                    selected: selected,
                    ref: setCardElement,
                    testId: testId,
                    cardPreview: preview,
                    videoControlsWrapperRef: videoControlsWrapperRef
                })
            }) : renderCard(),
            mediaViewerSelectedItem ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ZIFT.default), {
                collectionName: collectionName,
                items: mediaViewerItems || [],
                mediaClientConfig: mediaClient.config,
                selectedItem: mediaViewerSelectedItem,
                onClose: ()=>{
                    setMediaViewerSelectedItem(null);
                },
                contextId: contextId,
                featureFlags: featureFlags,
                viewerOptions: viewerOptions
            }) : null,
            getSsrScriptProps && /*#__PURE__*/ (0, $2OMIu.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};

});
parcelRegister("cUAFJ", function(module, exports) {

$parcel$export(module.exports, "imageResizeModeToFileImageMode", () => $8885fcf64c420485$export$dc1fb2767ac9a82f);
const $8885fcf64c420485$export$dc1fb2767ac9a82f = (resizeMode)=>resizeMode === 'stretchy-fit' ? 'full-fit' : resizeMode;

});

parcelRegister("1HkJZ", function(module, exports) {

$parcel$export(module.exports, "resolveCardPreviewDimensions", () => $0230b42a780845d1$export$f187979e6522f007);

var $lTKac = parcelRequire("lTKac");

var $i9jF7 = parcelRequire("i9jF7");

var $kwmmf = parcelRequire("kwmmf");

var $fTh39 = parcelRequire("fTh39");

var $ElPvE = parcelRequire("ElPvE");
const $0230b42a780845d1$export$726bc1818ebaed3b = (dimension, options)=>{
    const retinaFactor = (0, $lTKac.isRetina)() ? 2 : 1;
    const dimensionValue = options.dimensions && options.dimensions[dimension] || '';
    if ((0, $fTh39.isValidPercentageUnit)(dimensionValue) && options.element) return (0, $i9jF7.getElementDimension)(options.element, dimension) * retinaFactor;
    if (typeof dimensionValue === 'number') return dimensionValue * retinaFactor;
    if ((0, $ElPvE.containsPixelUnit)(`${dimensionValue}`)) return parseInt(`${dimensionValue}`, 10) * retinaFactor;
    return (0, $kwmmf.defaultImageCardDimensions)[dimension] * retinaFactor;
};
const $0230b42a780845d1$export$5b11506bddb36f50 = (options)=>{
    const width = $0230b42a780845d1$export$726bc1818ebaed3b('width', options);
    const height = $0230b42a780845d1$export$726bc1818ebaed3b('height', options);
    return {
        width: width,
        height: height
    };
};
const $0230b42a780845d1$export$a94e513ca3122718 = (dimensionName, { dimensions: dimensions, element: element })=>{
    const dimensionValue = dimensions?.[dimensionName] || '';
    if ((0, $fTh39.isValidPercentageUnit)(dimensionValue) && element) return (0, $i9jF7.getElementDimension)(element, dimensionName);
    if (typeof dimensionValue === 'number') return dimensionValue;
    if ((0, $ElPvE.containsPixelUnit)(`${dimensionValue}`)) return parseInt(`${dimensionValue}`, 10);
    return (0, $kwmmf.defaultImageCardDimensions)[dimensionName];
};
const $0230b42a780845d1$export$f187979e6522f007 = (options)=>{
    const width = $0230b42a780845d1$export$a94e513ca3122718('width', options);
    const height = $0230b42a780845d1$export$a94e513ca3122718('height', options);
    return {
        width: width,
        height: height
    };
};

});
parcelRegister("lTKac", function(module, exports) {

$parcel$export(module.exports, "isRetina", () => $86a18a8bfb64bc5e$export$2f19d859969045b7);
function $86a18a8bfb64bc5e$export$2f19d859969045b7() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}

});

parcelRegister("ElPvE", function(module, exports) {

$parcel$export(module.exports, "containsPixelUnit", () => $97d213fbdc74d1db$export$9dd9ef980c055cad);
const $97d213fbdc74d1db$export$9dd9ef980c055cad = (value)=>value.substr(-2) === 'px' && !isNaN(+value.slice(0, -2));

});


parcelRegister("cSJ4P", function(module, exports) {

$parcel$export(module.exports, "getFileDetails", () => $8e2ba52b73537d17$export$7e125c11d42de4d1);

var $1Pp1U = parcelRequire("1Pp1U");
var $7qjGu = parcelRequire("7qjGu");
const $8e2ba52b73537d17$var$getProcessingStatusFromFileState = (status)=>{
    switch(status){
        case 'processed':
            return 'succeeded';
        case 'processing':
            return 'running';
        case 'failed-processing':
            return 'failed';
    }
};
const $8e2ba52b73537d17$var$getFileDetailsFromFileState = (state)=>({
        id: state.id,
        name: state.name,
        size: state.size,
        mimeType: state.mimeType,
        createdAt: state.createdAt,
        mediaType: state.mediaType,
        processingStatus: $8e2ba52b73537d17$var$getProcessingStatusFromFileState(state.status)
    });
const $8e2ba52b73537d17$export$7e125c11d42de4d1 = (identifier, fileState)=>{
    return (0, $7qjGu.isFileIdentifier)(identifier) ? fileState && !(0, $1Pp1U.isErrorFileState)(fileState) ? $8e2ba52b73537d17$var$getFileDetailsFromFileState(fileState) : {
        id: identifier.id
    } : {
        id: identifier.mediaItemType,
        name: identifier.name || identifier.dataURI,
        mediaType: 'image'
    };
};

});

parcelRegister("hSY3r", function(module, exports) {

$parcel$export(module.exports, "ViewportDetector", () => $9fa785ecd7d1404c$export$35aa735df177ee7c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $4eKbI = parcelRequire("4eKbI");

var $ylBmJ = parcelRequire("ylBmJ");
const $9fa785ecd7d1404c$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP = 900; //px
const $9fa785ecd7d1404c$var$createIntersectionObserverCallback = (onVisible)=>(entries, observer)=>{
        for (let entry of entries)if (entry.isIntersecting) {
            onVisible();
            observer.disconnect();
            break;
        }
    };
const $9fa785ecd7d1404c$var$ViewportObserver = ({ onVisible: onVisible, cardEl: cardEl, children: children })=>{
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)(false);
    const onVisibleCallback = (0, $5uXOq.useCallback)(()=>{
        setIsVisible(true);
        onVisible();
    }, [
        onVisible
    ]);
    (0, $5uXOq.useEffect)(()=>{
        let intersectionObserver;
        try {
            intersectionObserver = new IntersectionObserver($9fa785ecd7d1404c$var$createIntersectionObserverCallback(onVisibleCallback), {
                root: (0, $ylBmJ.default)(),
                rootMargin: `${$9fa785ecd7d1404c$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP}px`
            });
        } catch (error) {
            intersectionObserver = new IntersectionObserver($9fa785ecd7d1404c$var$createIntersectionObserverCallback(onVisibleCallback), {
                root: null,
                rootMargin: `${$9fa785ecd7d1404c$var$ABS_VIEWPORT_ANCHOR_OFFSET_TOP}px`
            });
        }
        cardEl && intersectionObserver.observe(cardEl);
        return ()=>{
            intersectionObserver.disconnect();
        };
    }, [
        cardEl,
        onVisibleCallback
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4eKbI.default), {
        ignore: !isVisible,
        children: children
    });
};
const $9fa785ecd7d1404c$export$35aa735df177ee7c = ({ cardEl: cardEl, onVisible: onVisible, children: children })=>{
    if (typeof IntersectionObserver === 'undefined') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9fa785ecd7d1404c$var$ViewportObserver, {
        cardEl: cardEl,
        onVisible: onVisible,
        children: children
    });
};

});
parcelRegister("4eKbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd3e682addb0cb4a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6wxJn = parcelRequire("6wxJn");
function $fd3e682addb0cb4a$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const ignoredInteractionContext = (0, $5uXOq.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: kids
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6wxJn.default).Provider, {
        value: ignoredInteractionContext,
        children: kids
    });
}

});

parcelRegister("ylBmJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $250d911c3cf07a75$export$2e2bcd8739ae039);
var $250d911c3cf07a75$export$2e2bcd8739ae039 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("6xnfM", function(module, exports) {

$parcel$export(module.exports, "InlinePlayerLazy", () => $ffd1f9d847788d2e$export$c7e2887eae92d53c);

var $5uXOq = parcelRequire("5uXOq");

const $ffd1f9d847788d2e$export$c7e2887eae92d53c = /*#__PURE__*/ (0, $5uXOq.lazy)(async ()=>{
    const { InlinePlayer: InlinePlayer } = await (parcelRequire("78goZ"));
    return {
        default: InlinePlayer
    };
});

});
parcelRegister("78goZ", function(module, exports) {

let $531600e3246ba134$var$load = (parcelRequire("28QjX"))(4);
module.exports = $531600e3246ba134$var$load("5Pm6L").then(()=>parcelRequire('fxQ8I'));

});


parcelRegister("10b0h", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $baceb2843b357d39$export$4eaebdef02112fe4);

var $5uXOq = parcelRequire("5uXOq");

var $1Pp1U = parcelRequire("1Pp1U");
var $gFZHi = parcelRequire("gFZHi");

var $93kaw = parcelRequire("93kaw");
var $24tOd = parcelRequire("24tOd");
var $cEHh7 = parcelRequire("cEHh7");

var $8GKRF = parcelRequire("8GKRF");

var $kGpuq = parcelRequire("kGpuq");

var $01sWe = parcelRequire("01sWe");

var $3JWNV = parcelRequire("3JWNV");
var $4n1NZ = parcelRequire("4n1NZ");
var $7xRaJ = parcelRequire("7xRaJ");

var $3JZCV = parcelRequire("3JZCV");
var $jR4hE = parcelRequire("jR4hE");

var $8Kbwv = parcelRequire("8Kbwv");
const $baceb2843b357d39$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const [status, setStatus] = (0, $5uXOq.useState)('loading');
    const [error, setError] = (0, $5uXOq.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $5uXOq.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $5uXOq.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $5uXOq.useState)('not-resolved');
    const ssrReliabilityRef = (0, $5uXOq.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $5uXOq.useMemo)(()=>dimensions ? (0, $8Kbwv.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $8Kbwv.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $jR4hE.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $3JWNV.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $kGpuq.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $5uXOq.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $24tOd.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $1Pp1U.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $5uXOq.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('metadata-fetch', (0, $gFZHi.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $8Kbwv.useCurrentValueRef)(()=>{
        return (0, $3JWNV.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $5uXOq.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $8Kbwv.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $8Kbwv.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $5uXOq.useEffect)(()=>{
        const cachedPreview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $8Kbwv.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $4n1NZ.isSupportedLocalPreview)(mediaType) && (0, $8GKRF.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $3JWNV.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $8Kbwv.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $3JWNV.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $01sWe.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $5uXOq.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $3JWNV.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $3JWNV.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $3JWNV.isLocalPreview)(failedPreview);
        const isRemote = (0, $3JWNV.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $01sWe.ImageLoadError)(failedPreview?.source);
            (0, $7xRaJ.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $5uXOq.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $3JWNV.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $3JWNV.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $3JZCV.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $93kaw.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("93kaw", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $d123d92fa0d5c1a9$export$46fd859414de9d62);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $cEHh7 = parcelRequire("cEHh7");

var $7wsJE = parcelRequire("7wsJE");

var $eaxUQ = parcelRequire("eaxUQ");
function $d123d92fa0d5c1a9$var$useCurrentValueRef(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}
const $d123d92fa0d5c1a9$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $cEHh7.useMediaClient)();
    const innerRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const registerCopyIntentRef = $d123d92fa0d5c1a9$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $7wsJE.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $7wsJE.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $5uXOq.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $5uXOq.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) (0, $eaxUQ.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $eaxUQ.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("7wsJE", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $9a6af4835a9857e5$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $9a6af4835a9857e5$export$aacb463551da2e8f);

var $1As4I = parcelRequire("1As4I");
const $9a6af4835a9857e5$var$getRequestErrorDetails = (err)=>{
    if ((0, $1As4I.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $9a6af4835a9857e5$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $1As4I.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$9a6af4835a9857e5$var$getRequestErrorDetails(error)
        }
    };
};
const $9a6af4835a9857e5$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("eaxUQ", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $9ea95d3f3a6b1d04$export$f65ca476c09acec0);
const $9ea95d3f3a6b1d04$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("kGpuq", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $d93d75d54376e990$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $d93d75d54376e990$export$768c370ed0dbaeb3);

var $gFZHi = parcelRequire("gFZHi");

var $01sWe = parcelRequire("01sWe");
const $d93d75d54376e990$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $d93d75d54376e990$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $d93d75d54376e990$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $d93d75d54376e990$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $d93d75d54376e990$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $d93d75d54376e990$export$4af9d71992e89714(error),
        error: $d93d75d54376e990$export$88c61dcad53762da(error),
        errorDetail: $d93d75d54376e990$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $d93d75d54376e990$export$29aa614726672b2e(error)
    };
};
const $d93d75d54376e990$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$d93d75d54376e990$export$74aaf4784c2edb2c(new (0, $01sWe.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("01sWe", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $fcceba16863dd854$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $fcceba16863dd854$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $fcceba16863dd854$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $fcceba16863dd854$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $fcceba16863dd854$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $fcceba16863dd854$export$7156ce7b78b49bd7);
class $fcceba16863dd854$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $fcceba16863dd854$export$2c035820a31723e extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$10ab445310d30114 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$18e89b7e50818288 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $fcceba16863dd854$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $fcceba16863dd854$export$d0a45ab59b4606b extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(source){
        super($fcceba16863dd854$var$getImageLoadPrimaryReason(source));
    }
}
function $fcceba16863dd854$export$553696a6e769784c(err) {
    return err instanceof $fcceba16863dd854$export$96e559194c287cf4;
}
const $fcceba16863dd854$export$b380593ba3516c6f = (err)=>err instanceof $fcceba16863dd854$export$2c035820a31723e;
const $fcceba16863dd854$export$e1d87830b3784f94 = (err)=>err instanceof $fcceba16863dd854$export$10ab445310d30114;
const $fcceba16863dd854$export$443aeb298d35d79d = (err)=>$fcceba16863dd854$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $fcceba16863dd854$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($fcceba16863dd854$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("3JWNV", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $609060e8f7210c63$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $609060e8f7210c63$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $609060e8f7210c63$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $609060e8f7210c63$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $609060e8f7210c63$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $609060e8f7210c63$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $609060e8f7210c63$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $609060e8f7210c63$export$98e935d981c884d);

var $9KG2L = parcelRequire("9KG2L");

var $01sWe = parcelRequire("01sWe");

var $7xRaJ = parcelRequire("7xRaJ");

var $4n1NZ = parcelRequire("4n1NZ");
const $609060e8f7210c63$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $7xRaJ.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $609060e8f7210c63$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $01sWe.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $609060e8f7210c63$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $609060e8f7210c63$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $609060e8f7210c63$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $609060e8f7210c63$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $609060e8f7210c63$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $609060e8f7210c63$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $4n1NZ.getRemotePreview)(mediaClient, id, params, traceContext);
    return $609060e8f7210c63$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $609060e8f7210c63$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $4n1NZ.getLocalPreview)(filePreview);
    return $609060e8f7210c63$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("9KG2L", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $3193ea5c2295e37f$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $3193ea5c2295e37f$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $3193ea5c2295e37f$export$e51a8146182600b8);
const $3193ea5c2295e37f$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $3193ea5c2295e37f$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$3193ea5c2295e37f$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $3193ea5c2295e37f$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $3193ea5c2295e37f$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $3193ea5c2295e37f$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $3193ea5c2295e37f$var$getStringFromParams(params, 'collection'),
        alt: $3193ea5c2295e37f$var$getStringFromParams(params, 'alt'),
        height: $3193ea5c2295e37f$var$getNumberFromParams(params, 'height'),
        width: $3193ea5c2295e37f$var$getNumberFromParams(params, 'width'),
        size: $3193ea5c2295e37f$var$getNumberFromParams(params, 'size'),
        name: $3193ea5c2295e37f$var$getStringFromParams(params, 'name'),
        mimeType: $3193ea5c2295e37f$var$getStringFromParams(params, 'mimeType')
    };
};
const $3193ea5c2295e37f$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $3193ea5c2295e37f$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$3193ea5c2295e37f$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $3193ea5c2295e37f$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("7xRaJ", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $abbc266dbfedc514$export$b7e8ee3f7a41459);

var $aAIop = parcelRequire("aAIop");
const $abbc266dbfedc514$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $abbc266dbfedc514$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $abbc266dbfedc514$export$b7e8ee3f7a41459 = new $abbc266dbfedc514$export$7b50526c091bb915((0, $aAIop.createObjectURLCache)());

});
parcelRegister("aAIop", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $0cfc22aea6c15367$export$ba71be67d5c32535);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $0cfc22aea6c15367$export$36d0f9859761643d = 50;
class $0cfc22aea6c15367$var$ExtendedLRUCache extends (0, $iwKVT.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $0cfc22aea6c15367$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $0cfc22aea6c15367$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $0cfc22aea6c15367$export$ba71be67d5c32535 = ()=>new $0cfc22aea6c15367$export$75d1c8c9ba1d0773($0cfc22aea6c15367$export$36d0f9859761643d);

});


parcelRegister("4n1NZ", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3b75ec6170865ae7$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3b75ec6170865ae7$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3b75ec6170865ae7$export$bfe20bd01db02b3);

var $jzW7G = parcelRequire("jzW7G");

var $48aIR = parcelRequire("48aIR");

var $01sWe = parcelRequire("01sWe");

var $Nl5sY = parcelRequire("Nl5sY");
const $3b75ec6170865ae7$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3b75ec6170865ae7$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $48aIR.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $Nl5sY.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $jzW7G.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3b75ec6170865ae7$var$getImageLocalPreview(value);
            case 'video':
                return $3b75ec6170865ae7$var$getVideoLocalPreview(value);
            default:
                throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
};
const $3b75ec6170865ae7$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $01sWe.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("48aIR", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $93f6c931eebc2be3$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $93f6c931eebc2be3$export$67689507e8404821);

var $k9Ch0 = parcelRequire("k9Ch0");

var $5m9mt = parcelRequire("5m9mt");

var $1xbJn = parcelRequire("1xbJn");

var $hNjKA = parcelRequire("hNjKA");
const { Orientation: $93f6c931eebc2be3$var$Orientation, XResolution: $93f6c931eebc2be3$var$XResolution } = (0, $k9Ch0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $93f6c931eebc2be3$var$DPI_WEB_BASELINE = 72;
async function $93f6c931eebc2be3$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $93f6c931eebc2be3$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $93f6c931eebc2be3$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $93f6c931eebc2be3$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
        else return $93f6c931eebc2be3$export$268f92356524130b(tags, $93f6c931eebc2be3$var$XResolution, $93f6c931eebc2be3$var$DPI_WEB_BASELINE) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $93f6c931eebc2be3$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$93f6c931eebc2be3$var$Orientation]) {
        const tagValue = tags[$93f6c931eebc2be3$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $k9Ch0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $93f6c931eebc2be3$export$67689507e8404821(file) {
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    return $93f6c931eebc2be3$var$getOrientationFromTags(tags);
}
function $93f6c931eebc2be3$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $93f6c931eebc2be3$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $1xbJn.loadImage)(src);
        const { width: width, height: height } = (0, $1xbJn.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("k9Ch0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $8ba626f637ae3df3$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $8ba626f637ae3df3$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $8ba626f637ae3df3$export$f6ea0c89fd7d156);
var $8ba626f637ae3df3$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $8ba626f637ae3df3$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $8ba626f637ae3df3$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("5m9mt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $6da5c9a89db4de84$export$41982b5c7acb23c4);

var $k9Ch0 = parcelRequire("k9Ch0");

var $jkveD = parcelRequire("jkveD");

var $kINoG = parcelRequire("kINoG");

var $2edT6 = parcelRequire("2edT6");
async function $6da5c9a89db4de84$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $k9Ch0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $kINoG.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $2edT6.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $k9Ch0.ImageType).JPEG) return await (0, $jkveD.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("jkveD", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $537aa8dc852a8555$export$556b2ccec62d7f2a);

var $k9Ch0 = parcelRequire("k9Ch0");
const { XResolution: $537aa8dc852a8555$var$XResolution, YResolution: $537aa8dc852a8555$var$YResolution } = (0, $k9Ch0.SupportedImageMetaTag);
let $537aa8dc852a8555$var$loadImage;

function $537aa8dc852a8555$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$537aa8dc852a8555$var$loadImage) {
            const module = await (parcelRequire("iErjn"));
            $537aa8dc852a8555$var$loadImage = module.default || module;
        }
        $537aa8dc852a8555$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $537aa8dc852a8555$var$XResolution || key === $537aa8dc852a8555$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("iErjn", function(module, exports) {

let $d94125e60802a764$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d94125e60802a764$var$load("i57oW").then(()=>parcelRequire('8aLn9'));

});


parcelRegister("kINoG", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $013315ab2d0cc3cf$export$5fb37736440fca6f);

var $1xbJn = parcelRequire("1xbJn");
let $013315ab2d0cc3cf$var$pngChunksExtract;

async function $013315ab2d0cc3cf$export$5fb37736440fca6f(file) {
    if (!$013315ab2d0cc3cf$var$pngChunksExtract) {
        const module = await (parcelRequire("jegge"));
        $013315ab2d0cc3cf$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $1xbJn.fileToArrayBuffer)(file);
    const chunks = $013315ab2d0cc3cf$var$pngChunksExtract(buffer);
    return await $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks);
}
async function $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("jegge", function(module, exports) {

let $dffbf02b1eb2951b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dffbf02b1eb2951b$var$load("4tH5n").then(()=>parcelRequire('eYIux'));

});


parcelRegister("2edT6", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $1cac606283e05089$export$55c3bc9841b19de2);
function $1cac606283e05089$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});



parcelRegister("Nl5sY", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $33ec34d1173165de$export$4269d30173168e5c);
const $33ec34d1173165de$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("3JZCV", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $293d53ca8ea6912a$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $293d53ca8ea6912a$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $293d53ca8ea6912a$export$de7c49925e44d75d);

var $1QRxp = parcelRequire("1QRxp");
const $293d53ca8ea6912a$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $293d53ca8ea6912a$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $293d53ca8ea6912a$var$dashed = (param)=>param ? `-${param}` : '';
const $293d53ca8ea6912a$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$293d53ca8ea6912a$var$dashed(collectionName)}${$293d53ca8ea6912a$var$dashed(occurrenceKey)}`;
const $293d53ca8ea6912a$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $293d53ca8ea6912a$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $1QRxp.printFunctionCall)($293d53ca8ea6912a$export$4310981e0aa4ce67, $293d53ca8ea6912a$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $1QRxp.printScript)([
        $293d53ca8ea6912a$export$ede93d4564eaa8da.toString(),
        $293d53ca8ea6912a$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $293d53ca8ea6912a$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $293d53ca8ea6912a$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("1QRxp", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $56ce1649d25a132b$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $56ce1649d25a132b$export$8b902fb69a2f17c1);

var $VSDnB = parcelRequire("VSDnB");
const $56ce1649d25a132b$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $56ce1649d25a132b$var$printParams = (args)=>args.map((arg)=>$56ce1649d25a132b$var$printParam(arg)).join(',');
const $56ce1649d25a132b$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$56ce1649d25a132b$var$printParams(args)});`;
const $56ce1649d25a132b$export$8b902fb69a2f17c1 = (statements)=>(0, $VSDnB.fg)('platform_remove_media_script_after_execution') ? `(function(){
 			 ${statements.join(';')}
  			document.currentScript.remove();
		})();
		` : `(function(){
   			${statements.join(';')}
 		})();`;

});


parcelRegister("jR4hE", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $815e3e27cebcb154$export$d3a890b0f7844b6f);

var $3JZCV = parcelRequire("3JZCV");
const $815e3e27cebcb154$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $3JZCV.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $3JZCV.getKey)(identifier)];
};

});

parcelRegister("8Kbwv", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $7b6d905fc3b6f0e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $7b6d905fc3b6f0e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db);

var $5uXOq = parcelRequire("5uXOq");
const $7b6d905fc3b6f0e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $7b6d905fc3b6f0e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $7b6d905fc3b6f0e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $7b6d905fc3b6f0e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}

});


parcelRegister("hn1fT", function(module, exports) {

$parcel$export(module.exports, "createDownloadAction", () => $2af08dc982f589f3$export$948607b7587fecda);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $d4dv2 = parcelRequire("d4dv2");

var $fUEF9 = parcelRequire("fUEF9");
function $2af08dc982f589f3$export$1390767202e8e51e(actions, details) {
    return actions.map((action)=>({
            ...action,
            handler: ()=>{
                action.handler({
                    type: 'file',
                    details: details
                });
            }
        }));
}
const $2af08dc982f589f3$export$948607b7587fecda = (baseAction, formatMessage)=>{
    const { isDisabled: isDisabled } = baseAction;
    const label = isDisabled ? 'Download Disabled' : 'Download';
    const tooltip = isDisabled ? formatMessage((0, $fUEF9.messages).download_disabled_security_policy) : undefined;
    return {
        ...baseAction,
        label: label,
        tooltip: tooltip,
        icon: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d4dv2))), {
            color: isDisabled ? "var(--ds-icon-disabled, #091E424F)" : 'currentColor',
            spacing: "spacious",
            label: "Download"
        })
    };
};

});
parcelRegister("d4dv2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::647640fe09afef5813e2888b2ce1f074>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98361ed174bfbb2b$var$_react = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $98361ed174bfbb2b$var$_download = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("EOGIN")));

var $98361ed174bfbb2b$var$_download2 = $98361ed174bfbb2b$var$_interopRequireDefault((parcelRequire("5krT5")));
function $98361ed174bfbb2b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DownloadIcon.
 * This component is DownloadIcon, with `UNSAFE_fallbackIcon` set to "DownloadIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $98361ed174bfbb2b$var$DownloadIcon = (props)=>/*#__PURE__*/ $98361ed174bfbb2b$var$_react.default.createElement($98361ed174bfbb2b$var$_download.default, Object.assign({
        LEGACY_fallbackIcon: $98361ed174bfbb2b$var$_download2.default
    }, props));
$98361ed174bfbb2b$var$DownloadIcon.Name = 'DownloadIconMigration';
var $98361ed174bfbb2b$var$_default = module.exports.default = $98361ed174bfbb2b$var$DownloadIcon;

});
parcelRegister("EOGIN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3903aba4213e0f68da56229d9d15d40>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07ab0e2228a1635e$var$_react = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $07ab0e2228a1635e$var$_baseNew = $07ab0e2228a1635e$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $07ab0e2228a1635e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Download".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for file downloads.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07ab0e2228a1635e$var$DownloadIcon = (props)=>/*#__PURE__*/ $07ab0e2228a1635e$var$_react.default.createElement($07ab0e2228a1635e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v7.44l2.72-2.72 1.06 1.06-4 4a.75.75 0 0 1-1.06 0l-4-4 1.06-1.06 2.72 2.72V1zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$07ab0e2228a1635e$var$DownloadIcon.displayName = 'DownloadIcon';
var $07ab0e2228a1635e$var$_default = module.exports.default = $07ab0e2228a1635e$var$DownloadIcon;

});

parcelRegister("5krT5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e1473e49ea22b68$var$_react = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3e1473e49ea22b68$var$_download = $3e1473e49ea22b68$var$_interopRequireDefault((parcelRequire("EOGIN")));
function $3e1473e49ea22b68$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3e1473e49ea22b68$var$DownloadIcon = (props)=>/*#__PURE__*/ $3e1473e49ea22b68$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M10.687 17.292a.983.983 0 0 0-1.397 0 1 1 0 0 0 0 1.407l1.964 1.98a1.08 1.08 0 0 0 1.538 0l1.919-1.933a1 1 0 0 0 0-1.408.983.983 0 0 0-1.398 0l-1.29 1.3z"/><path fill-rule="nonzero" d="M13.001 19.993 13 10.006C13 9.451 12.552 9 12 9s-1 .45-1 1.007l.001 9.987c0 .555.448 1.006 1 1.006s1-.45 1-1.007"/><path d="M7.938 5.48a5 5 0 0 0-.777-.062C4.356 5.418 2 7.62 2 10.498 2 13.409 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.05.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.12a4.14 4.14 0 0 1 4.069 3.645l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-2-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.02-3.901.9-5.038 2.48"/></g></svg>`
    }, props, {
        newIcon: $3e1473e49ea22b68$var$_download.default
    }));
$3e1473e49ea22b68$var$DownloadIcon.displayName = 'DownloadIcon';
var $3e1473e49ea22b68$var$_default = module.exports.default = $3e1473e49ea22b68$var$DownloadIcon;

});



parcelRegister("4qUCy", function(module, exports) {

$parcel$export(module.exports, "DateOverrideContext", () => $18c9d4b0da4fa4bb$export$5bc85d7cf4a39f3e);

var $5uXOq = parcelRequire("5uXOq");
const $18c9d4b0da4fa4bb$export$5bc85d7cf4a39f3e = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});

parcelRegister("1k7cJ", function(module, exports) {

$parcel$export(module.exports, "AbuseModal", () => $74f8f4c75854389a$export$9b832d04bd876d78);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $84THj = parcelRequire("84THj");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $kgoHi = parcelRequire("kgoHi");
var $bgrar = parcelRequire("bgrar");
var $8CUq3 = parcelRequire("8CUq3");

var $fUEF9 = parcelRequire("fUEF9");
const $74f8f4c75854389a$var$gridStyles = (0, $8CUq3.xcss)({
    width: '100%'
});
const $74f8f4c75854389a$var$closeContainerStyles = (0, $8CUq3.xcss)({
    gridArea: 'close'
});
const $74f8f4c75854389a$var$titleContainerStyles = (0, $8CUq3.xcss)({
    gridArea: 'title'
});
const $74f8f4c75854389a$export$9b832d04bd876d78 = (0, $8RXs9.default)(({ isOpen: isOpen, onConfirm: onConfirm, onClose: onClose, intl: { formatMessage: formatMessage } })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
        children: isOpen && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $1R1Ge.default), {
            onClose: onClose,
            testId: "mediaAbuseModal",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bgrar.default), {
                        gap: "space.200",
                        templateAreas: [
                            'title close'
                        ],
                        xcss: $74f8f4c75854389a$var$gridStyles,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kgoHi.default), {
                                xcss: $74f8f4c75854389a$var$closeContainerStyles,
                                justifyContent: "end",
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                                    appearance: "subtle",
                                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($84THj))),
                                    label: "Close Modal",
                                    onClick: onClose
                                })
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kgoHi.default), {
                                xcss: $74f8f4c75854389a$var$titleContainerStyles,
                                justifyContent: "start",
                                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                                    appearance: "warning",
                                    children: formatMessage((0, $fUEF9.messages).abuse_modal_title)
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7QSqG.default), {
                    children: formatMessage((0, $fUEF9.messages).abuse_modal_body)
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                            appearance: "subtle",
                            onClick: onClose,
                            children: formatMessage((0, $fUEF9.messages).cancel)
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                            appearance: "warning",
                            onClick: onConfirm,
                            children: formatMessage((0, $fUEF9.messages).abuse_modal_submit)
                        })
                    ]
                })
            ]
        })
    });
});

});


parcelRegister("2ucn9", function(module, exports) {

$parcel$export(module.exports, "setAnalyticsContext", () => $6db3927cfa9b9373$export$70c58d75bd83664);
$parcel$export(module.exports, "startResourceObserver", () => $6db3927cfa9b9373$export$8840d7cbe19419a0);


var $VSDnB = parcelRequire("VSDnB");

var $g7fAZ = parcelRequire("g7fAZ");

var $32HY8 = parcelRequire("32HY8");
const $6db3927cfa9b9373$var$MEDIA_CARD_PERF_STATE_KEY = '__mediaCardPerfState_asflkajsdflja';
const $6db3927cfa9b9373$var$urlRegex = /https:\/\/(?:media\.(?:dev|staging|prod)\.atl-paas\.net|api\.media\.atlassian\.com|media-cdn(?:\.stg\.|\.)atlassian\.com)\/file\/([^/]+)\/image.*[?&]source=mediaCard/;
const $6db3927cfa9b9373$var$clientIdParamRegex = /[?&]clientId=([^&]+)/;
const $6db3927cfa9b9373$var$ssrParamRegex = /[?&]token=([^&]+)/;
const $6db3927cfa9b9373$var$createAndGetResourceObserver = ()=>{
    return new PerformanceObserver((list)=>{
        list.getEntries().forEach((baseEntry)=>{
            const entry = baseEntry;
            const matchFileId = entry.name.match($6db3927cfa9b9373$var$urlRegex);
            const matchClientId = entry.name.match($6db3927cfa9b9373$var$clientIdParamRegex);
            const matchSSR = entry.name.match($6db3927cfa9b9373$var$ssrParamRegex);
            if (matchFileId && window[$6db3927cfa9b9373$var$MEDIA_CARD_PERF_STATE_KEY]?.mediaCardCreateAnalyticsEvent) {
                const fileId = matchFileId[1];
                const clientId = matchClientId?.[1];
                const ssr = matchSSR ? 'server' : undefined;
                const navigationTime = performance.getEntriesByType('navigation')[0];
                const mediaDurationMetrics = (0, $g7fAZ.createMediaDurationMetrics)(entry, navigationTime);
                const event = window[$6db3927cfa9b9373$var$MEDIA_CARD_PERF_STATE_KEY].mediaCardCreateAnalyticsEvent({
                    eventType: 'operational',
                    action: 'succeeded',
                    actionSubject: 'mediaCardPerfObserver',
                    attributes: {
                        ssr: ssr,
                        fileId: fileId,
                        mediaClientId: clientId,
                        featureFlags: {
                            'media-cdn-single-host': (0, $VSDnB.fg)('platform_media_cdn_single_host')
                        },
                        ...mediaDurationMetrics
                    }
                });
                event.fire((0, $6409754536c5152d$export$ec1779cb96554e1));
                if ((0, $VSDnB.fg)('platform_media_card_ufo_network_metrics')) {
                    const ufoDurationMetrics = (0, $g7fAZ.createUfoDurationMetrics)(entry, navigationTime);
                    const endpointName = 'image';
                    (0, $32HY8.sendUfoDurationMetrics)(ufoDurationMetrics, endpointName);
                }
            }
        });
    });
};
const $6db3927cfa9b9373$export$70c58d75bd83664 = (newAnalyticsContext)=>{
    if (!window[$6db3927cfa9b9373$var$MEDIA_CARD_PERF_STATE_KEY]) window[$6db3927cfa9b9373$var$MEDIA_CARD_PERF_STATE_KEY] = {};
    window[$6db3927cfa9b9373$var$MEDIA_CARD_PERF_STATE_KEY].mediaCardCreateAnalyticsEvent = newAnalyticsContext;
};
const $6db3927cfa9b9373$var$isDefinedPerformanceObserver = ()=>typeof window['PerformanceObserver'] !== 'undefined';
const $6db3927cfa9b9373$export$8840d7cbe19419a0 = ()=>{
    if (!$6db3927cfa9b9373$var$isDefinedPerformanceObserver()) return;
    if (window[$6db3927cfa9b9373$var$MEDIA_CARD_PERF_STATE_KEY]?.mediaCardPerfObserver) return;
    if (!window[$6db3927cfa9b9373$var$MEDIA_CARD_PERF_STATE_KEY]) window[$6db3927cfa9b9373$var$MEDIA_CARD_PERF_STATE_KEY] = {};
    window[$6db3927cfa9b9373$var$MEDIA_CARD_PERF_STATE_KEY].mediaCardPerfObserver = $6db3927cfa9b9373$var$createAndGetResourceObserver();
    window[$6db3927cfa9b9373$var$MEDIA_CARD_PERF_STATE_KEY].mediaCardPerfObserver.observe({
        type: 'resource',
        buffered: true
    });
};

});
parcelRegister("g7fAZ", function(module, exports) {

$parcel$export(module.exports, "createMediaDurationMetrics", () => $3b1962a999b7a353$export$b22670df0917866e);
$parcel$export(module.exports, "createUfoDurationMetrics", () => $3b1962a999b7a353$export$45a6f341f1a26a5d);
const $3b1962a999b7a353$var$getStartedAt = (entry, navigationTime)=>entry.startTime - (navigationTime?.domContentLoadedEventEnd || 0);
const $3b1962a999b7a353$var$getCommonMetrics = (entry)=>({
        tcpHandshakeTime: {
            end: entry.connectEnd,
            start: entry.connectStart
        },
        dnsLookupTime: {
            end: entry.domainLookupEnd,
            start: entry.domainLookupStart
        },
        redirectTimeTaken: {
            end: entry.redirectEnd,
            start: entry.redirectStart
        },
        tlsConnectNegotiationTime: {
            end: entry.requestStart,
            start: entry.secureConnectionStart
        },
        timeTakenToFetchWithoutRedirect: {
            end: entry.responseEnd,
            start: entry.fetchStart
        },
        /**
	 * `interimRequestTime` represents the entire time the browser took to
	 * request the resource from the server. This includes the interim response time
	 * (for example, 100 Continue or 103 Early Hints).
	 *
	 * i.e. It is the time taken for the request to be sent
	 * + the waiting time for the server to send a response
	 *
	 * Please, note that this value
	 * is distinctly different from the aforementioned document.
	 */ interimRequestTime: {
            end: entry.responseStart,
            start: entry.requestStart
        },
        /**
	 * `requestInvocationTime` represents the actual time the browser took to request
	 * the resource from the server (i.e. it does not include the interim reponse
	 * time).
	 * NOTE: it relies on an experimental feature (`firstInterimResponseStart`) that is
	 * available in Chrome, but not in FireFox or Safari. This value will be undefined
	 * when `firstInterimResponseStart` is unavailable.
	 */ requestInvocationTime: entry.firstInterimResponseStart ? {
            end: entry.firstInterimResponseStart,
            start: entry.requestStart
        } : undefined,
        /**
	 * `contentDownloadTime` represents the time taken for the browser to receive
	 * the resource from the server. This may be cut short if the transport
	 * connection is closed.
	 */ contentDownloadTime: {
            end: entry.responseEnd,
            start: entry.responseStart
        }
    });
const $3b1962a999b7a353$var$calculateCommonDurations = (metrics)=>Object.fromEntries(Object.entries(metrics).map(([key, marks])=>{
        if (!marks) return [
            key,
            undefined
        ];
        const { start: start, end: end } = marks;
        return [
            key,
            end - start
        ];
    }));
const $3b1962a999b7a353$export$b22670df0917866e = (entry, navigationTime)=>{
    return {
        startedAt: $3b1962a999b7a353$var$getStartedAt(entry, navigationTime),
        /**
		 * Performance resource timing data regarding the loading of an
		 * application's resources as described in
		 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming
		 */ transferSize: entry.transferSize,
        decodedBodySize: entry.decodedBodySize,
        totalDuration: entry.duration,
        initiatorType: entry.initiatorType,
        responseEnd: entry.responseEnd,
        browserCacheHit: entry.transferSize === 0,
        nextHopProtocol: entry.nextHopProtocol,
        ...$3b1962a999b7a353$var$calculateCommonDurations($3b1962a999b7a353$var$getCommonMetrics(entry)),
        /**
		 * The user agent string for the current browser
		 * Read more: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/userAgent
		 */ userAgent: window.navigator.userAgent,
        /**
		 * Performance resource timing data sent by the server. This includes:
		 *
		 * `cdnCacheHit` is a boolean determining whether the CDN cache was hit or missed.
		 *
		 * `cdnDownstreamFBL` is the 'CDN Downstream First Byte Latency'. It represents
		 * how long the it took the CDN to respond to the frontend.
		 *
		 * `cdnUpstreamFBL` is the 'CDN Upstream First Byte Latency'. It represents the
		 * time the Media backend took to respond to the CDN, in the case that the CDN
		 * cache was a miss. Notably, this timing is a subset of the `cdnDownstreamFBL` timing.
		 */ cdnCacheHit: entry.serverTiming.find(({ name: name })=>{
            return name === 'cdn-cache-hit';
        }) ? true : false,
        cdnDownstreamFBL: entry.serverTiming.find(({ name: name })=>{
            return name === 'cdn-downstream-fbl';
        })?.duration,
        cdnUpstreamFBL: entry.serverTiming.find(({ name: name })=>{
            return name === 'cdn-upstream-fbl';
        })?.duration
    };
};
const $3b1962a999b7a353$var$filterCommonMetrics = (metrics)=>Object.fromEntries(Object.entries(metrics).filter(([, marks])=>!!marks));
const $3b1962a999b7a353$export$45a6f341f1a26a5d = (entry, navigationTime)=>{
    return {
        resourceTiming: {
            start: $3b1962a999b7a353$var$getStartedAt(entry, navigationTime),
            end: entry.responseEnd
        },
        ...$3b1962a999b7a353$var$filterCommonMetrics($3b1962a999b7a353$var$getCommonMetrics(entry))
    };
};

});

parcelRegister("32HY8", function(module, exports) {

$parcel$export(module.exports, "sendUfoDurationMetrics", () => $14739ac363c56c1b$export$be8beb5937d1436e);

var $bFU4G = parcelRequire("bFU4G");
const $14739ac363c56c1b$var$mediaLabelStack = [
    {
        name: 'media'
    }
];
const $14739ac363c56c1b$export$be8beb5937d1436e = (ufoDurationMetrics, endpoint)=>{
    const labelStack = [
        ...$14739ac363c56c1b$var$mediaLabelStack,
        {
            name: endpoint
        }
    ];
    Object.entries(ufoDurationMetrics).map(([name, { start: start, end: end, size: size }])=>{
        (0, $bFU4G.addCustomSpans)(name, start, end, size, labelStack);
    });
};

});


parcelRegister("3aXpE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa69217d65efc8ae$export$2e2bcd8739ae039);

var $jnjS3 = parcelRequire("jnjS3");
var $fa69217d65efc8ae$export$2e2bcd8739ae039 = (0, $jnjS3.default);

});
parcelRegister("jnjS3", function(module, exports) {

$parcel$export(module.exports, "default", () => $095a4d1378115b65$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");
function $095a4d1378115b65$export$2e2bcd8739ae039({ name: name, children: children }) {
    const context = (0, $1tcYS.useInteractionContext)();
    const newContext = (0, $5uXOq.useMemo)(()=>{
        if (context) return {
            ...context,
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [
                ...context.labelStack,
                {
                    name: name
                }
            ]
        };
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1tcYS.default).Provider, {
        value: newContext,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
}

});





//# sourceMappingURL=@atlaskit-internal_media-card-with-media-client.1b8771b7.js.map
